export const toolsData = [
  {
    id: 1000,
    name: "Sylva Identity Discovery",
    description: "An OSINT identity discovery tool to track and connect digital footprints across usernames, emails, and online profiles.",
    link: "https://sylva.pfeister.dev/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1001,
    name: "Sherlock",
    description: "A powerful username OSINT tool that finds accounts across hundreds of social media platforms using a single username.",
    link: "https://github.com/sherlock-project/sherlock",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1002,
    name: "WhatsMyName",
    description: "A fast username enumeration platform used in OSINT investigations to identify where a username exists online.",
    link: "https://whatsmyname.app/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1003,
    name: "Namechk",
    description: "Check username availability across major websites and social media platforms to track online identity usage.",
    link: "https://namechk.com/",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1004,
    name: "UserSearch.org",
    description: "An OSINT username search engine that helps you identify profile traces across multiple social networks and websites.",
    link: "https://usersearch.org/",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1005,
    name: "WhatsMyName (GitHub)",
    description: "Open-source OSINT username search tool with a large database of websites to quickly locate online accounts.",
    link: "https://github.com/WebBreacher/WhatsMyName",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1006,
    name: "WhatsMyName",
    description: "An OSINT search platform to quickly detect usernames across different websites and services.",
    link: "https://whatsmyname.app/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1007,
    name: "Thats Them",
    description: "People search tool used for OSINT that can help match usernames, emails and personal details for investigation.",
    link: "https://thatsthem.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1008,
    name: "NameCheckup",
    description: "A username & domain checker that helps investigators verify digital identity availability across platforms.",
    link: "https://namecheckup.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1009,
    name: "Instant Username Search",
    description: "A quick username lookup engine to search online platforms and reveal possible accounts linked to a username.",
    link: "https://instantusername.com/",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1010,
    name: "IDCrawl Username Search",
    description: "Search usernames across social networks and websites to discover profiles and connected public identity traces.",
    link: "https://www.idcrawl.com/username",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1011,
    name: "Names Directory",
    description: "Directory-based OSINT tool for searching identity traces that can help locate people and linked online profiles.",
    link: "https://namesdir.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1012,
    name: "Amazon Usernames (M)",
    description: "Google dork to search Amazon pages for a specific username, useful in platform-specific OSINT investigations.",
    link: "https://www.google.com/search?q=site:amazon.com+%3Cusername%3E",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1013,
    name: "Github User (M)",
    description: "Fetch public GitHub events data for a username to identify coding activity, repos, and open-source footprint.",
    link: "https://api.github.com/users/%3Cusername%3E/events/public",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1014,
    name: "Tinder Usernames (M)",
    description: "Manual OSINT method to check Tinder profile URLs for a username and identify possible user presence.",
    link: "https://www.gotinder.com/@%3Cusername%3E",
    category: "Username",
    icon: "👤"
  },
  {
    id: 1015,
    name: "Keybase",
    description: "A public identity and crypto-proof platform useful for OSINT to connect usernames with verified accounts.",
    link: "https://keybase.io/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1016,
    name: "MIT PGP Key Server",
    description: "Search public PGP keys to identify email-owner associations and digital identity verification signals.",
    link: "http://pgp.mit.edu/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1017,
    name: "Sylva Identity Discovery",
    description: "A digital footprint OSINT tool to discover identities using email, usernames, and online profile mapping.",
    link: "https://sylva.pfeister.dev/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1018,
    name: "ThatsThem (Reverse Email)",
    description: "Reverse email lookup OSINT tool used to identify possible name, phone, and public records linked to an email.",
    link: "https://thatsthem.com/reverse-email-lookup",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1019,
    name: "Hunter",
    description: "Professional email finding tool to discover company emails and verify business email patterns for OSINT research.",
    link: "https://hunter.io/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1020,
    name: "Email to Address (R)",
    description: "Reverse lookup service to identify location/address-related details linked with email records (restricted tool).",
    link: "http://www.melissadata.com/lookups/emails.asp",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1021,
    name: "VoilaNorbert",
    description: "Email discovery tool to find professional emails using name and company details, useful for business OSINT.",
    link: "https://www.voilanorbert.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1022,
    name: "GHunt",
    description: "Advanced Google OSINT tool that helps investigate Gmail accounts and Google-linked public footprint data.",
    link: "https://github.com/mxrch/GHunt",
    category: "Google",
    icon: "🔍"
  },
  {
    id: 1023,
    name: "OSINT Industries",
    description: "Premium OSINT platform to search emails, usernames, and phone data to uncover public identity connections.",
    link: "https://osint.industries/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1024,
    name: "theHarvester",
    description: "Famous OSINT reconnaissance tool to gather emails, subdomains, and public data from search engines and sources.",
    link: "https://github.com/laramies/theHarvester",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1025,
    name: "Infoga",
    description: "Email OSINT gathering tool used to collect information about email targets and related public footprint.",
    link: "https://github.com/m4ll0k/infoga",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1026,
    name: "Skymem",
    description: "Search email traces indexed publicly to discover linked accounts, posts, and possible email exposures.",
    link: "http://www.skymem.info/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1027,
    name: "Epieos",
    description: "OSINT investigation platform to search emails, phone numbers, and accounts to reveal connected digital identities.",
    link: "https://epieos.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1028,
    name: "Email Format",
    description: "Check common corporate email formats to predict and verify company email patterns during investigations.",
    link: "https://www.email-format.com/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1029,
    name: "Email Permutator",
    description: "Generate possible email combinations from names and domains for email discovery in OSINT and recon work.",
    link: "http://metricsparrow.com/toolkit/email-permutator/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1030,
    name: "OneLook Reverse Dictionary & Thesaurus",
    description: "A smart word discovery tool helpful in OSINT for finding username ideas, aliases, and keyword variations.",
    link: "http://www.onelook.com/reverse-dictionary.shtml",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1031,
    name: "Reacher GitHub",
    description: "Open-source email verification system that checks whether an email exists without sending messages.",
    link: "https://github.com/reacherhq/check-if-email-exists",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1032,
    name: "Reacher Demo",
    description: "Email validation demo tool to verify deliverability and reduce fake/invalid emails in investigations.",
    link: "https://reacher.email",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1033,
    name: "MailScrap",
    description: "Email extraction tool that scrapes websites for publicly listed email addresses for OSINT and recon.",
    link: "https://mailscrap.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1034,
    name: "Read Notify",
    description: "Email tracking service used to detect delivery and open activity (use only with authorization).",
    link: "http://www.readnotify.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1035,
    name: "Email Reputation",
    description: "Check email reputation to detect suspicious or breached emails commonly used in cybercrime activity.",
    link: "https://emailrep.io/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1036,
    name: "MailboxValidator",
    description: "Email verification tool to validate if an email address is real, active, and properly configured.",
    link: "https://www.mailboxvalidator.com/demo",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1037,
    name: "Have I been pwned?",
    description: "Check if an email has appeared in public data breaches — one of the best tools for breach awareness.",
    link: "https://haveibeenpwned.com/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1038,
    name: "Hudson Rock",
    description: "Threat intelligence resource to check leaked credentials and infection exposure from cybercrime sources.",
    link: "https://www.hudsonrock.com/threat-intelligence-cybercrime-tools",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1039,
    name: "DeHashed (R)",
    description: "Premium breach intelligence platform to search leaked credentials, emails, usernames, and related records.",
    link: "https://dehashed.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1040,
    name: "Vigilante.pw",
    description: "Search compromised data leaks to identify exposed emails and accounts for security awareness.",
    link: "https://www.vigilante.pw/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1041,
    name: "Ashley Madison Emails",
    description: "OSINT leak-check resource for investigating Ashley Madison breach-related email data exposure.",
    link: "https://ashley.cynic.al/",
    category: "Email",
    icon: "✉️"
  },
  {
    id: 1042,
    name: "MxToolbox",
    description: "Domain/email diagnostic tool to analyze MX records, DNS settings, and blacklist status for investigation.",
    link: "http://mxtoolbox.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1043,
    name: "Domain Dossier",
    description: "Fast domain OSINT tool to view DNS, WHOIS, traceroute, and network footprint details in one place.",
    link: "http://centralops.net/co/DomainDossier.aspx",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1044,
    name: "domainIQ",
    description: "Advanced domain intelligence tool to view WHOIS history, ownership data, and domain connections.",
    link: "https://www.domainiq.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1045,
    name: "DomainTools Whois",
    description: "Professional WHOIS lookup platform for domain ownership research and security investigation.",
    link: "http://whois.domaintools.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1046,
    name: "Domain Big Data",
    description: "WHOIS and domain intelligence tool to find ownership patterns, emails, and linked infrastructure.",
    link: "http://domainbigdata.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1047,
    name: "Whoisology",
    description: "WHOIS history search platform for tracking domain registration, records, and ownership changes.",
    link: "https://whoisology.com/#advanced",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1048,
    name: "Whois ARIN",
    description: "Search ARIN databases to identify IP ownership, ASN information, and network organization details.",
    link: "https://whois.arin.net/ui/advanced.jsp",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1049,
    name: "DNSstuff",
    description: "DNS analysis toolkit to troubleshoot and investigate domain DNS configurations.",
    link: "https://tools.dnsstuff.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1050,
    name: "Robtex (R)",
    description: "Domain and IP intelligence platform to analyze DNS, hosting relationships, and network footprint.",
    link: "https://www.robtex.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1051,
    name: "Domaincrawler.com",
    description: "Domain search engine for discovering related domains and domain ownership footprints.",
    link: "http://www.domaincrawler.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1052,
    name: "MarkMonitor Whois Search",
    description: "Enterprise WHOIS search platform used for domain ownership investigation and brand protection research.",
    link: "https://domains.markmonitor.com/whois/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1053,
    name: "easyWhois",
    description: "Simple and clean WHOIS lookup tool to quickly fetch domain registration and ownership details.",
    link: "https://www.easywhois.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1054,
    name: "Website Informer",
    description: "Website intelligence tool that provides traffic stats, hosting, related sites, and public website details.",
    link: "http://website.informer.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1055,
    name: "Who.is",
    description: "Quick WHOIS lookup service to discover domain owner info, DNS records, and registration data.",
    link: "https://who.is/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1056,
    name: "Whois AMPed",
    description: "WHOIS analysis tool focused on IP/domain investigation with clean output and strong search features.",
    link: "https://whoisamped.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1057,
    name: "ViewDNS.info",
    description: "DNS intelligence site providing reverse IP lookup, DNS propagation checks, and domain investigation tools.",
    link: "http://viewdns.info/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1058,
    name: "Daily DNS Changes",
    description: "Track daily DNS modifications to detect domain changes, infrastructure shifts, and suspicious movements.",
    link: "http://www.dailychanges.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1059,
    name: "IP2WHOIS",
    description: "Lookup WHOIS records for IPs and domains to extract ownership and registration details.",
    link: "https://www.ip2whois.com",
    category: "Network",
    icon: "🌐"
  },
  {
    id: 1060,
    name: "Netlas.io (Whois Domains)",
    description: "Internet intelligence platform to search domain WHOIS data, ownership, and infrastructure relationships.",
    link: "https://app.netlas.io/whois_domains/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1061,
    name: "SynapsInt",
    description: "OSINT automation platform for reconnaissance, investigation workflows, and threat intelligence collection.",
    link: "https://synapsint.com",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1062,
    name: "Aquatone",
    description: "Subdomain discovery and visual recon tool that captures screenshots and identifies web attack surfaces.",
    link: "https://github.com/michenriksen/aquatone",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1063,
    name: "FindSubDomains",
    description: "A subdomain search tool to discover related subdomains and expand reconnaissance scope.",
    link: "https://findsubdomains.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1064,
    name: "Google Subdomains (D)",
    description: "Google dork query to discover indexed subdomains of a domain using search engine reconnaissance.",
    link: "https://www.google.com/?gws_rd=ssl#q=site:%3Cdomain.com%3E",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1065,
    name: "Recon-ng",
    description: "Modular OSINT reconnaissance framework for performing automated information gathering and profiling.",
    link: "https://github.com/lanmaster53/recon-ng",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1066,
    name: "XRay",
    description: "Security reconnaissance tool for analyzing targets and extracting useful infrastructure intelligence.",
    link: "https://github.com/evilsocket/xray",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1067,
    name: "DNS Recon",
    description: "DNS reconnaissance tool to enumerate subdomains, DNS records, zone transfers, and target infrastructure.",
    link: "https://github.com/darkoperator/dnsrecon",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1068,
    name: "Gobuster",
    description: "Fast directory/file brute-forcing tool used to find hidden paths, endpoints, and web content on targets.",
    link: "https://github.com/OJ/gobuster",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1069,
    name: "Fierce Domain Scanner",
    description: "Domain scanning tool to discover subdomains and related hosts during penetration testing and OSINT recon.",
    link: "https://github.com/davidpepper/fierce-domain-scanner",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1070,
    name: "Bluto",
    description: "Brute-force domain enumeration tool used to discover subdomains and expose hidden infrastructure.",
    link: "https://github.com/darryllane/Bluto",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1071,
    name: "OWASP Maryam",
    description: "OSINT and reconnaissance framework by OWASP to automate intelligence collection workflows.",
    link: "https://github.com/saeeddhqan/Maryam",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1072,
    name: "theHarvester",
    description: "A reconnaissance OSINT tool to collect subdomains, emails, and public information for investigations.",
    link: "https://github.com/laramies/theHarvester",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1073,
    name: "Pentest-tools.com Subdomains",
    description: "Online subdomain finder tool to quickly enumerate a domain’s subdomains and exposed assets.",
    link: "https://pentest-tools.com/information-gathering/find-subdomains-of-domain",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1074,
    name: "SecLists DNS Subdomains",
    description: "A massive collection of wordlists used for DNS enumeration and subdomain discovery in recon workflows.",
    link: "https://github.com/danielmiessler/SecLists/tree/master/Discovery/DNS",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1075,
    name: "dnspop",
    description: "Passive DNS OSINT tool for investigating historical DNS data and discovering infrastructure relationships.",
    link: "https://github.com/bitquark/dnspop",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1076,
    name: "gdns",
    description: "A DNS OSINT tool designed for discovering domain-related data and mapping DNS infrastructure.",
    link: "https://github.com/hrbrmstr/gdns",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1077,
    name: "assetnote",
    description: "Attack surface discovery tool and OSINT framework used to identify assets, subdomains, and endpoints.",
    link: "https://github.com/infosec-au/assetnote",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1078,
    name: "Sublist3r",
    description: "Popular subdomain enumeration tool for OSINT and recon that uses multiple sources to find subdomains.",
    link: "https://github.com/aboul3la/Sublist3r",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1079,
    name: "AltDNS",
    description: "Generate permutated subdomains and discover hidden subdomain assets during domain reconnaissance.",
    link: "https://github.com/infosec-au/altdns",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1080,
    name: "Netlas.io Domains",
    description: "Internet intelligence tool to search domains and map relationships between assets and infrastructure.",
    link: "https://app.netlas.io/domains/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1081,
    name: "Shodan",
    description: "Search engine for internet-connected devices to discover open ports, vulnerabilities, and exposed services.",
    link: "https://www.shodan.io/",
    category: "Network",
    icon: "🌐"
  },
  {
    id: 1082,
    name: "Netlas.io",
    description: "Internet-wide scanning platform to explore exposed domains, services, certificates, and digital assets.",
    link: "https://app.netlas.io/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1083,
    name: "ODIN (R)",
    description: "Security intelligence platform for threat hunting, attack surface monitoring, and cyber OSINT research.",
    link: "https://www.getodin.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1084,
    name: "Kraken",
    description: "OSINT reconnaissance automation tool to gather and structure intelligence from multiple online sources.",
    link: "https://github.com/Sw4mpf0x/Kraken",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1085,
    name: "Online Nikto scanner",
    description: "Online web vulnerability scanner based on Nikto to detect misconfigurations and common security issues.",
    link: "https://nikto.online/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1086,
    name: "urlscan.io",
    description: "Analyze websites for OSINT by scanning URLs, capturing page behavior, and extracting hosted resources.",
    link: "https://urlscan.io/search/#*",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1087,
    name: "Daily DNS Changes",
    description: "Monitor DNS updates to detect changes in domain infrastructure and possible suspicious activities.",
    link: "http://www.dailychanges.com/",
    category: "Domain",
    icon: "🌍"
  },
  {
    id: 1088,
    name: "SameID",
    description: "Find connected identities across the internet by searching for recurring usernames and aliases.",
    link: "http://sameid.net/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1089,
    name: "Redirect Detective",
    description: "URL redirection checker that reveals full redirect chains and hidden destination URLs for investigation.",
    link: "http://redirectdetective.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1090,
    name: "Sitediff",
    description: "Website comparison tool to monitor changes and detect modifications in web content across time.",
    link: "https://github.com/digininja/sitediff",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1091,
    name: "AnalyzeID",
    description: "Domain and identity OSINT tool to evaluate domain ownership, infrastructure links, and website details.",
    link: "http://analyzeid.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1092,
    name: "urlDNA",
    description: "URL intelligence tool that generates fingerprints of a website URL to support OSINT investigations.",
    link: "https://urldna.io",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1093,
    name: "Google Certificate Transparency",
    description: "Explore certificate transparency logs to discover subdomains, issued certificates, and domain-related assets.",
    link: "https://www.certificate-transparency.org/known-logs",
    category: "Google",
    icon: "🔍"
  },
  {
    id: 1094,
    name: "Spyse",
    description: "Internet asset search engine for discovering domains, IPs, certificates, open ports, and related OSINT data.",
    link: "https://spyse.com/search/certificate",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1095,
    name: "Censys",
    description: "Internet reconnaissance platform to analyze IPs, certificates, hosts, and exposed services for OSINT.",
    link: "https://censys.io/",
    category: "Network",
    icon: "🌐"
  },
  {
    id: 1096,
    name: "crt.sh - Certificate Search",
    description: "Search SSL certificate transparency logs to discover subdomains, domains, and historical certificate records.",
    link: "https://crt.sh/?",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1097,
    name: "certgraph",
    description: "A certificate transparency graph tool to visualize and map domain relationships using SSL certificates.",
    link: "https://github.com/lanrat/certgraph",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1098,
    name: "ODIN (R)",
    description: "Security intelligence and threat hunting solution for monitoring attack surface and cyber risks.",
    link: "https://www.getodin.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1099,
    name: "Netlas.io Certs",
    description: "Certificate intelligence tool for exploring SSL certificate datasets and discovering subdomains.",
    link: "https://app.netlas.io/certs/",
    category: "OSINT Tools",
    icon: "🧰"
  },
  {
    id: 1100,
    name: "Security Trails",
    description: "Domain intelligence platform to investigate DNS history, subdomains, passive DNS, and infrastructure changes.",
    link: "https://securitytrails.com/",
    category: "OSINT Tools",
    icon: "🧰"
  },
{
  id: 1101,
  name: "Mnemonic",
  description: "A Passive DNS intelligence platform to explore historical DNS records and uncover domain-to-IP relationships.",
  link: "http://passivedns.mnemonic.no/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1102,
  name: "DNS History",
  description: "Track historical DNS changes of domains to identify infrastructure shifts, hosting movements, and past records.",
  link: "http://dnshistory.org/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1103,
  name: "PTRarchive.com",
  description: "A searchable archive of historical PTR (reverse DNS) records helpful for infrastructure and IP investigation.",
  link: "http://ptrarchive.com/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1104,
  name: "DNS Dumpster",
  description: "A popular DNS recon tool that maps subdomains, DNS records, and reveals domain infrastructure visually.",
  link: "https://dnsdumpster.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1105,
  name: "Deteque (R)",
  description: "Threat intelligence and attack surface tool to analyze and track domain reputation and security risks (restricted access).",
  link: "https://www.deteque.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1106,
  name: "AbuseIPDB (Webpage and API)",
  description: "Check IP reputation using community reports and API to detect malicious IPs, abuse records, and threat activity.",
  link: "https://www.abuseipdb.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1107,
  name: "UrlQuery.net",
  description: "URL analysis tool that scans websites to reveal hidden scripts, network calls, and potentially malicious behavior.",
  link: "http://urlquery.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1108,
  name: "PassiveTotal",
  description: "Threat intelligence platform for domain/IP enrichment, reputation checks, and infrastructure relationship mapping.",
  link: "https://www.passivetotal.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1109,
  name: "URL Void",
  description: "Website reputation checker that scans domains using multiple blacklist engines to detect suspicious or malicious URLs.",
  link: "http://www.urlvoid.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1110,
  name: "Threat Crowd",
  description: "Threat intelligence search engine to analyze domains, IPs, emails, and discover connected malicious infrastructure.",
  link: "https://www.threatcrowd.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1111,
  name: "FortiGuard Reputation Service",
  description: "Fortinet reputation lookup tool to analyze IP/domain risk rating, category, and potential malicious activity.",
  link: "http://fortiguard.com/iprep",
  category: "Network",
  icon: "🌐"
},
{
  id: 1112,
  name: "McAfee TrustedSource",
  description: "McAfee reputation intelligence service for checking URL/domain trust scores and security classification.",
  link: "http://www.trustedsource.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1113,
  name: "Trend Micro Site Safety Center",
  description: "Check website safety and reputation using Trend Micro threat intelligence to identify risky and malicious domains.",
  link: "https://global.sitesafety.trendmicro.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1114,
  name: "WatchGuard ReputationAuthority",
  description: "Website reputation lookup tool to categorize URL risk levels and detect unsafe websites.",
  link: "http://www.reputationauthority.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1115,
  name: "Sucuri SiteCheck",
  description: "Website malware scanner that checks for infections, blacklist status, and security issues in public sites.",
  link: "https://sitecheck.sucuri.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1116,
  name: "ThreatMiner.org",
  description: "Threat intelligence portal to search domains, IPs, malware indicators, and related threat data for investigation.",
  link: "https://www.threatminer.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1117,
  name: "BlueCoat WebPulse",
  description: "URL reputation classification tool to verify website category, risk level, and security filtering information.",
  link: "https://sitereview.bluecoat.com/sitereview.jsp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1118,
  name: "Zscaler Zulu URL Risk Analyzer",
  description: "Analyze a URL for potential threats and risk scoring using Zscaler’s security intelligence engine.",
  link: "http://zulu.zscaler.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1119,
  name: "Joe Sandbox Url Analyzer",
  description: "Online URL sandbox analyzer to detect malicious behavior, scripts, redirects, and threat patterns.",
  link: "https://www.url-analyzer.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1120,
  name: "Deepviz Domain Search",
  description: "Domain lookup tool to explore ownership signals, links, infrastructure patterns, and threat context.",
  link: "https://search.deepviz.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1121,
  name: "Cisco SenderBase",
  description: "Cisco reputation intelligence service for investigating IP reputation and traffic behavior patterns.",
  link: "http://www.senderbase.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1122,
  name: "AVG Threat Labs",
  description: "Website safety report tool from AVG to check domain risk, reputation score, and possible threats.",
  link: "http://www.avgthreatlabs.com/ww-en/website-safety-reports/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1123,
  name: "Webroot BrightCloud URL/IP Lookup",
  description: "Lookup URL or IP reputation using BrightCloud intelligence to verify category and security risk rating.",
  link: "http://www.brightcloud.com/tools/url-ip-lookup.php",
  category: "Network",
  icon: "🌐"
},
{
  id: 1124,
  name: "vURL Online",
  description: "Dissect and analyze URLs to identify malicious patterns, redirects, parameters, and phishing signals.",
  link: "https://vurldissect.co.uk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1125,
  name: "AlienVault Open Threat Exchange",
  description: "Community-driven threat intelligence platform to explore indicators, pulses, and real-world cyber threats.",
  link: "https://otx.alienvault.com/browse/pulses/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1126,
  name: "Malware Domain List",
  description: "Search known malicious domains to identify malware distribution and suspicious infrastructure indicators.",
  link: "http://www.malwaredomainlist.com/mdl.php",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1127,
  name: "Web Inspector Online Scan",
  description: "Online website security scanner to detect vulnerabilities, malware traces, and unsafe configurations.",
  link: "http://app.webinspector.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1128,
  name: "Google Safe Browsing API",
  description: "Google’s official API to detect phishing and malware URLs by checking against Safe Browsing threat lists.",
  link: "https://developers.google.com/safe-browsing/?csw=1",
  category: "Google",
  icon: "🔍"
},
{
  id: 1129,
  name: "hpHosts Online",
  description: "Blacklist intelligence site for tracking suspicious hosts, adware sources, and known malicious domains.",
  link: "http://hosts-file.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1130,
  name: "Ransomware Tracker Abuse.ch",
  description: "Track ransomware-related malicious domains using Abuse.ch intelligence feeds for threat hunting and defense.",
  link: "http://ransomwaretracker.abuse.ch/downloads/RW_DOMBL.txt",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1131,
  name: "Threatexpert.com Malicious URLs",
  description: "Malicious URL blocklist source useful for identifying infected domains and suspicious web infrastructure.",
  link: "http://www.networksec.org/grabbho/block.txt",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1132,
  name: "Zeus C2 Tracker",
  description: "Malware C2 tracking feed listing malicious domains used in Zeus botnet command-and-control infrastructure.",
  link: "https://zeustracker.abuse.ch/blocklist.php?download=domainblocklist",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1133,
  name: "Malware Domains Blacklist",
  description: "Blacklist feed of known malware-related domains used for blocking and detecting malicious web activity.",
  link: "http://mirror1.malwaredomains.com/files/domains.txt",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1134,
  name: "Blackweb",
  description: "Open-source blacklist and filtering tool for blocking malicious domains and unsafe websites.",
  link: "https://github.com/maravento/blackweb",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1135,
  name: "Critical Stack Intel (R)",
  description: "Threat intelligence platform offering community indicators and blacklist feeds for network protection (restricted).",
  link: "https://intel.criticalstack.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1136,
  name: "DNS Sinkhole",
  description: "Malicious domain feed used to identify malware hosting domains and sinkhole suspicious DNS targets.",
  link: "http://malc0de.com/bl/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1137,
  name: "DNS-BH Malware Domain Blocklist",
  description: "Malware domain blocklist for detecting and blocking known malicious DNS domains and command servers.",
  link: "http://www.malwaredomains.com/wordpress/?page_id=66",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1138,
  name: "Malware Domain List (Hosts)",
  description: "Hosts-based blocklist of malicious domains used for defense, investigation, and security filtering.",
  link: "http://www.malwaredomainlist.com/hostslist/hosts.txt",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1139,
  name: "Malware Patrol (R)",
  description: "Paid threat intelligence feed offering malware and phishing blocklists for proactive cyber defense.",
  link: "http://www.malware.com.br/open-source.shtml",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1140,
  name: "MalwareURL (R)",
  description: "Malware-focused URL intelligence platform providing malicious URL lists and threat monitoring (restricted access).",
  link: "http://www.malwareurl.com/index.php",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1141,
  name: "scumware.org",
  description: "Blacklist intelligence resource to report and track malicious domains, scams, and unsafe web infrastructure.",
  link: "https://www.scumware.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1142,
  name: "ZeuS Tracker",
  description: "Threat intelligence tracker for botnet indicators and malicious infrastructure related to ZeuS malware.",
  link: "https://zeustracker.abuse.ch/blocklist.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1143,
  name: "Shadowserver Foundation",
  description: "Global cybersecurity nonprofit providing threat reports and intelligence services for exposed systems and malware activity.",
  link: "http://www.shadowserver.org/wiki/pmwiki.php?n=Services/Reports",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1144,
  name: "Email Domain Validation",
  description: "Validate email domains and DNS setup to confirm if a domain can receive mail and detect fake domains.",
  link: "https://www.mailboxvalidator.com/domain",
  category: "Email",
  icon: "✉️"
},
{
  id: 1145,
  name: "DNS Twist",
  description: "Typosquatting detection tool that generates lookalike domains to detect phishing, spoofing, and brand abuse.",
  link: "https://github.com/elceef/dnstwist",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1146,
  name: "URLCrazy",
  description: "Generate typo and variant domains to find phishing targets and malicious lookalike domain patterns.",
  link: "http://www.morningstarsecurity.com/research/urlcrazy",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1147,
  name: "dnstwister",
  description: "Online typosquatting search engine to discover malicious domain lookalikes and phishing infrastructure.",
  link: "https://dnstwister.report/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1148,
  name: "Catphish",
  description: "OSINT and phishing detection tool to identify suspicious domains, lookalike assets, and scam infrastructure.",
  link: "https://github.com/ring0lab/catphish",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1149,
  name: "BuiltWith",
  description: "Technology profiling tool to detect what CMS, frameworks, analytics, and hosting a website is using.",
  link: "http://builtwith.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1150,
  name: "SiteSleuth",
  description: "Website technology & infrastructure intelligence platform to analyze tools, hosting, and tracking details.",
  link: "https://www.sitesleuth.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1151,
  name: "Wappalyzer",
  description: "Identify website technologies such as frameworks, CMS, analytics tools, and server stack with one scan.",
  link: "https://wappalyzer.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1152,
  name: "SEMrush",
  description: "SEO intelligence tool to analyze website traffic, ranking keywords, competitors, and performance insights.",
  link: "https://www.semrush.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1153,
  name: "TopGainers",
  description: "Website ranking and domain performance platform to analyze visibility and trending growth signals.",
  link: "https://topgainers.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1154,
  name: "Moonsearch",
  description: "Domain and web intelligence tool that helps explore websites, ranking signals, and indexed presence online.",
  link: "http://moonsearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1155,
  name: "StackShare",
  description: "Discover technologies used by companies and websites by viewing their public tech stacks and tools.",
  link: "https://stackshare.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1156,
  name: "Ewhois",
  description: "Domain intelligence platform providing WHOIS lookup, ownership details, and DNS-related research.",
  link: "https://ewhois.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1157,
  name: "Netcraft",
  description: "Website intelligence tool providing hosting data, technology stack, SSL info, and security footprint reports.",
  link: "http://toolbar.netcraft.com/site_report?url=undefined#last_reboot",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1158,
  name: "StatsCrop",
  description: "Website analytics and traffic estimation tool used for OSINT website profiling and popularity research.",
  link: "http://www.statscrop.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1159,
  name: "Open Site Explorer",
  description: "Link intelligence tool by Moz to analyze backlinks, domain authority, and SEO strength of websites.",
  link: "https://moz.com/researchtools/ose/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1160,
  name: "SpyOnWeb",
  description: "Discover connected websites sharing IP, tracking codes, analytics IDs, and infrastructure fingerprints.",
  link: "http://www.spyonweb.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1161,
  name: "SecurityHeaders.io",
  description: "Check HTTP security headers of a website and detect missing protections like CSP, HSTS, and XSS defenses.",
  link: "https://securityheaders.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1162,
  name: "Keyword Density",
  description: "Analyze keyword density of a webpage to understand content patterns, SEO signals, and possible spam usage.",
  link: "http://tools.seobook.com/general/keyword-density/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1163,
  name: "Alexa Site Statistics",
  description: "Website ranking and traffic insights tool (legacy) useful for analyzing general popularity signals.",
  link: "http://www.alexa.com/siteinfo",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1164,
  name: "Cisco Umbrella Popularity List",
  description: "Explore domain popularity datasets to understand trending domains and high-traffic internet destinations.",
  link: "http://s3-us-west-1.amazonaws.com/umbrella-static/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1165,
  name: "Alexa Top 500 Global Sites",
  description: "Top global websites list (legacy) for comparing popular internet destinations and traffic rankings.",
  link: "http://www.alexa.com/topsites",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1166,
  name: "W3bin.com",
  description: "Website intelligence service to gather metadata, hosting details, and performance signals for OSINT research.",
  link: "https://w3bin.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1167,
  name: "Sitedossier",
  description: "Domain profiling tool to view DNS data, backlinks, website popularity, and related domain information.",
  link: "http://www.sitedossier.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1168,
  name: "Visual Site Mapper",
  description: "Generate a visual map of website pages and structure to understand site navigation and footprint.",
  link: "http://www.visualsitemapper.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1169,
  name: "ClearWebStats.com",
  description: "Website traffic intelligence tool to check popularity, ranking estimates, and general web performance stats.",
  link: "https://www.clearwebstats.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1170,
  name: "PubDB",
  description: "Public domain database search tool useful for exploring website indexing, links, and domain footprint.",
  link: "http://pub-db.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1171,
  name: "WWW Domain Tools",
  description: "Domain tools suite for performing WHOIS lookup, DNS checks, and basic domain intelligence research.",
  link: "https://w3dt.net/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1172,
  name: "SimilarWeb",
  description: "Website traffic analytics platform to estimate visitors, top countries, referral sources, and competitor sites.",
  link: "https://www.similarweb.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1173,
  name: "Website Outlook",
  description: "Website profiling tool showing estimated value, traffic ranking, and web presence indicators for OSINT research.",
  link: "http://websiteoutlook.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1174,
  name: "Siteliner",
  description: "Website content audit tool to detect duplicate pages, broken links, and SEO issues across a domain.",
  link: "http://siteliner.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1175,
  name: "WebPagetest",
  description: "Website performance testing platform to analyze load speed, requests, and optimize web performance.",
  link: "https://www.webpagetest.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1176,
  name: "WhatWeb",
  description: "Website fingerprinting tool that detects CMS, plugins, frameworks, and technologies used by a target website.",
  link: "https://github.com/urbanadventurer/WhatWeb",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1177,
  name: "Link Expander",
  description: "Expand shortened URLs and reveal the real destination link to detect suspicious redirects and phishing.",
  link: "http://www.linkexpander.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1178,
  name: "GetLinkInfo",
  description: "Check shortened URLs to view redirect chains, destination pages, and security-related link details.",
  link: "http://www.getlinkinfo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1179,
  name: "CheckShortURL",
  description: "Unshorten and analyze short URLs to reveal final destination pages and verify link safety.",
  link: "http://checkshorturl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1180,
  name: "Lengthen Me",
  description: "URL unshortener tool that expands shortened URLs and displays final destination links for safe browsing.",
  link: "https://lengthen.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1181,
  name: "URL Expander",
  description: "Reveal the true destination of shortened links and detect hidden redirect chains in suspicious URLs.",
  link: "http://urlex.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1182,
  name: "URL Unshortener",
  description: "Expand short links into full URLs to verify destination sites and reduce phishing risk.",
  link: "http://www.urlunshortener.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1183,
  name: "Where Does This Link Go?",
  description: "Analyze and expand shortened URLs to uncover the final redirect destination and hidden tracking paths.",
  link: "http://wheredoesthislinkgo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1184,
  name: "KnowURL",
  description: "Check URL safety, redirects, and website reputation to confirm if a link is trustworthy.",
  link: "http://www.knowurl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1185,
  name: "VisualPing",
  description: "Website change monitoring tool that alerts when a webpage updates — useful for OSINT tracking and monitoring.",
  link: "http://visualping.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1186,
  name: "Change Detection",
  description: "Monitor web pages for changes and receive alerts — great for OSINT tracking, news monitoring, and updates.",
  link: "http://www.changedetection.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1187,
  name: "Check site availability Online",
  description: "Website uptime checker to monitor online availability, downtime alerts, and server response status.",
  link: "https://upcheck.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1188,
  name: "Follow That Page",
  description: "Track webpage updates and get notified about content changes — useful for monitoring targets and websites.",
  link: "https://www.followthatpage.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1189,
  name: "Urlwatch",
  description: "Open-source website change detection tool that monitors URLs and alerts when content changes.",
  link: "https://github.com/thp/urlwatch",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1190,
  name: "WatchThatPage",
  description: "Monitor website changes and updates automatically — useful for OSINT tracking and digital monitoring.",
  link: "http://watchthatpage.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1191,
  name: "ChangeDetect",
  description: "Web page monitoring service to detect content changes and alert users instantly for tracking purposes.",
  link: "http://www.changedetect.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1192,
  name: "Google Trends",
  description: "Analyze trending keywords and search behavior over time to support investigation, market insights, and OSINT research.",
  link: "https://www.google.com/trends/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1193,
  name: "Reddit (M)",
  description: "Manual OSINT method to find discussions and mentions of a domain on Reddit using domain search pages.",
  link: "https://www.reddit.com/domain/%3CURLhere%3E",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1194,
  name: "DNSSEC Analyzer",
  description: "Analyze DNSSEC configuration and validate DNS security settings to prevent spoofing and DNS tampering.",
  link: "http://dnssec-debugger.verisignlabs.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1195,
  name: "DNSViz",
  description: "Visual DNS analysis tool to inspect DNSSEC chain, configuration errors, and security problems in DNS records.",
  link: "http://dnsviz.net/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1196,
  name: "Public Buckets",
  description: "Search engine for public cloud storage buckets to discover exposed cloud files and misconfigured assets.",
  link: "https://buckets.grayhatwarfare.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1197,
  name: "Online Port scanner",
  description: "Online port scanning tool to check open ports and services visible from the internet for a target IP.",
  link: "https://portscanner.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1198,
  name: "CloudScraper",
  description: "Automation tool to bypass and scrape Cloudflare-protected websites for recon and security research.",
  link: "https://github.com/jordanpotti/cloudscraper",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1199,
  name: "Check site availability Online",
  description: "Uptime monitoring tool to track website availability, response time, and downtime incidents.",
  link: "https://upcheck.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1200,
  name: "Sn1per",
  description: "Automated pentest and recon framework that scans for vulnerabilities, open ports, and security misconfigurations.",
  link: "https://github.com/1N3/Sn1per",
  category: "OSINT Tools",
  icon: "🧰"
},

 {
  id: 1201,
  name: "Online Nikto scanner",
  description: "Online Nikto-based web vulnerability scanner to detect outdated software, dangerous files, and common security misconfigurations.",
  link: "https://nikto.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1202,
  name: "XSSposed.org",
  description: "A vulnerability disclosure archive focused on XSS vulnerabilities, useful for learning past exploits and target risk research.",
  link: "https://www.xssposed.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1203,
  name: "Zone-H.org",
  description: "Defacement archive database used for OSINT to analyze hacked websites, attack patterns, and historical incidents.",
  link: "http://zone-h.org/archive",
  category: "Archives",
  icon: "📚"
},
{
  id: 1204,
  name: "RobotsDisallowed",
  description: "Curated collection of sensitive robots.txt paths that helps identify hidden directories and potential exposure points.",
  link: "https://github.com/danielmiessler/RobotsDisallowed",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1205,
  name: "Belati",
  description: "Open-source OSINT investigation framework designed for reconnaissance, evidence collection, and digital footprint analysis.",
  link: "https://github.com/aancw/Belati",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1206,
  name: "BlackWidow",
  description: "Website spider and OSINT scraping tool to collect emails, phone numbers, files, and sensitive patterns from webpages.",
  link: "https://softbytelabs.com/wp/blackwidow/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1207,
  name: "Burp Suite",
  description: "Industry-standard web security testing toolkit for intercepting traffic, scanning vulnerabilities, and penetration testing workflows.",
  link: "https://portswigger.net/burp/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1208,
  name: "EyeWitness",
  description: "Recon tool that captures screenshots of websites, categorizes services, and builds visual reports for investigations.",
  link: "https://github.com/ChrisTruncer/EyeWitness",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1209,
  name: "IntelliTamper",
  description: "Web debugging and tampering tool used to inspect HTTP traffic, manipulate requests, and analyze web behavior.",
  link: "http://www.softpedia.com/get/Internet/Other-Internet-Related/IntelliTamper.shtml",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1210,
  name: "Hunting-New-Registered-Domains",
  description: "Track newly registered domains to detect phishing campaigns, malicious lookalikes, and emerging threats early.",
  link: "https://github.com/gfek/Hunting-New-Registered-Domains",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1211,
  name: "International Domain Name Conversion Tool",
  description: "Convert Internationalized Domain Names (IDNs) to ASCII/Punycode to investigate spoofing and Unicode-based phishing threats.",
  link: "http://mct.verisign-grs.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1212,
  name: "Online Nikto scanner",
  description: "Quick online vulnerability scan using Nikto signatures to find insecure headers, misconfigurations, and risky files.",
  link: "https://nikto.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1213,
  name: "Microsoft",
  description: "Official Microsoft reporting portal to submit unsafe or malicious websites for review and user protection.",
  link: "https://www.microsoft.com/en-us/wdsi/support/report-unsafe-site-guest",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1214,
  name: "Google",
  description: "Google Safe Browsing reporting page to submit phishing URLs and malicious websites for security review.",
  link: "https://safebrowsing.google.com/safebrowsing/report_phish/?hl=en",
  category: "Google",
  icon: "🔍"
},
{
  id: 1215,
  name: "MaxMind Demo",
  description: "IP geolocation lookup demo used to map IP addresses to countries, cities, and network providers.",
  link: "https://www.maxmind.com/en/home",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1216,
  name: "IPv4/IPv6 lists by country code",
  description: "Country-wise IPv4/IPv6 allocation lists for network investigation, filtering, and geolocation-based analysis.",
  link: "http://ipverse.net/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1217,
  name: "IP2Location.com",
  description: "IP geolocation service to identify city, region, ISP, and proxy/VPN signals for network intelligence.",
  link: "https://www.ip2location.com/demo",
  category: "Network",
  icon: "🌐"
},
{
  id: 1218,
  name: "IP Fingerprints",
  description: "IP lookup and network footprint tool to view geolocation, ASN details, reverse IP, and hosting information.",
  link: "http://www.ipfingerprints.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1219,
  name: "DB-IP",
  description: "IP intelligence platform offering geolocation and ASN details for mapping network identity and location.",
  link: "https://db-ip.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1220,
  name: "IP Location Finder",
  description: "Compare IP geolocation results from multiple providers to validate location and network attribution.",
  link: "https://www.iplocation.net/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1221,
  name: "Info Sniper",
  description: "IP geolocation tool to locate IP origin on map and retrieve ISP/network details for OSINT investigation.",
  link: "http://www.infosniper.net/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1222,
  name: "utrace",
  description: "IP tracing and geolocation tool for identifying country, region, and organization behind an IP address.",
  link: "http://en.utrace.de/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1223,
  name: "InfobyIP.com",
  description: "IP lookup tool to fetch geolocation, ASN, hosting provider, and network ownership information.",
  link: "https://www.infobyip.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1224,
  name: "ipTRACKERonline",
  description: "IP tracking and lookup tool to analyze location, ISP, and reverse DNS for investigation use.",
  link: "https://www.iptrackeronline.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1225,
  name: "My IP Address",
  description: "Check public IP address details including ISP, ASN, geolocation data, and network metadata.",
  link: "https://www.ipaddress.my/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1226,
  name: "urlscan.io",
  description: "Scan a website to analyze page behavior, requests, scripts, redirects, and extract intelligence indicators.",
  link: "https://urlscan.io/search/#*",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1227,
  name: "Spyse",
  description: "Internet intelligence search engine for analyzing IPs, domains, ports, vulnerabilities, and exposed services.",
  link: "https://spyse.com/search/ip",
  category: "Network",
  icon: "🌐"
},
{
  id: 1228,
  name: "Shodan",
  description: "Search engine for exposed devices and services to discover open ports, banners, vulnerabilities, and risks.",
  link: "https://www.shodan.io/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1229,
  name: "Netlas.io",
  description: "Internet-wide data platform to search IPs, ports, certificates, and map infrastructure exposures.",
  link: "https://netlas.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1230,
  name: "Portmap",
  description: "Port mapping intelligence tool for discovering open services, devices, and exposed network endpoints worldwide.",
  link: "https://portmap.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1231,
  name: "Scans.io",
  description: "Internet scan data resource that provides searchable datasets for open ports and exposed services.",
  link: "https://scans.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1232,
  name: "ZoomEye",
  description: "Cyber search engine to find exposed devices, systems, ports, and network services across the internet.",
  link: "https://www.zoomeye.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1233,
  name: "Nmap",
  description: "Most popular network scanning tool to discover hosts, services, open ports, and perform security auditing.",
  link: "https://nmap.org/download.html",
  category: "Network",
  icon: "🌐"
},
{
  id: 1234,
  name: "Online Port scanner",
  description: "Online port scanning utility to verify exposed services and identify open ports on a public IP address.",
  link: "https://portscanner.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1235,
  name: "Internet Census Search",
  description: "Internet scan search tool to explore publicly indexed IP/port datasets and exposed network services.",
  link: "http://www.exfiltrated.com/querystart.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1236,
  name: "Criminal IP Search",
  description: "Threat intelligence and asset discovery tool to detect risky IPs, exposed services, and malicious infrastructure.",
  link: "https://www.criminalip.io/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1237,
  name: "Scanless",
  description: "Automation tool that runs reconnaissance and scanning using third-party APIs without directly scanning targets.",
  link: "https://github.com/vesche/scanless",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1238,
  name: "BinaryEdge (R)",
  description: "Internet-wide scanning and threat intelligence platform for exposed services, vulnerabilities, and risk signals (restricted).",
  link: "https://www.binaryedge.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1239,
  name: "Masscan",
  description: "High-speed port scanner capable of scanning large IP ranges quickly to detect open services and exposures.",
  link: "https://github.com/robertdavidgraham/masscan",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1240,
  name: "ODIN (R)",
  description: "Threat intelligence and infrastructure investigation platform for asset discovery and security exposure monitoring.",
  link: "https://www.getodin.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1241,
  name: "ASlookup.com",
  description: "ASN lookup tool to map IP addresses to Autonomous Systems and network providers for OSINT attribution.",
  link: "https://aslookup.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1242,
  name: "Port scanner Online",
  description: "Web-based port scanner to validate open ports and identify services exposed on a public network.",
  link: "https://portscanner.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1243,
  name: "Onyphe",
  description: "Cyber defense search engine for IP/host intelligence, exposed services, and vulnerability metadata enrichment.",
  link: "https://www.onyphe.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1244,
  name: "ODIN (R)",
  description: "Infrastructure intelligence platform for investigating IPs, ports, services, and exposed assets across the internet.",
  link: "https://www.getodin.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1245,
  name: "IPv4 CIDR Report",
  description: "CIDR and ASN reporting resource to analyze IPv4 allocations, network ownership, and routing information.",
  link: "http://www.cidr-report.org/as2.0/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1246,
  name: "Reverse.report",
  description: "Reverse IP intelligence platform to discover domains hosted on the same IP and identify neighbor infrastructure.",
  link: "https://reverse.report/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1247,
  name: "Team Cymru IP to ASN",
  description: "Lookup service to map IP addresses to ASN and network owner details for attribution investigations.",
  link: "https://asn.cymru.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1248,
  name: "IP to ASN DB",
  description: "Database tool to translate IP addresses into ASN, provider, and routing owner information.",
  link: "https://iptoasn.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1249,
  name: "Hacker Target - Reverse DNS",
  description: "Reverse DNS lookup tool to identify domain names pointing to a given IP address for infrastructure research.",
  link: "https://hackertarget.com/reverse-dns-lookup/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1250,
  name: "IPv6 CIDR Report",
  description: "IPv6 allocation and ASN report resource for analyzing routing blocks, owners, and network footprint data.",
  link: "http://www.cidr-report.org/v6/as2.0/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1251,
  name: "Hurricane Electric BGP Toolkit",
  description: "One of the best BGP/ASN intelligence tools to explore routing paths, prefixes, peers, and internet topology.",
  link: "http://bgp.he.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1252,
  name: "BGP Malicious Content Ranking",
  description: "Rank and analyze BGP routing networks linked to malicious activity, spam, and unsafe content distribution.",
  link: "http://bgpranking.circl.lu/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1253,
  name: "BGPStream",
  description: "Monitor BGP routing events and analyze hijacks, leaks, and internet routing anomalies in real-time.",
  link: "https://bgpstream.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1254,
  name: "PeeringDB",
  description: "Search peering and interconnection database to discover ASN details, IXPs, and network operator metadata.",
  link: "https://www.peeringdb.com/advanced_search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1255,
  name: "BGP Tools",
  description: "BGP utilities for investigating routing data, AS paths, prefixes, and internet network relationships.",
  link: "http://www.bgp4.as/tools",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1256,
  name: "IP Void",
  description: "IP reputation checker using blacklist engines to detect suspicious IPs, malware hosts, and risky servers.",
  link: "http://www.ipvoid.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1257,
  name: "ExoneraTor",
  description: "Tor Project tool to verify whether an IP address was a Tor exit node on a specific date and time.",
  link: "https://exonerator.torproject.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1258,
  name: "Grey Noise",
  description: "Noise intelligence platform to determine if an IP is internet background scanning or targeted malicious activity.",
  link: "https://viz.greynoise.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1259,
  name: "LiveIPMap IP Check",
  description: "IP lookup and mapping tool showing IP location, ISP details, and geolocation validation.",
  link: "https://www.liveipmap.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1260,
  name: "Blocklist.de",
  description: "Blacklist intelligence service that tracks attacking IP addresses and suspicious login brute-force attempts.",
  link: "http://www.blocklist.de/en/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1261,
  name: "DShield API",
  description: "SANS ISC DShield API for querying threat intelligence, IP reputation, and malicious activity reports.",
  link: "https://isc.sans.edu/api/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1262,
  name: "FireHOL IP Lists",
  description: "One of the most popular IP blacklist collections for blocking malicious networks and suspicious sources.",
  link: "http://iplists.firehol.org/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1263,
  name: "Project Honey Pot",
  description: "Threat intelligence service that tracks spammers and malicious bots using honeypot-collected IP data.",
  link: "http://www.projecthoneypot.org/list_of_ips.php",
  category: "Network",
  icon: "🌐"
},
{
  id: 1264,
  name: "AbuseIPDB",
  description: "Community-driven IP abuse database used to investigate malicious IPs with reports and threat history.",
  link: "https://www.abuseipdb.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1265,
  name: "IP Fingerprints - Reverse IP Lookup",
  description: "Reverse IP lookup tool to find domains hosted on the same IP and discover neighboring domain infrastructure.",
  link: "http://www.ipfingerprints.com/reverseip.php",
  category: "Network",
  icon: "🌐"
},
{
  id: 1266,
  name: "Bing IP Search (D)",
  description: "Bing dork to find websites hosted on a specific IP address, useful for neighbor domain discovery.",
  link: "http://www.bing.com/search?q=ip%3A8.8.8.8",
  category: "Network",
  icon: "🌐"
},
{
  id: 1267,
  name: "TCP/IP Utils - Domain Neighbors",
  description: "Domain neighbor tool to detect websites hosted near a target domain and analyze shared infrastructure.",
  link: "http://www.tcpiputils.com/domain-neighbors",
  category: "Domain",
  icon: "🌍"
},
{
  id: 1268,
  name: "MyIPNeighbors",
  description: "Neighbor domain discovery tool to find domains hosted on the same server or IP range for OSINT analysis.",
  link: "http://www.my-ip-neighbors.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1269,
  name: "CloudFlare Watch",
  description: "Legacy tool to identify real IP behind Cloudflare-protected sites using historical DNS and OSINT traces.",
  link: "http://www.crimeflare.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1270,
  name: "CloudFail",
  description: "OSINT tool designed to uncover origin IPs behind Cloudflare protection using recon and discovery methods.",
  link: "https://github.com/m0rtem/CloudFail",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1271,
  name: "WiGLE: Wireless Network Mapping",
  description: "Wireless network mapping database to locate WiFi access points and analyze SSIDs for geolocation OSINT.",
  link: "https://wigle.net/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1272,
  name: "OpenCellid: Database of Cell Towers",
  description: "Public cell tower database used for geolocation OSINT and mobile network infrastructure analysis.",
  link: "https://opencellid.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1273,
  name: "Wireshark",
  description: "World’s most used packet analyzer to capture and inspect network traffic for forensic and security analysis.",
  link: "https://www.wireshark.org/download.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1274,
  name: "NetworkMiner",
  description: "Network forensic analysis tool that extracts files, images, credentials, and metadata from captured traffic.",
  link: "https://www.netresec.com/?page=Networkminer",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1275,
  name: "Packet Total",
  description: "Online packet capture analysis service to upload PCAP files and detect suspicious traffic patterns.",
  link: "http://www.packettotal.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1276,
  name: "NetworkTotal",
  description: "PCAP analysis platform to identify threats, anomalies, and malicious activity inside network traffic.",
  link: "https://www.networktotal.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1277,
  name: "Ki.tc",
  description: "Short-link tracking service often used as an IP logger—use only ethically and with full user consent.",
  link: "https://ki.tc",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1278,
  name: "Grabify",
  description: "Link tracking / IP logging tool often misused—use only for authorized testing and educational demonstrations.",
  link: "https://grabify.link",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1279,
  name: "IP Logger",
  description: "Link-based tracking service that captures visitor IP and basic device info—use only with permission and legal authorization.",
  link: "https://iplogger.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1280,
  name: "Google Images",
  description: "Google image search engine used for OSINT to find similar images, sources, and related visual footprints.",
  link: "https://images.google.com/?gws_rd=ssl",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1281,
  name: "Bing Images",
  description: "Bing image search for OSINT to locate photo sources, duplicates, and visually similar images online.",
  link: "http://www.bing.com/images",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1282,
  name: "Yahoo Image Search",
  description: "Image search engine for discovering related photos, sources, and published copies across the web.",
  link: "http://images.yahoo.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1283,
  name: "TinEye Reverse Image Search",
  description: "Reverse image search tool to detect where an image appears online and track its earliest known versions.",
  link: "http://tineye.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1284,
  name: "PimEyes Face Search Engine",
  description: "AI-powered face search tool that finds where a face appears online—use responsibly with privacy awareness.",
  link: "https://pimeyes.com/en",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1285,
  name: "Yandex Images",
  description: "Reverse image search engine known for strong similarity matching and useful for OSINT visual investigations.",
  link: "https://www.yandex.com/images/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1286,
  name: "Baidu Images",
  description: "Chinese reverse image search tool to identify image matches and sources from Asian platforms and websites.",
  link: "http://shitu.baidu.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1287,
  name: "Twitter Image Search (M)",
  description: "Manual Twitter/X search query to find images by keyword, hashtag, or event for social media OSINT.",
  link: "https://twitter.com/search?q=%3Csearchterm%3E&src=typd&vertical=default&f=images",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1288,
  name: "Imgur Search",
  description: "Search Imgur for images and viral content to discover sources, reposts, and community discussions.",
  link: "https://imgur.com/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1289,
  name: "Photobucket",
  description: "Image hosting platform used in OSINT to trace image uploads, albums, and older media footprint data.",
  link: "http://photobucket.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1290,
  name: "Karma Decay",
  description: "Reddit image reverse search tool to find reposts and original submissions for OSINT content verification.",
  link: "http://karmadecay.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1291,
  name: "Image Raider",
  description: "Bulk reverse image searching tool to find where multiple images appear online and track duplicates efficiently.",
  link: "https://www.imageraider.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1292,
  name: "7Photos.net",
  description: "Reverse image lookup tool that helps detect photo copies and sources published on multiple websites.",
  link: "http://7photos.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1293,
  name: "Panoramio",
  description: "Legacy geo-photo resource useful for location OSINT and image geotagging research.",
  link: "http://www.panoramio.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1294,
  name: "Current Location",
  description: "Geo-location reference site to check coordinates and location details for mapping and OSINT validation.",
  link: "http://current-location.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1295,
  name: "Lakako Photo Search",
  description: "Photo search engine for exploring visual content across websites to trace sources and related images.",
  link: "http://www.lakako.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1296,
  name: "CC Search",
  description: "Creative Commons search tool to find legally usable images and media for content verification and research.",
  link: "https://ccsearch.creativecommons.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1297,
  name: "CamFind App",
  description: "Mobile visual search app that identifies objects from photos—useful for OSINT field investigations.",
  link: "http://camfindapp.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1298,
  name: "RevEye Reverse Image Search",
  description: "Browser extension that enables one-click reverse image search across multiple engines like Google, Yandex & TinEye.",
  link: "https://chrome.google.com/webstore/detail/reveye-reverse-image-sear/keaaclcjhehbbapnphnmpiklalfhelgf?hl=en",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1299,
  name: "SmugMug Search",
  description: "Search SmugMug galleries to find photos, albums, and published media for OSINT image tracking.",
  link: "http://www.smugmug.com/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1300,
  name: "ImageNet",
  description: "Large-scale image dataset resource helpful for AI research, machine learning training, and visual recognition studies.",
  link: "http://image-net.org/",
  category: "Images",
  icon: "🖼️"
},

 {
  id: 1301,
  name: "Places2",
  description: "MIT Places dataset explorer to identify scene types and locations in images — useful for visual OSINT and AI-based analysis.",
  link: "http://places2.csail.mit.edu/explore.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1302,
  name: "Image Identification Project",
  description: "AI-powered image recognition tool to identify objects, places, and visual context for OSINT verification.",
  link: "https://www.imageidentify.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1303,
  name: "SauceNAO",
  description: "Reverse image search engine popular for finding image sources, reposts, and original creators (especially anime/artwork).",
  link: "https://saucenao.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1304,
  name: "Picarta",
  description: "AI-based image geolocation tool that predicts where a photo was taken using visual cues — powerful for geolocation OSINT.",
  link: "https://picarta.ai/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1305,
  name: "Webstigram",
  description: "Instagram web search interface for discovering posts, hashtags, and accounts useful for social media OSINT.",
  link: "http://websta.me/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1306,
  name: "Instagram",
  description: "Official Instagram platform for searching profiles, hashtags, places, and posts during social media investigations.",
  link: "https://www.instagram.com/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1307,
  name: "Mini Instagram",
  description: "Lightweight Instagram viewer/search tool for quickly browsing public profiles and media for OSINT purposes.",
  link: "http://mininsta.net/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1308,
  name: "Imgrab",
  description: "Instagram media extraction tool used to download and archive public Instagram content for OSINT documentation.",
  link: "https://imgrab.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1309,
  name: "Tofo.me",
  description: "Instagram profile viewer that helps analyze public profiles and content without complex navigation.",
  link: "https://tofo.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1310,
  name: "Flickr",
  description: "Photo-sharing platform often rich in metadata and geotags — useful for image-based OSINT investigations.",
  link: "https://www.flickr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1311,
  name: "Flickr Map",
  description: "Geo-map view of Flickr images to explore photos by location — helpful for geolocation investigations.",
  link: "https://www.flickr.com/map/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1312,
  name: "My Pics Map",
  description: "Map-based tool to visualize photo geolocation data and plot where pictures were taken using EXIF GPS coordinates.",
  link: "http://www.mypicsmap.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1313,
  name: "idGettr",
  description: "Utility for extracting Flickr photo IDs/user IDs to support deeper investigation and automated OSINT workflows.",
  link: "http://idgettr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1314,
  name: "Flickr Hive Mind",
  description: "Explore Flickr photos through tags and relationships to uncover related images, themes, and user content.",
  link: "http://flickrhivemind.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1315,
  name: "ExifTool",
  description: "Industry-standard metadata extraction tool to read EXIF data from images/videos (camera model, GPS, timestamps).",
  link: "http://www.sno.phy.queensu.ca/~phil/exiftool/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1316,
  name: "ExifEditor",
  description: "Online EXIF viewer/editor to inspect and modify image metadata for privacy checks and OSINT verification.",
  link: "https://exifeditor.io",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1317,
  name: "Jeffrey's Exif Viewer",
  description: "Fast EXIF metadata viewer that reveals GPS coordinates, device details, and timestamps from image files.",
  link: "http://exif.regex.info/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1318,
  name: "ExifViewer",
  description: "Simple EXIF metadata viewer for inspecting camera info, geotags, and technical metadata in images.",
  link: "http://www.exifviewer.org/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1319,
  name: "Search by Exif",
  description: "Search engine focused on EXIF metadata to locate images sharing similar camera signatures or EXIF values.",
  link: "http://www.exif-search.com/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1320,
  name: "ImgOps",
  description: "Image operations hub offering quick access to reverse image search, EXIF tools, and forensic analysis sites.",
  link: "http://imgops.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1321,
  name: "Metapicz",
  description: "Online EXIF and metadata viewer that extracts technical + GPS metadata for image investigation.",
  link: "http://metapicz.com/#landing",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1322,
  name: "JPEGsnoop",
  description: "JPEG forensic tool to analyze compression signatures and detect possible editing/tampering evidence.",
  link: "http://www.impulseadventure.com/photo/jpeg-snoop.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1323,
  name: "GeoSetter",
  description: "Photo geotagging and metadata tool to view/edit GPS data and map photo locations for OSINT work.",
  link: "http://www.geosetter.de/en/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1324,
  name: "xeuledoc - Fetch metadata about any public Google document",
  description: "Extract metadata from public Google Docs to gather author info, timestamps, and document details for OSINT.",
  link: "https://github.com/Malfrats/xeuledoc",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1325,
  name: "FotoForensics",
  description: "Image forensic analysis platform (ELA) used to detect photo manipulation, edits, and hidden compression patterns.",
  link: "http://fotoforensics.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1326,
  name: "Ghiro",
  description: "Digital image forensics tool for extracting EXIF, analyzing manipulations, and producing investigation reports.",
  link: "https://github.com/ghirensics/ghiro",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1327,
  name: "Camera Trace",
  description: "Camera serial database that helps track stolen cameras and match images to camera fingerprints in investigations.",
  link: "http://www.cameratrace.com/trace",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1328,
  name: "Online OCR",
  description: "Extract text from images using OCR — useful for reading screenshots, documents, and image-based evidence.",
  link: "http://www.free-ocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1329,
  name: "i2OCR",
  description: "OCR tool to convert images to editable text, great for extracting evidence from screenshots or scanned documents.",
  link: "http://www.i2ocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1330,
  name: "New OCR",
  description: "Online OCR platform for converting image documents into text for investigation and verification workflows.",
  link: "https://www.newocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1331,
  name: "Online OCR",
  description: "OCR website to turn images/PDF into searchable text for OSINT, verification, and documentation.",
  link: "http://www.onlineocr.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1332,
  name: "Creepy",
  description: "Geolocation OSINT tool that maps location metadata from social media and image EXIF (for ethical investigation use).",
  link: "http://www.geocreepy.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1333,
  name: "Google Videos",
  description: "Google video search engine for discovering video sources, reposts, and related content across the internet.",
  link: "https://www.google.com/videohp?gws_rd=ssl",
  category: "Google",
  icon: "🔍"
},
{
  id: 1334,
  name: "Bing Videos",
  description: "Video search engine to find video sources, duplicates, and indexed content for OSINT video investigations.",
  link: "http://www.bing.com/videos",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1335,
  name: "Vimeo Search",
  description: "Search Vimeo for videos and creators to trace content origins and verify published footage.",
  link: "https://vimeo.com/search?",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1336,
  name: "Internet Archive Videos",
  description: "Archive.org video library containing historical and public domain footage useful for OSINT verification.",
  link: "https://archive.org/details/opensource_movies",
  category: "Archives",
  icon: "📚"
},
{
  id: 1337,
  name: "Vines (D)",
  description: "Google dork to search for Vine video traces and archives using keyword-based OSINT search.",
  link: "https://www.google.com/search?q=site:vine.co+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1338,
  name: "Dogpile Web Search",
  description: "Metasearch engine combining multiple search sources to broaden OSINT web discovery results.",
  link: "http://www.dogpile.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1339,
  name: "Geo Search Tool",
  description: "Geolocation search utility for finding location-based content and mapping OSINT sources.",
  link: "http://www.geosearchtool.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1340,
  name: "blinkx Video Search",
  description: "Video search tool to explore web indexed videos and track source origin for OSINT research.",
  link: "http://www.blinkx.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1341,
  name: "Facebook Live Map",
  description: "Facebook live content map to discover streams by location and event — useful for social OSINT monitoring.",
  link: "https://www.facebook.com/livemap#",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1342,
  name: "LiveLeak",
  description: "Video hosting platform archive reference used in OSINT for older viral footage and incident media research.",
  link: "https://www.liveleak.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1343,
  name: "Metatube",
  description: "Video search and discovery engine to locate related videos and archived content for investigations.",
  link: "http://www.metatube.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1344,
  name: "Yahoo Video Search",
  description: "Yahoo video discovery/search for tracking video sources, content reposts, and references across the web.",
  link: "http://video.search.yahoo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1345,
  name: "DetURL",
  description: "Download/record online videos for investigation archiving and evidence preservation purposes.",
  link: "http://deturl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1346,
  name: "Print YouTube StoryBoard Instructions",
  description: "Guide explaining how to extract YouTube storyboard frames for video verification and frame analysis.",
  link: "http://www.labnol.org/internet/print-youtube-video/28217/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1347,
  name: "Print Storyboard from Youtube",
  description: "Bookmarklet script to extract storyboard frames from YouTube videos for frame-by-frame OSINT verification.",
  link: "https://www.youtube.com/shorts/6F5a_sb-L9Y?feature=share",
  category: "Network",
  icon: "🌐"
},
{
  id: 1348,
  name: "Frame by Frame for YouTube",
  description: "Chrome extension to view YouTube videos frame-by-frame — useful for investigations and visual evidence analysis.",
  link: "https://chrome.google.com/webstore/detail/frame-by-frame-for-youtub/elkadbdicdciddfkdpmaolomehalghio?hl=en-GB",
  category: "Google",
  icon: "🔍"
},
{
  id: 1349,
  name: "YouTube Metadata",
  description: "Tool for extracting metadata from YouTube videos (upload date, IDs, channel info) to support verification.",
  link: "http://www.amnestyusa.org/citizenevidence/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1350,
  name: "TubeChop",
  description: "Trim and clip YouTube videos into short segments for evidence sharing and focused OSINT documentation.",
  link: "http://www.tubechop.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1351,
  name: "YouTube Data Tools",
  description: "Collect and analyze YouTube data (comments, networks, channels) for social analysis and OSINT research.",
  link: "https://tools.digitalmethods.net/netvizz/youtube/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1352,
  name: "Hooktube",
  description: "Alternative YouTube viewing platform often used to access videos in restricted networks and OSINT environments.",
  link: "https://hooktube.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1353,
  name: "yasiv-youtube",
  description: "YouTube recommendation network visualizer that maps related videos for analysis and content tracing.",
  link: "https://yasiv.com/youtube",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1354,
  name: "SeeAllTheThings",
  description: "OSINT tool collection for discovering cameras, devices, and internet-connected exposure endpoints.",
  link: "https://github.com/baywolf88/seeallthethings",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1355,
  name: "Insecam",
  description: "Search engine listing publicly exposed webcams (educational awareness tool) — highlights insecure camera deployments.",
  link: "http://insecam.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1356,
  name: "EarthCam",
  description: "Public webcam streaming portal useful for location OSINT, environment monitoring, and live city exploration.",
  link: "http://www.earthcam.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1357,
  name: "GoogleDocs (D)",
  description: "Google dork to search exposed Google Docs containing keywords, leaked data, or sensitive documents.",
  link: "https://www.google.com/?q=site:docs.google.com+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1358,
  name: "GoogleDrive (D)",
  description: "Google dork to find publicly indexed Google Drive files linked to keywords, documents, and datasets.",
  link: "https://www.google.com/?q=site:drive.google.com+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1359,
  name: "Dropbox (D)",
  description: "Google dork to locate exposed Dropbox direct links and documents indexed publicly.",
  link: "https://www.google.com/?q=site:dl.dropbox.com+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1360,
  name: "Amazon AWS (D)",
  description: "Google dork to discover publicly accessible Amazon S3 objects and cloud documents by keyword search.",
  link: "https://www.google.com/search?q=site:s3.amazonaws.com+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1361,
  name: "OneDrive (D)",
  description: "Google dork to locate publicly available OneDrive links that may reveal documents, backups, or shared files.",
  link: "https://www.google.com/search?safe=off&q=site:onedrive.live.com+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1362,
  name: "Cryptome (D)",
  description: "Google dork for Cryptome — useful for searching sensitive document archives and historic leak references.",
  link: "https://www.google.com/search?q=site:cryptome.org+%3Csearchterm%3E",
  category: "Google",
  icon: "🔍"
},
{
  id: 1363,
  name: "Scribd",
  description: "Document hosting platform to discover reports, books, manuals, and PDFs for OSINT research and learning.",
  link: "https://www.scribd.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1364,
  name: "DocJax",
  description: "Document search engine that helps discover PDFs, DOCs, and online documents indexed publicly.",
  link: "http://www.docjax.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1365,
  name: "WikiLeaks Search",
  description: "Advanced WikiLeaks search tool for exploring leaked documents, cables, and public datasets for OSINT research.",
  link: "https://search.wikileaks.org/advanced",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1366,
  name: "RECAP Court Doc Repo",
  description: "Repository of U.S. court documents (PACER/RECAP) useful for legal OSINT, case tracking, and court research.",
  link: "http://archive.recapthelaw.org/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1367,
  name: "filessoo.com",
  description: "File search engine to locate publicly indexed documents and downloads across different websites.",
  link: "http://filessoo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1368,
  name: "Leaked Cables",
  description: "WikiLeaks cable archive search tool for exploring diplomatic cables and historical intelligence documents.",
  link: "https://search.wikileaks.org/plusd/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1369,
  name: "Pastebin Alerts",
  description: "Monitor paste sites for leaked keywords, credentials, and sensitive mentions using alert-based OSINT tracking.",
  link: "http://andrewmohawk.com/pasteLert/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1370,
  name: "Just Paste It",
  description: "Popular paste site used for sharing text — can be monitored in OSINT to detect leaks, dumps, and public disclosures.",
  link: "https://justpaste.it/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1371,
  name: "Pastebin OSINT Harvester",
  description: "Tool to harvest and monitor paste sites for leaked content, credentials, and sensitive data patterns.",
  link: "https://github.com/needmorecowbell/sniff-paste",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1372,
  name: "What The Font",
  description: "Identify fonts from images/screenshots — helpful in logo tracing, document analysis, and authenticity checks.",
  link: "https://www.myfonts.com/WhatTheFont/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1373,
  name: "Font Squirrel",
  description: "Font recognition and matching tool to identify fonts from images for branding, posters, and document OSINT.",
  link: "https://www.fontsquirrel.com/matcherator",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1374,
  name: "IdentiFont",
  description: "Font identification directory to recognize fonts by appearance and characteristics for investigation and design tracking.",
  link: "http://www.identifont.com/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1375,
  name: "Font Spring",
  description: "Font recognition tool to match fonts from screenshots and images for verification and brand identity research.",
  link: "https://www.fontspring.com/matcherator",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1376,
  name: "What Font Is",
  description: "AI font finder to detect typefaces from images — useful for posters, certificates, and visual OSINT analysis.",
  link: "https://www.whatfontis.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1377,
  name: "FB Email Search",
  description: "Facebook public search query to find accounts linked with an email (if publicly indexed). Useful for OSINT linking.",
  link: "https://www.facebook.com/public?query=email@gmail.com&nomc=0",
  category: "Email",
  icon: "✉️"
},
{
  id: 1378,
  name: "Recover FB Account",
  description: "Official Facebook account recovery page — useful for legitimate account restoration and security checks.",
  link: "https://www.facebook.com/login/identify?ctx=recover",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1379,
  name: "Facebook Photos by ID (M)",
  description: "Manual method to access a Facebook photo using its ID for direct lookup during investigations.",
  link: "https://www.facebook.com/photo.php?fbid=PHOTO-ID-HERE",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1380,
  name: "FB Lookup ID",
  description: "Extract Facebook profile/page numeric ID from URL — helpful for OSINT automation and link analysis.",
  link: "https://lookup-id.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1381,
  name: "FB Identify (Requires Logout)",
  description: "Facebook identify tool for searching accounts for recovery purposes (works best when logged out).",
  link: "https://www.facebook.com/login/identify",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1382,
  name: "Inflact Instagram Viewer (Anonymous)",
  description: "Anonymous Instagram viewer for browsing public posts and profiles — useful for OSINT checks without login.",
  link: "https://inflact.com/profiles/instagram-viewer/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1383,
  name: "Osintgram",
  description: "Powerful Instagram OSINT tool to gather public profile data, followers analysis, and post intelligence.",
  link: "https://github.com/Datalux/Osintgram",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1384,
  name: "Twitter Advanced Search",
  description: "Official advanced search for Twitter/X to filter posts by date, user, keywords, hashtags, and location hints.",
  link: "https://twitter.com/search-advanced",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1385,
  name: "Twitter Location Search",
  description: "Twitter/X geocode search query to find posts from a specific area — useful for location-based OSINT monitoring.",
  link: "https://twitter.com/search?q=geocode%3A36.1143855%2C-115.1727518%2C1km&src=typd",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1386,
  name: "Twitter Date Search",
  description: "Twitter/X search query example to find tweets within a specific date range for timeline investigations.",
  link: "https://twitter.com/search?q=SearchTerm%20since:2016-03-01%20until:2016-03-02",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1387,
  name: "BackTweets",
  description: "Historical tweet search tool used to find older tweets, mentions, and archived tweet references.",
  link: "http://backtweets.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1388,
  name: "Followerwonk (R)",
  description: "Twitter/X analytics platform to analyze bios, followers, and social graphs for OSINT and influence research (restricted).",
  link: "https://followerwonk.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1389,
  name: "Twopcharts",
  description: "Twitter/X analytics tool for tracking follower growth, tweet stats, and audience insights.",
  link: "http://twopcharts.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1390,
  name: "TweeterID",
  description: "Find Twitter/X user ID from username and reverse lookup — useful for OSINT automation and tool integration.",
  link: "https://tweeterid.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1391,
  name: "Tweepsect",
  description: "Analyze Twitter/X profiles with stats like posting habits, frequency, top words, and audience patterns.",
  link: "http://tweepsect.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1392,
  name: "Twitonomy",
  description: "Twitter/X analytics tool to examine tweets, retweets, engagement stats, and communication patterns.",
  link: "http://www.twitonomy.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1393,
  name: "Foller.me Analytics",
  description: "Free Twitter/X account analytics tool showing profile details, interests, activity, and engagement insights.",
  link: "https://foller.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1394,
  name: "X0rz Tweets_analyzer",
  description: "Open-source Twitter/X analyzer that processes timelines for patterns, keywords, and user behavior insights.",
  link: "https://github.com/x0rz/tweets_analyzer",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1395,
  name: "RiteTag",
  description: "Hashtag analytics tool to identify trending hashtags and improve hashtag strategy for social OSINT research.",
  link: "https://ritetag.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1396,
  name: "TAGSExplorer",
  description: "Explore Twitter/X hashtag conversations using interactive visualization for investigations and trend analysis.",
  link: "https://tags.hawksey.info/tagsexplorer/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1397,
  name: "Tweet Metadata",
  description: "PDF reference explaining tweet metadata fields — useful for investigators and forensic OSINT analysis.",
  link: "http://online.wsj.com/public/resources/documents/TweetMetadata.pdf",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1398,
  name: "Birdwatcher",
  description: "Twitter/X reconnaissance tool to collect tweets, track targets, and build datasets for OSINT analysis.",
  link: "https://github.com/michenriksen/birdwatcher",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1399,
  name: "Tinfoleak Web",
  description: "Web-based OSINT tool to analyze tweets and extract metadata like location hints, device info, and timestamps.",
  link: "http://tinfoleak.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1400,
  name: "Tinfoleak.py",
  description: "Python-based Twitter/X OSINT tool to extract metadata from tweets and build investigation-friendly reports.",
  link: "http://www.vicenteaguileradiaz.com/tools/",
  category: "OSINT Tools",
  icon: "🧰"
},

 {
  id: 1401,
  name: "DMI-TCAT",
  description: "Powerful Twitter/X data collection and analysis toolkit for researchers — useful for tracking hashtags, timelines, and OSINT datasets.",
  link: "https://github.com/digitalmethodsinitiative/dmi-tcat",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1402,
  name: "Twint",
  description: "Advanced Twitter/X OSINT scraping tool to extract tweets, users, and metadata without relying on the official API.",
  link: "https://github.com/twintproject/twint",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1403,
  name: "GeoSocial Footprint",
  description: "Maps social media location footprints to identify geo-activity patterns — helpful for location-based OSINT investigations.",
  link: "http://geosocialfootprint.com/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1404,
  name: "HEAVY.AI OmniSci Tweetmap",
  description: "Real-time tweet mapping demo used to visualize tweets geographically and analyze social activity across locations.",
  link: "https://www.heavy.ai/demos/tweetmap",
  category: "Geo",
  icon: "📍"
},
{
  id: 1405,
  name: "One Million Tweet Map",
  description: "Interactive Twitter/X map showing large-scale tweet distribution — useful for event tracking and geo-OSINT.",
  link: "http://onemilliontweetmap.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1406,
  name: "Creepy",
  description: "Geolocation OSINT tool that gathers social/image location metadata and plots it on maps for investigation analysis.",
  link: "http://www.geocreepy.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1407,
  name: "Fedica",
  description: "Social media analytics platform to understand audience location, engagement, and follower insights — great for OSINT profiling.",
  link: "https://fedica.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1408,
  name: "All My Tweets",
  description: "Twitter/X archive viewer that helps export and browse tweet history — useful for investigation evidence collection.",
  link: "https://www.allmytweets.net/connect/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1409,
  name: "Spoonbill",
  description: "Track profile changes (bio, username, location, etc.) on Twitter/X over time — great for timeline-based OSINT.",
  link: "https://spoonbill.io",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1410,
  name: "TweetVacuum",
  description: "Tweet cleanup + archive tool that can save tweets for analysis and remove unwanted tweet traces (ethical use only).",
  link: "https://github.com/T3hUb3rK1tten/TweetVacuum",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1411,
  name: "Reddit Metis",
  description: "Reddit user profiling tool showing interests, posting behavior, comment activity, and subreddit patterns for OSINT.",
  link: "https://redditmetis.com/#",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1412,
  name: "Reddit Archive",
  description: "Reddit archive search engine to access and explore older posts for research, investigations, and history tracking.",
  link: "http://www.redditarchive.com/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1413,
  name: "subreddits",
  description: "Subreddit directory and discovery tool to explore communities, topics, and keyword-based subreddit research.",
  link: "http://subreddits.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1414,
  name: "Reddit Comment History",
  description: "Reddit comment visualizer that displays comment history patterns — useful for behavioral and timeline OSINT.",
  link: "https://roadtolarissa.com/javascript/reddit-comment-visualizer/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1415,
  name: "LinkedInt - LinkedIn Recon Tool",
  description: "LinkedIn OSINT reconnaissance tool for collecting employee data, company structure, and public profile intelligence.",
  link: "https://github.com/vysec/LinkedInt",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1416,
  name: "ScrapedIn",
  description: "LinkedIn scraping tool that extracts public profile details for OSINT and professional footprint analysis.",
  link: "https://github.com/dchrastil/ScrapedIn",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1417,
  name: "InSpy",
  description: "LinkedIn enumeration tool to identify employee accounts and map organization presence for security OSINT research.",
  link: "https://github.com/leapsecurity/InSpy",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1418,
  name: "raven",
  description: "LinkedIn OSINT automation tool to gather employee listings and public information for recon operations.",
  link: "https://github.com/0x09AL/raven",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1419,
  name: "TikTok Viewer",
  description: "TikTok profile & video viewer for anonymous browsing and OSINT content discovery without login requirement.",
  link: "https://urlebird.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1420,
  name: "Treeverse",
  description: "Graph-based Bluesky social network exploration tool — useful for mapping connections and social OSINT.",
  link: "https://github.com/paulgb/Treeverse",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1421,
  name: "SteamOSINT",
  description: "Steam OSINT tool to investigate gaming profiles, usernames, public activity, and linked accounts across platforms.",
  link: "https://github.com/Frontline-Femmes/Steam-OSINT",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1422,
  name: "Myspace",
  description: "Legacy social network useful for historical OSINT, old profiles, usernames, and archived digital footprint research.",
  link: "https://myspace.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1423,
  name: "Tumblr",
  description: "Search Tumblr by tags to discover posts, blogs, and content trails useful for social media OSINT investigations.",
  link: "http://www.tumblr.com/tagged/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1424,
  name: "TheHoodUp (NSFW)",
  description: "NSFW social forum search/archive resource (useful only for niche OSINT cases and monitoring; handle carefully).",
  link: "http://thehoodup.com/board/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1425,
  name: "BlackPlanet.com - Member Find",
  description: "Member search portal for BlackPlanet to locate profiles and usernames for OSINT-based digital footprint lookup.",
  link: "http://www.blackplanet.com/user_search/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1426,
  name: "MiGente (Latino)",
  description: "MiGente member directory search for finding legacy social profiles and usernames for OSINT investigation.",
  link: "http://www.migente.com/user_search/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1427,
  name: "Asian Avenue",
  description: "Asian Avenue member finder for discovering older accounts and usernames for historical OSINT profiling.",
  link: "http://www.asianave.com/user_search/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1428,
  name: "Orkut (Brazil)",
  description: "Legacy Google Orkut reference useful for OSINT history and archived profile research (where available).",
  link: "https://orkut.google.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1429,
  name: "Odnoklassniki",
  description: "Major Russian social network used for social OSINT, profile discovery, and identity linking investigations.",
  link: "http://ok.ru/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1430,
  name: "VK",
  description: "Popular social network (VK) for user search, groups, and community OSINT investigations especially in CIS regions.",
  link: "https://vk.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1431,
  name: "Delicious",
  description: "Bookmarking platform used to discover saved links and content trails — useful for niche OSINT research.",
  link: "https://del.icio.us/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1432,
  name: "Social Searcher",
  description: "Search engine for social networks that tracks mentions, keywords, and trending conversations for OSINT monitoring.",
  link: "http://www.social-searcher.com/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1433,
  name: "Google Social Search",
  description: "Google-powered social media search mode to find posts and mentions across platforms through keyword discovery.",
  link: "http://www.social-searcher.com/google-social-search/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1434,
  name: "SocialBlade.com",
  description: "Track influencer stats and growth (YouTube, Instagram, Twitter/X etc.) for credibility checks and OSINT profiling.",
  link: "http://socialblade.com/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1435,
  name: "Talkwalker Social Media Search (R)",
  description: "Enterprise-level social listening platform for monitoring mentions, sentiment, and media intelligence (restricted features).",
  link: "https://www.talkwalker.com/social-media-analytics-search",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1436,
  name: "PinGroupie",
  description: "Pinterest search tool to explore boards, users, and pins — useful for niche OSINT discovery and digital footprint linking.",
  link: "http://pingroupie.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1437,
  name: "Google CSE for Telegram links",
  description: "Custom Google search engine focused on Telegram links/channels — powerful for Telegram OSINT discovery.",
  link: "https://cse.google.com/cse?cx=006368593537057042503:efxu7xprihg",
  category: "Google",
  icon: "🔍"
},
{
  id: 1438,
  name: "Skype Web Client",
  description: "Official Skype web platform for accessing chats and contacts — useful in digital footprint verification contexts.",
  link: "https://web.skype.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1439,
  name: "MostwantedHF",
  description: "Forum/community OSINT resource site — used to explore leaked references, investigations threads, and cyber discussions.",
  link: "http://mostwantedhf.info/index.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1440,
  name: "Skype Resolver 2019",
  description: "Legacy Skype resolver OSINT tool reference (may be outdated) — used in historical investigations and research.",
  link: "http://www.skypeipresolver.net/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1441,
  name: "Snapchat Leak Checker",
  description: "Security checker tool to verify whether Snapchat account credentials may have been exposed in leaks.",
  link: "https://lastpass.com/snapchat/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1442,
  name: "Kik Username (M)",
  description: "Manual Kik profile lookup using username — useful for messaging OSINT and account identification.",
  link: "http://kik.me/%3Cusername%3E",
  category: "Username",
  icon: "👤"
},
{
  id: 1443,
  name: "YikMap",
  description: "Maps YikYak content by location — useful for location-based social OSINT and event monitoring.",
  link: "http://yikmap.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1444,
  name: "Family Tree Now",
  description: "People search engine for public records and genealogy-style lookup — useful for identity & relationship OSINT research.",
  link: "http://www.familytreenow.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1445,
  name: "InfoFlow Public People Search In Chilean",
  description: "People search platform focused on public records in Chile — useful for regional identity OSINT investigations.",
  link: "https://infoflow.cloud/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1446,
  name: "ThatsThem",
  description: "People search tool for finding possible name/address matches and public details for identity investigations.",
  link: "https://thatsthem.com/name-address-search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1447,
  name: "ZoomInfo Directory",
  description: "Professional directory search for business contacts and employment info — useful for corporate OSINT research.",
  link: "http://www.zoominfo.com/people_directory/professional_profile/A-0-1",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1448,
  name: "Zaba Search",
  description: "People search engine for public record-based lookup (mainly US) — useful for background investigation research.",
  link: "http://www.zabasearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1449,
  name: "USSearch.com",
  description: "US people search platform offering identity lookup and background-style public information research.",
  link: "http://www.ussearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1450,
  name: "Melissa Data - People Finder (R)",
  description: "People verification and lookup tool for identity matching and contact validation (restricted features).",
  link: "http://www.melissadata.com/lookups/peoplefinder.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1451,
  name: "Advanced Background Checks",
  description: "People lookup platform that aggregates public details for OSINT background research and verification.",
  link: "https://www.advancedbackgroundchecks.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1452,
  name: "SalesMaple Contact Search",
  description: "Business contact discovery platform used for professional contact OSINT and company-based lead research.",
  link: "https://www.salesmaple.com/contacts/#!/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1453,
  name: "PeekYou",
  description: "Search people by name/username to find linked social profiles and public digital footprints.",
  link: "http://www.peekyou.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1454,
  name: "Reverse Genie People",
  description: "Reverse people lookup tool for identity discovery using phone/name-based search patterns.",
  link: "http://www.reversegenie.com/people.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1455,
  name: "Wink People Search",
  description: "People search utility listing public profiles and records — helpful for quick identity OSINT searches.",
  link: "http://itools.com/tool/wink-people-search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1456,
  name: "Radaris",
  description: "People search platform for identity lookup, contact discovery, and relationship-style public record research.",
  link: "http://radaris.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1457,
  name: "Intelius",
  description: "Public record lookup tool used for background checks and identity verification style OSINT research.",
  link: "http://www.intelius.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1458,
  name: "InfoSpace",
  description: "Search aggregation service that helps discover people-related and web footprint information from multiple sources.",
  link: "http://infospace.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1459,
  name: "Webmii",
  description: "People search engine focused on digital footprint — useful for tracking online presence across websites.",
  link: "http://webmii.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1460,
  name: "Snitch.name",
  description: "Username/people discovery site to locate identity traces and public mentions across the internet.",
  link: "http://snitch.name/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1461,
  name: "Lullar",
  description: "Search for people using usernames or email patterns to link accounts across platforms for OSINT profiling.",
  link: "http://com.lullar.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1462,
  name: "Yasni",
  description: "People search engine for finding publicly indexed profiles, mentions, and professional presence online.",
  link: "http://www.yasni.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1463,
  name: "findmypast.com",
  description: "Genealogy and public records search platform useful for historical identity OSINT and family record research.",
  link: "http://search.findmypast.com/search-world-records",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1464,
  name: "HowManyOfMe",
  description: "Name statistics tool showing how common a name is — useful for identity uniqueness checks in OSINT cases.",
  link: "http://howmanyofme.com/search/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1465,
  name: "FamilySearch.org",
  description: "Free genealogy database used for verifying family records, ancestry, and historical identity OSINT research.",
  link: "https://familysearch.org/search/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1466,
  name: "Ancestry.com",
  description: "Large genealogy and historical records platform used for relationship tracing and identity OSINT verification.",
  link: "http://search.ancestry.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1467,
  name: "Nuwber",
  description: "Public record style people lookup engine for finding name-based links, contact data, and public footprint research.",
  link: "https://nuwber.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1468,
  name: "Genealogy.com",
  description: "Genealogy lookup platform for ancestry records and family connections — helpful for historical OSINT research.",
  link: "http://www.genealogy.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1469,
  name: "My Life",
  description: "People search and reputation-style directory used to explore public identity profiles and digital footprint insights.",
  link: "https://www.mylife.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1470,
  name: "AnyWho",
  description: "Online directory / people search for basic identity lookup and public contact information discovery.",
  link: "http://www.anywho.com/whitepages",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1471,
  name: "Addresses.com",
  description: "Address and contact search directory to locate publicly indexed address/name information for OSINT validation.",
  link: "http://www.addresses.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1472,
  name: "Sorted By Name",
  description: "Name-based directory useful for searching people lists and public name references online.",
  link: "http://sortedbyname.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1473,
  name: "Cubib",
  description: "People search engine aggregating public data sources for identity lookups and profile discovery.",
  link: "https://cubib.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1474,
  name: "True People Search",
  description: "Free people search tool for name, phone, and address discovery used in OSINT identity verification.",
  link: "https://www.truepeoplesearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1475,
  name: "Fast People Search",
  description: "Quick people lookup search engine to find public details and identity traces for OSINT research.",
  link: "https://www.fastpeoplesearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1476,
  name: "IDCrawl",
  description: "Search for people across social platforms using usernames and profile traces — useful for digital footprint OSINT.",
  link: "https://www.idcrawl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1477,
  name: "The Knot",
  description: "Registry search platform (wedding registries) useful for locating public registry profiles in OSINT cases.",
  link: "https://www.theknot.com/registry/couplesearch",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1478,
  name: "Registry Finder",
  description: "Multi-registry search tool to locate public wedding/baby registries and related identity information.",
  link: "https://www.registryfinder.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1479,
  name: "My Registry",
  description: "Universal gift registry search tool for locating public registry entries and profile details.",
  link: "https://www.myregistry.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1480,
  name: "Amazon Registry Search",
  description: "Amazon registry lookup tool for public gift registries — useful for OSINT profile linking and verification.",
  link: "https://www.amazon.com/gp/registry/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1481,
  name: "Bed, Bath, & Beyond Gift Registry",
  description: "Gift registry search page used to locate public registries and identity references for OSINT research.",
  link: "https://www.bedbathandbeyond.com/store/giftregistry/registry_search_guest.jsp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1482,
  name: "The Bump",
  description: "Baby registry lookup platform useful for searching public registry entries and identity verification research.",
  link: "https://registry.thebump.com/babyregistrysearch",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1483,
  name: "Match.com",
  description: "Dating platform reference — used in OSINT for username/profile discovery where information is publicly available.",
  link: "http://www.match.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1484,
  name: "AYI.com",
  description: "Dating network lookup reference useful for checking public profiles and identity traces across dating platforms.",
  link: "https://www.ayi.com/index.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1485,
  name: "Plenty Of Fish.com",
  description: "Dating platform reference used for social footprint verification and username discovery investigations.",
  link: "http://www.pof.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1486,
  name: "eHarmony",
  description: "Dating platform used in OSINT only for public-profile tracing and username-based identity research.",
  link: "http://www.eharmony.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1487,
  name: "Farmers Only",
  description: "Dating platform reference for niche identity lookup scenarios using public OSINT methods.",
  link: "http://www.farmersonly.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1488,
  name: "Zoosk",
  description: "Dating platform reference used for locating public profile traces and performing username OSINT checks.",
  link: "https://www.zoosk.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1489,
  name: "OkCupid",
  description: "Dating platform reference for public footprint discovery and identity correlation investigations.",
  link: "https://www.okcupid.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1490,
  name: "Tinder (R)",
  description: "Dating platform reference (restricted) used for identity verification and OSINT checks where legally allowed.",
  link: "https://tinder.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1491,
  name: "Wamba.com",
  description: "Dating/social platform reference used in OSINT for public profile lookups and identity linking.",
  link: "http://wamba.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1492,
  name: "AdultFriendFinder",
  description: "Adult dating platform reference for niche OSINT tracing (only for lawful investigations and safe handling).",
  link: "http://adultfriendfinder.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1493,
  name: "Ashley Madison",
  description: "Dating platform reference used for OSINT identity trace lookups in specific investigations (lawful use only).",
  link: "https://www.ashleymadison.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1494,
  name: "BeautifulPeople.com",
  description: "Dating/social platform reference used for public OSINT searches and username discovery scenarios.",
  link: "https://www.beautifulpeople.com/en-US",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1495,
  name: "Badoo",
  description: "Dating and social discovery platform used in OSINT for public profile and username footprint checks.",
  link: "https://badoo.us/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1496,
  name: "Spark.com",
  description: "Social/dating platform reference used for public identity tracing and profile discovery investigations.",
  link: "https://www.spark.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1497,
  name: "Meetup",
  description: "Community events platform useful for OSINT: identify groups, event participation, member interests, and activity trails.",
  link: "http://www.meetup.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1498,
  name: "BlackPeopleMeet",
  description: "Dating/community platform reference used for OSINT profile tracing and username-based searches (public info only).",
  link: "http://www.blackpeoplemeet.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1499,
  name: "Bumble",
  description: "Dating platform reference used for OSINT investigations only through ethical/publicly available information.",
  link: "https://bumble.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1500,
  name: "Hinge",
  description: "Dating platform reference used in OSINT for footprint linking and identity validation where public information exists.",
  link: "https://hinge.co/en-gb",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1501,
  name: "Slydial",
  description: "Voicemail drop service that can deliver a message directly to voicemail without ringing — useful for lawful outreach and verification workflows.",
  link: "https://www.slydial.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1502,
  name: "Numbering Plans",
  description: "International phone number intelligence tool to analyze numbering plans, country codes, and telecom metadata.",
  link: "https://www.numberingplans.com/?page=analysis&sub=phonenr",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1503,
  name: "Numberway",
  description: "Global telephone directory search platform for locating publicly available phone-related information across countries.",
  link: "https://www.numberway.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1504,
  name: "WhoCalld",
  description: "Caller identification and reverse lookup style site to research unknown phone numbers and spam reports.",
  link: "https://whocalld.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1505,
  name: "411",
  description: "Reverse phone lookup directory to search publicly listed phone details and possible owner information.",
  link: "http://www.411.com/reverse_phone",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1506,
  name: "CallerID Test",
  description: "Tool to test caller ID behavior and number presentation — useful for telecom validation and research.",
  link: "http://www.calleridtest.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1507,
  name: "ThatsThem - Reverse Phone Lookup",
  description: "Reverse phone lookup tool that helps identify possible owner details and associated public records.",
  link: "https://thatsthem.com/reverse-phone-lookup",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1508,
  name: "Twilio Lookup",
  description: "Phone number intelligence lookup by Twilio — reveals carrier, line type, and validation data via number analysis.",
  link: "https://www.twilio.com/lookup",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1509,
  name: "Fone Finder",
  description: "Phone number prefix lookup service to identify carrier, city/state region, and number assignment information.",
  link: "http://www.fonefinder.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1510,
  name: "True Caller",
  description: "Popular caller identification service used to identify unknown callers and spam numbers using public + community reports.",
  link: "http://www.truecaller.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1511,
  name: "Reverse Genie",
  description: "Reverse phone lookup directory to find possible owner name/location information from publicly available records.",
  link: "http://www.reversegenie.com/phone.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1512,
  name: "SpyDialer",
  description: "Reverse phone lookup tool used to identify unknown numbers and access publicly listed caller details.",
  link: "http://www.spydialer.com/default.aspx",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1513,
  name: "Phone Validator",
  description: "Phone number validation tool to verify phone format, region, and number status (active/valid pattern checks).",
  link: "http://www.phonevalidator.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1514,
  name: "Free Carrier Lookup",
  description: "Carrier lookup service to identify telecom operator of a phone number and check line type information.",
  link: "http://freecarrierlookup.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1515,
  name: "Mr. Number (M)",
  description: "Manual Mr. Number lookup reference for spam call detection and phone-based OSINT verification.",
  link: "http://mrnumber.com/1-888-742-0000",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1516,
  name: "CallerIDService.com (R)",
  description: "Caller ID lookup service offering number intelligence and phone verification features (restricted/paid).",
  link: "http://www.calleridservice.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1517,
  name: "Next Caller (R)",
  description: "Phone number enrichment platform offering identity and caller insights for verification and fraud prevention (restricted).",
  link: "https://nextcaller.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1518,
  name: "Data24-7 (R)",
  description: "Phone and contact data validation platform used for telecom verification and identity enrichment services (restricted).",
  link: "https://www.data24-7.com/signup.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1519,
  name: "HLR Lookup Portal (R)",
  description: "HLR lookup portal to check mobile number status, country/operator, and routing information (restricted features).",
  link: "https://www.hlr-lookups.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1520,
  name: "OpenCNAM",
  description: "Caller name (CNAM) lookup service used to identify business/person names associated with phone numbers.",
  link: "https://www.opencnam.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1521,
  name: "OpenCNAM API",
  description: "API endpoint for OpenCNAM to perform automated CNAM lookups and integrate caller-name intelligence in apps.",
  link: "http://api.opencnam.com/v2/phone/+19073372323",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1522,
  name: "USPhoneBook",
  description: "US reverse phone and address directory to find public records linked to phone numbers.",
  link: "https://www.usphonebook.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1523,
  name: "Numspy-Api",
  description: "Phone intelligence API that provides number lookup information for verification and OSINT research.",
  link: "https://numspy.pythonanywhere.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1524,
  name: "Melissa Data - Property Viewer (R)",
  description: "Property lookup and verification tool for searching address-related public property intelligence (restricted).",
  link: "http://www.melissadata.com/lookups/propertyviewer.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1525,
  name: "Regrid (US Only)",
  description: "US property map and parcel data platform useful for land/property OSINT and location-based research.",
  link: "https://app.regrid.com/us/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1526,
  name: "Zillow",
  description: "Real-estate search platform that provides property details, valuations, and listing history useful for OSINT.",
  link: "http://www.zillow.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1527,
  name: "Emporis",
  description: "Building and architecture database for researching high-rise buildings and property details for OSINT.",
  link: "https://www.emporis.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1528,
  name: "Homefacts",
  description: "Property and neighborhood info lookup service useful for public record OSINT and location context research.",
  link: "https://www.homefacts.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1529,
  name: "Neighbor Report",
  description: "Neighborhood intelligence and public property insights platform — useful for location-based OSINT profiling.",
  link: "https://neighbor.report/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1530,
  name: "Redfin",
  description: "Real estate platform providing listing history, property insights, and neighborhood data useful for research.",
  link: "https://www.redfin.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1531,
  name: "Nationwide County Court Records",
  description: "Directory of US county court records resources — useful for finding case lookup portals and court data sources.",
  link: "http://www.blackbookonline.info/USA-County-Court-Records.aspx",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1532,
  name: "World Legal Information Institute",
  description: "Global legal database offering access to laws, cases, and legal resources across countries.",
  link: "http://worldlii.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1533,
  name: "Canadian Legal Information Institute",
  description: "Free Canadian legal database providing access to court judgments, legislation, and legal information.",
  link: "http://www.canlii.org/en/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1534,
  name: "Most Wanted Criminal Pages",
  description: "Public listing resource that aggregates wanted/criminal pages for research and awareness purposes.",
  link: "http://ancestorhunt.com/most-wanted-criminals-and-fugitives.htm",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1535,
  name: "Black Book Online - Criminal Search",
  description: "Public records directory linking to criminal and court record search resources across US jurisdictions.",
  link: "http://www.blackbookonline.info/criminalsearch.aspx",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1536,
  name: "CrimeReports.com",
  description: "Crime reporting and mapping platform that visualizes incidents in different areas for public safety OSINT.",
  link: "https://www.crimereports.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1537,
  name: "Familywatchdog - Sex Offender Search",
  description: "Search platform for sex offender registry-style lookup to support public safety awareness and lawful research.",
  link: "http://www.familywatchdog.us/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1538,
  name: "Felon Spy",
  description: "Criminal record lookup tool (varies by region) used for checking offender information via public databases.",
  link: "http://www.felonspy.com/search.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1539,
  name: "The Inmate Locator",
  description: "Inmate lookup directory that helps locate prisoner records in various correctional systems (public data).",
  link: "http://www.theinmatelocator.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1540,
  name: "Criminal Searches",
  description: "Criminal record search and public record lookup directory for lawful investigation and verification research.",
  link: "http://www.criminalsearches.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1541,
  name: "National Sex Offender Search",
  description: "Official US national sex offender public website for searching registries legally and responsibly.",
  link: "https://www.nsopw.gov/en/Search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1542,
  name: "Mugshots.com",
  description: "Mugshot and arrest record style directory (data quality varies) used for public record OSINT research.",
  link: "http://mugshots.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1543,
  name: "judyrecords",
  description: "Massive legal records search engine for discovering court cases and legal filings across multiple sources.",
  link: "https://www.judyrecords.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1544,
  name: "Caselaw Access Project",
  description: "Open access legal research project providing digitized case law datasets for analysis and investigations.",
  link: "https://case.law/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1545,
  name: "CourtListener",
  description: "Legal search engine and alerts platform for court opinions, dockets, and federal case research.",
  link: "https://www.courtlistener.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1546,
  name: "Docket Alarm",
  description: "Court docket search platform providing access to case details and alerts for legal OSINT tracking.",
  link: "https://www.docketalarm.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1547,
  name: "Google Scholar Case Law",
  description: "Google Scholar’s legal search for case law and court opinions — useful for research and citations.",
  link: "https://scholar.google.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1548,
  name: "PACER",
  description: "Official US federal court records system used to access dockets and documents (registration required).",
  link: "https://pacer.uscourts.gov/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1549,
  name: "Free Law RECAP Archive",
  description: "RECAP archive by Free Law Project that provides access to many court documents without PACER fees.",
  link: "https://www.courtlistener.com/recap/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1550,
  name: "UniCourt",
  description: "Court record search platform covering multiple US jurisdictions — useful for case research and litigation tracking.",
  link: "https://unicourt.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1551,
  name: "Federal Inmate Locator",
  description: "Official US Bureau of Prisons inmate locator for searching federal prisoner records lawfully.",
  link: "https://www.bop.gov/inmateloc/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1552,
  name: "NC Salary DB",
  description: "Government salary database resource useful for transparency research and public employee pay OSINT.",
  link: "http://www.newsobserver.com/news/databases/state-pay/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1553,
  name: "Gov Data Canada",
  description: "Public data aggregation portal for Canadian government datasets useful for research and policy OSINT.",
  link: "https://govdataca.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1554,
  name: "CA Salary DB",
  description: "Public salary database resource for California state pay transparency and public record OSINT research.",
  link: "http://www.sacbee.com/site-services/databases/state-pay/article2642161.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1555,
  name: "BIN Base",
  description: "BIN database lookup tool to identify bank issuer information using payment card BIN/IIN number prefixes.",
  link: "http://www.binbase.com/search.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1556,
  name: "VAT Research",
  description: "VAT lookup and validation resource for company verification and tax-related business OSINT investigations.",
  link: "https://vat-search.eu/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1557,
  name: "NETR Online",
  description: "Public records directory for US counties including tax, property, and government record searches.",
  link: "http://publicrecords.netronline.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1558,
  name: "Sorted by Birth Date",
  description: "Birth date indexed directory resource useful for demographic research and open public record exploration.",
  link: "http://sortedbybirthdate.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1559,
  name: "Death Check",
  description: "Death record validation service used for matching identity records and fraud prevention verification (restricted).",
  link: "http://www.melissadata.com/lookups/deathcheck.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1560,
  name: "Find A Grave",
  description: "Grave and memorial search platform used for genealogy research and historical identity verification.",
  link: "http://www.findagrave.com/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1561,
  name: "GraveInfo",
  description: "Grave records and memorial information directory for genealogy and historical OSINT research.",
  link: "http://www.graveinfo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1562,
  name: "NACo County Explorer",
  description: "US county data explorer by NACo — useful for demographic, governance, and regional OSINT research.",
  link: "http://explorer.naco.org/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1563,
  name: "Voter Records",
  description: "Voter record lookup platform (region dependent) used for identity verification and public record research.",
  link: "https://voterrecords.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1564,
  name: "Voter Registration Data",
  description: "Public records directory pointing to voter registration resources across US states and counties.",
  link: "http://www.blackbookonline.info/USA-Voter-Records.aspx",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1565,
  name: "US Patent Office Search",
  description: "Official USPTO patent search portal for finding patents, inventors, and company filings.",
  link: "https://www.uspto.gov/patents/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1566,
  name: "Google Patent Search",
  description: "Google patent search tool to explore patents, inventors, and technical filings using advanced filters.",
  link: "https://www.google.com/advanced_patent_search",
  category: "Google",
  icon: "🔍"
},
{
  id: 1567,
  name: "FollowTheMoney.org",
  description: "Political contribution transparency database useful for tracking donors, funding flows, and political finance OSINT.",
  link: "http://www.followthemoney.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1568,
  name: "OpenSecrets.org",
  description: "Political finance tracking platform that provides lobbying, spending, and contribution intelligence for OSINT.",
  link: "http://www.opensecrets.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1569,
  name: "Political MoneyLine",
  description: "Political fundraising tracking platform useful for monitoring political finance and contribution datasets.",
  link: "http://www.politicalmoneyline.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1570,
  name: "MelissaData - Campaign Contributions",
  description: "Campaign contribution lookup tool used for political finance research and validation checks (restricted).",
  link: "http://www.melissadata.com/lookups/fec.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1571,
  name: "Influence Explorer",
  description: "Transparency dataset explorer to research political influence, contributions, and lobbying connections.",
  link: "http://data.influenceexplorer.com/#",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1572,
  name: "US Federal Election Commission",
  description: "Official FEC portal offering campaign finance data, filings, and disclosures for political OSINT research.",
  link: "http://www.fec.gov/finance/disclosure/norindsea.shtml",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1573,
  name: "Every Politician",
  description: "Open political dataset project providing structured politician records useful for research and OSINT analysis.",
  link: "http://everypolitician.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1574,
  name: "Public Records?",
  description: "Directory for searching public records across categories like people, courts, property, and government databases.",
  link: "http://publicrecords.searchsystems.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1575,
  name: "The World Bank Open Data Catalog",
  description: "Official World Bank open datasets catalog for global economics, development, and policy OSINT research.",
  link: "http://datacatalog.worldbank.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1576,
  name: "BRB Public Records",
  description: "Public records directory providing access to databases and search sources across different categories.",
  link: "http://www.brbpub.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1577,
  name: "GOVDATA - Das Datenportal für Deutschland (German)",
  description: "Germany’s government open data portal offering datasets for research, mapping, and public record OSINT.",
  link: "https://www.govdata.de/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1578,
  name: "Open-Data-Portal München (German)",
  description: "Munich open data portal providing local government datasets for city-level OSINT and public data research.",
  link: "https://www.opengov-muenchen.de/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1579,
  name: "AnnualReports.com",
  description: "Database of company annual reports — useful for business OSINT, financial insights, and corporate research.",
  link: "http://www.annualreports.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1580,
  name: "Public Register Online",
  description: "Company report and annual filings directory used to find corporate reports and business public records.",
  link: "http://www.annualreportservice.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1581,
  name: "Public Register's Annual Report Service",
  description: "Annual report search service for public companies — useful for financial OSINT and corporate filings research.",
  link: "http://www.prars.com/search/alpha/A",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1582,
  name: "International Registries",
  description: "UK government resource listing overseas registries — useful for international company verification OSINT.",
  link: "https://www.gov.uk/government/publications/overseas-registries/overseas-registries",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1583,
  name: "Businessweek Search",
  description: "Business profile and market research lookup tool for exploring companies, financials, and stock symbols.",
  link: "http://investing.businessweek.com/research/common/symbollookup/symbollookup.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1584,
  name: "Corporation Wiki",
  description: "Corporate intelligence platform that maps people-company relationships, corporate ownership, and business connections.",
  link: "http://www.corporationwiki.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1585,
  name: "Commercial Register - Worldwide",
  description: "Worldwide commercial register directory used to locate business registries and corporate verification resources.",
  link: "http://www.commercial-register.sg.ch/home/worldwide.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1586,
  name: "SEC.gov - EDGAR",
  description: "Official SEC EDGAR database to access public company filings like 10-K, 10-Q, S-1, and disclosures.",
  link: "http://www.sec.gov/edgar.shtml",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1587,
  name: "International White Pages",
  description: "International directory resource for locating public phone/address listings across different countries.",
  link: "http://www.wayp.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1588,
  name: "UK Companies",
  description: "Official UK Companies House search portal to verify UK company registration, directors, and filings.",
  link: "https://www.gov.uk/get-information-about-a-company",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1589,
  name: "Global EDGE Resource Directory",
  description: "Global business resources directory covering international markets, company data, and economic information.",
  link: "http://globaledge.msu.edu/global-resources",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1590,
  name: "Ripoff Report",
  description: "Consumer complaint reporting site useful for reputation OSINT and fraud/scam research (verify credibility carefully).",
  link: "http://www.ripoffreport.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1591,
  name: "Google Finance",
  description: "Financial market tool by Google to research companies, stock performance, news, and market trends.",
  link: "https://www.google.com/finance",
  category: "Google",
  icon: "🔍"
},
{
  id: 1592,
  name: "OpenCorporates",
  description: "One of the largest open databases of companies worldwide — useful for global business OSINT and verification.",
  link: "https://opencorporates.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1593,
  name: "Corporation Wiki",
  description: "Business intelligence directory showing leadership, ownership links, and company relationship mapping.",
  link: "https://www.corporationwiki.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1594,
  name: "Data.com Connect",
  description: "Business contacts platform used for professional network and contact discovery (may require access).",
  link: "https://connect.data.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1595,
  name: "ZoomInfo.com",
  description: "Business directory and company intelligence platform for contact discovery and corporate profiling.",
  link: "http://www.zoominfo.com/company-directory/us",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1596,
  name: "Kompass International",
  description: "International business directory used to find company profiles, industries, addresses, and contact information.",
  link: "http://www.kompass.com/selectcountry/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1597,
  name: "Infobel",
  description: "Global business directory for discovering companies, contact details, and regional business information.",
  link: "http://www.infobel.com/en/world/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1598,
  name: "AIHIT",
  description: "Company and organization information directory used for business OSINT research and corporate profiling.",
  link: "https://www.aihitdata.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1599,
  name: "Plonked",
  description: "Company data and business information lookup resource for discovering organization details online.",
  link: "https://www.plonked.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1600,
  name: "Buzzfile",
  description: "Small business directory providing company profiles, industries, addresses, and contact details for OSINT.",
  link: "http://www.buzzfile.com/Home/Basic",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1601,
  name: "LittleSis",
  description: "Database of political and corporate connections — maps relationships between people, orgs, and power networks.",
  link: "http://littlesis.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1602,
  name: "Companies House",
  description: "Official UK company registry providing filings, directors, shareholders, and company verification details.",
  link: "https://beta.companieshouse.gov.uk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1603,
  name: "Hoovers",
  description: "Business intelligence and company research platform for corporate profiling and market research.",
  link: "http://www.hoovers.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1604,
  name: "Corporate Information",
  description: "Worldwide corporate information directory useful for company background research and financial OSINT.",
  link: "http://corporateinformation.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1605,
  name: "Company Data Rex (EU)",
  description: "European company data directory that helps find business records, registration information, and corporate details.",
  link: "http://cdrex.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1606,
  name: "Europages",
  description: "B2B directory for European companies — useful for supplier lookup, company profiling, and verification research.",
  link: "http://www.europages.co.uk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1607,
  name: "Glassdoor Company Reviews",
  description: "Company reviews and salary insights platform — useful for reputation OSINT and employee experience research.",
  link: "https://www.glassdoor.com/Reviews/index.htm",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1608,
  name: "Owler (R)",
  description: "Company insights platform offering competitor research, revenue estimates, and business intelligence (restricted).",
  link: "https://www.owler.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1609,
  name: "Vault",
  description: "Career and company research platform providing employer guides, rankings, and workplace intelligence.",
  link: "http://www.vault.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1610,
  name: "Companies In The UK",
  description: "UK company directory offering search and company profile discovery for OSINT and business verification.",
  link: "https://www.companiesintheuk.co.uk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1611,
  name: "UK Companies list",
  description: "UK company listing platform used for company discovery, business search, and profile OSINT research.",
  link: "https://www.companieslist.co.uk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1612,
  name: "UK Data",
  description: "UK business directory to lookup companies and basic public business information for OSINT verification.",
  link: "http://ukdata.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1613,
  name: "Orbis Directory",
  description: "Worldwide company directory by BvD used for corporate verification, ownership research, and business OSINT.",
  link: "https://orbisdirectory.bvdinfo.com/version-2016121/OrbisDirectory/Companies",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1614,
  name: "Manta Small Business Directory",
  description: "US small business directory containing business profiles, categories, and contact information for research.",
  link: "https://www.manta.com/business-directory",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1615,
  name: "Crunchbase",
  description: "Startup and company intelligence platform providing funding info, investors, acquisitions, and growth data.",
  link: "https://www.crunchbase.com/#/home/index",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1616,
  name: "RecruitEm",
  description: "Recruiting and OSINT search tool that generates advanced queries to find employee profiles and resumes online.",
  link: "http://recruitin.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1617,
  name: "LinkedIn",
  description: "Professional network platform used for OSINT: employee profiling, company research, and career history discovery.",
  link: "https://www.linkedin.com/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1618,
  name: "Jobster",
  description: "Job and career listing platform reference useful for resume discovery and employment OSINT research.",
  link: "http://www.jobster.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1619,
  name: "XING (R)",
  description: "Professional networking platform (Europe-focused) useful for employee profiling and resume OSINT (restricted).",
  link: "https://www.xing.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1620,
  name: "Indeed",
  description: "Job search engine useful for finding resumes, company hiring trends, job postings, and workforce OSINT.",
  link: "http://www.indeed.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1621,
  name: "CVGadget",
  description: "Resume and CV search platform used to discover candidate profiles and career details for research.",
  link: "http://www.cvgadget.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1622,
  name: "RBA - Business Information Resources",
  description: "Business information resource directory containing links to company databases and corporate research tools.",
  link: "http://www.rba.co.uk/sources/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1623,
  name: "VAT Number Validation",
  description: "Official EU VIES VAT validation portal used to verify VAT registration details for company legitimacy checks.",
  link: "http://ec.europa.eu/taxation_customs/vies/?locale=en",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1624,
  name: "Vehicle Purchase Records",
  description: "VIN-based vehicle information lookup tool useful for vehicle history research and OSINT verification.",
  link: "http://vin.place/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1625,
  name: "VIN Decoderz",
  description: "VIN decoder tool to check vehicle manufacturing details, model specs, and basic identity information.",
  link: "http://www.vindecoderz.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1626,
  name: "That's Them VIN Search",
  description: "VIN search tool that helps find vehicle-related public information and history references.",
  link: "https://thatsthem.com/vin-search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1627,
  name: "Reverse Genie License Plates",
  description: "License plate lookup tool reference for vehicle record OSINT and identity verification research.",
  link: "http://www.reversegenie.com/plate.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1628,
  name: "VinCheck",
  description: "NICB VINCheck tool to verify whether a vehicle is reported stolen or has salvage records (official resource).",
  link: "https://www.nicb.org/theft_and_fraud_awareness/vincheck",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1629,
  name: "TRAVIC - Public Transportation Tracking",
  description: "Live transport tracking tool for monitoring public transportation movements and real-time location analysis.",
  link: "http://tracker.geops.ch/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1630,
  name: "Vehicle Specifications Lookup",
  description: "Vehicle data lookup service used for investigating car specs, configuration details, and model information.",
  link: "https://berla.co/products/ive/vehicle-lookup/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1631,
  name: "License Plate Search",
  description: "License plate lookup reference for vehicle history research and OSINT verification (availability varies by region).",
  link: "https://www.vehiclehistory.com/licence-plate-search/licence-plate.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1632,
  name: "FlightAware - Live Flight Tracker",
  description: "Live flight tracking platform for monitoring aircraft movements, routes, and air traffic history.",
  link: "http://flightaware.com/live/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1633,
  name: "Flightradar24.com",
  description: "Global aircraft tracking service showing live flight positions, aircraft info, and route history for OSINT.",
  link: "https://www.flightradar24.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1634,
  name: "World Aeronautical Database",
  description: "Aeronautical data directory for researching airports, aviation data, and flight-related OSINT information.",
  link: "http://worldaerodata.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1635,
  name: "ADS-B Exchange",
  description: "Crowdsourced aircraft tracking platform using ADS-B data — popular OSINT source for aviation monitoring.",
  link: "https://www.adsbexchange.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1636,
  name: "ADS-B.NL",
  description: "ADS-B aircraft tracking site to monitor planes, live data feeds, and aviation-related OSINT insights.",
  link: "https://www.ads-b.nl/index.php?pageno=9999",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1637,
  name: "Marine Traffic",
  description: "Live ship tracking platform showing vessel location, routes, and port activity useful for maritime OSINT.",
  link: "http://www.marinetraffic.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1638,
  name: "Vessel Tracker",
  description: "Maritime intelligence platform used for tracking ships, cargo movement, and vessel history.",
  link: "http://www.vesseltracker.com/app",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1639,
  name: "Ship AIS",
  description: "Ship AIS tracking platform to monitor vessel location, identity, and movement patterns.",
  link: "http://www.shipais.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1640,
  name: "Shodan Ship Tracker",
  description: "Shodan-powered ship tracker that uses AIS data to visualize maritime movement for OSINT investigations.",
  link: "https://shiptracker.shodan.io/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1641,
  name: "OpenSeaMap - The free nautical chart",
  description: "Open nautical mapping platform for researching maritime routes, ports, and coastal navigation data.",
  link: "http://www.openseamap.org",
  category: "Geo",
  icon: "📍"
},
{
  id: 1642,
  name: "Vessel Finder",
  description: "Vessel tracking tool for searching ships by name/IMO and viewing real-time maritime position history.",
  link: "https://www.vesselfinder.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1643,
  name: "Deutsche Bahn Open-Data-Portal (German)",
  description: "German railway open data portal providing transportation datasets for research and mobility OSINT.",
  link: "http://data.deutschebahn.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1644,
  name: "OpenRailwayMap",
  description: "Interactive railway mapping project visualizing rail lines and infrastructure data worldwide.",
  link: "https://www.openrailwaymap.org/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1645,
  name: "Transportation & Train Tracking",
  description: "Mobility tracking portal to monitor public transport movements and analyze route activity in real-time.",
  link: "https://mobility.portal.geops.io/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1646,
  name: "Satellite Tracking",
  description: "Satellite tracking tool to monitor satellite positions, passes, orbits, and space activity.",
  link: "http://www.n2yo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1647,
  name: "Track-Trace",
  description: "Global logistics and shipment tracking directory for couriers and parcel tracking research.",
  link: "http://www.track-trace.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1648,
  name: "Astrometry",
  description: "Astronomy image solver that identifies star fields to determine location/orientation — useful for advanced geolocation OSINT.",
  link: "https://nova.astrometry.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1649,
  name: "SunCalc",
  description: "Sun position and shadow analysis tool for estimating direction/time — widely used in photo/video geolocation OSINT.",
  link: "http://suncalc.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1650,
  name: "GPSVisualizer",
  description: "Convert and visualize GPS coordinates on maps — useful for mapping investigations and location OSINT reports.",
  link: "http://www.gpsvisualizer.com/geocode",
  category: "Geo",
  icon: "📍"
},
{
  id: 1651,
  name: "Military Grid Reference System Coordinates",
  description: "MGRS coordinate conversion tool used in tactical mapping and precise geolocation investigations.",
  link: "https://dominoc925-pages.appspot.com/mapplets/cs_mgrs.html",
  category: "Geo",
  icon: "📍"
},
{
  id: 1652,
  name: "Batch Geocoding",
  description: "Bulk geocoding tool to convert multiple addresses into latitude/longitude for map-based OSINT analysis.",
  link: "https://www.doogal.co.uk/BatchGeocoding.php",
  category: "Geo",
  icon: "📍"
},
{
  id: 1653,
  name: "Batch Reverse Geocoding",
  description: "Bulk reverse geocoding tool to convert coordinates into addresses — useful for large OSINT datasets.",
  link: "https://www.doogal.co.uk/BatchReverseGeocoding.php",
  category: "Geo",
  icon: "📍"
},
{
  id: 1654,
  name: "BatchGeo",
  description: "Map reporting tool to plot addresses/locations in bulk and generate shareable location intelligence reports.",
  link: "https://batchgeo.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1655,
  name: "Hyperlapse",
  description: "JavaScript library to generate hyperlapse animations from map/street imagery for location storytelling and reporting.",
  link: "https://github.com/TeehanLax/Hyperlapse.js",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1656,
  name: "Teehan+Lax Labs - Hyperlapse",
  description: "Hyperlapse demo platform for creating motion-style streetview animations useful for geo reporting.",
  link: "http://labs.teehanlax.com/project/hyperlapse",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1657,
  name: "Google Maps Streetview Player",
  description: "Street View playback tool used for simulating travel paths and building geo-visual OSINT reports.",
  link: "http://brianfolts.com/driver/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1658,
  name: "ScribbleMaps",
  description: "Map drawing and annotation tool to create custom OSINT reports with pins, routes, shapes, and labels.",
  link: "http://scribblemaps.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1659,
  name: "OpenSignal",
  description: "Mobile network coverage intelligence platform showing signal quality and coverage maps by carrier.",
  link: "https://opensignal.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1660,
  name: "AntennaSearch",
  description: "Cell tower and antenna location lookup tool used for telecom OSINT and infrastructure discovery.",
  link: "http://www.antennasearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1661,
  name: "Google Maps",
  description: "Most widely used mapping platform for location search, directions, satellite imagery, and geolocation OSINT.",
  link: "https://www.google.com/maps/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1662,
  name: "Bing Maps",
  description: "Mapping platform by Microsoft offering satellite imagery and navigation useful for alternative geo-OSINT analysis.",
  link: "http://www.bing.com/maps/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1663,
  name: "HERE Maps",
  description: "Location mapping platform with route planning and navigation features useful for geolocation research.",
  link: "https://maps.here.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1664,
  name: "Dual Maps",
  description: "Compare multiple map layers side-by-side (satellite/road) — helpful for geolocation OSINT verification.",
  link: "http://data.mashedworld.com/dualmaps/map.htm",
  category: "Geo",
  icon: "📍"
},
{
  id: 1665,
  name: "Instant Google Street View",
  description: "Quick Street View access tool for exploring locations instantly — useful for geo OSINT confirmation.",
  link: "http://www.instantstreetview.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1666,
  name: "Wikimapia",
  description: "Community-mapped location platform useful for identifying landmarks, buildings, and local place intelligence.",
  link: "http://wikimapia.org/#lang=en&lat=40.078071&lon=-100.458984&z=5&m=b",
  category: "Geo",
  icon: "📍"
},
{
  id: 1667,
  name: "OpenStreetMap",
  description: "Open-source world map used widely in OSINT for roads, landmarks, layers, and community geographic data.",
  link: "http://www.openstreetmap.org/#map=5/40.614/-100.679",
  category: "Geo",
  icon: "📍"
},
{
  id: 1668,
  name: "Flash Earth",
  description: "Satellite imagery viewer offering aerial map layers for fast location visualization and geo OSINT.",
  link: "http://www.flashearth.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1669,
  name: "Historic Aerials",
  description: "Historical satellite and aerial imagery platform useful for timeline-based location change investigations.",
  link: "http://www.historicaerials.com/?javascript=&",
  category: "Network",
  icon: "🌐"
},
{
  id: 1670,
  name: "Google Maps Update Alerts",
  description: "Alert tool to track changes in Google Maps areas — useful for monitoring places or regions over time.",
  link: "https://followyourworld.appspot.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1671,
  name: "Google Earth Overlays",
  description: "KML overlay resource for Google Earth to add layers and enhanced mapping data for OSINT visualization.",
  link: "http://www.mgmaps.com/kml/#view",
  category: "Google",
  icon: "🔍"
},
{
  id: 1672,
  name: "Yandex.Maps",
  description: "Mapping platform by Yandex offering strong regional imagery — useful for alternate geo OSINT verification.",
  link: "https://yandex.com/maps/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1673,
  name: "Google Earth",
  description: "Satellite imagery and 3D mapping platform used for deep geolocation OSINT and location history analysis.",
  link: "https://www.google.com/earth/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1674,
  name: "Baidu Maps",
  description: "Chinese mapping platform useful for researching and verifying locations within China in OSINT work.",
  link: "http://map.baidu.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1675,
  name: "Corona",
  description: "Remote sensing and mapping research resource for spatial analysis and geolocation investigations.",
  link: "http://corona.cast.uark.edu/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1676,
  name: "Daum (Korean)",
  description: "Korean map platform used for geolocation research and location verification in South Korea.",
  link: "http://map.daum.net/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1677,
  name: "Naver (Korean)",
  description: "Korean mapping service offering strong local data — useful for South Korea geolocation OSINT.",
  link: "http://map.naver.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1678,
  name: "OpenStreetMap",
  description: "OpenStreetMap portal for exploring maps, locations, routes, and global landmarks used in OSINT investigations.",
  link: "http://www.openstreetmap.org/#map=5/51.500/-0.100",
  category: "Geo",
  icon: "📍"
},
{
  id: 1679,
  name: "EarthExplorer",
  description: "USGS EarthExplorer portal providing satellite imagery datasets for terrain research and geo OSINT.",
  link: "https://earthexplorer.usgs.gov/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1680,
  name: "OpenStreetCam",
  description: "Crowdsourced street-level imagery platform useful for verifying locations using street photos.",
  link: "http://openstreetcam.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1681,
  name: "Travel by Drone",
  description: "Drone video archive used for location visualization and landmark verification for geolocation OSINT.",
  link: "http://travelbydrone.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1682,
  name: "Hivemapper",
  description: "Community-powered mapping platform that builds street-level maps — useful for geospatial analysis and OSINT.",
  link: "https://hivemapper.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1683,
  name: "LandsatLook Viewer",
  description: "USGS Landsat imagery viewer used to inspect satellite images and analyze terrain over time.",
  link: "https://landsatlook.usgs.gov/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1684,
  name: "Sentinel2Look Viewer",
  description: "Sentinel-2 satellite imagery viewer for high-resolution Earth observation and mapping OSINT.",
  link: "https://landsatlook.usgs.gov/sentinel2/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1685,
  name: "NEXRAD Data Inventory Search",
  description: "NOAA NEXRAD radar data inventory tool for storm/weather history research and location verification.",
  link: "https://www.ncdc.noaa.gov/nexradinv/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1686,
  name: "MapQuest",
  description: "Mapping and navigation platform offering directions and road maps useful for geo OSINT reference.",
  link: "https://www.mapquest.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1687,
  name: "OpenRailwayMap",
  description: "Railway infrastructure mapping tool for exploring rail networks and transport intelligence worldwide.",
  link: "http://www.openrailwaymap.org/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1688,
  name: "OpenInfrastructureMap",
  description: "Open map showing infrastructure layers (power, water, telecom, etc.) useful for infrastructure OSINT research.",
  link: "openinframap.org/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1689,
  name: "OpenStreetMap Routing Service",
  description: "OSM route planning tool for creating driving/walking routes useful in investigations and location analytics.",
  link: "http://www.yournavigation.org/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1690,
  name: "Hiking & Biking Map",
  description: "Specialized map for trails and outdoor paths — useful for terrain-based geolocation OSINT and route planning.",
  link: "http://hikebikemap.org/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1691,
  name: "US Nav Guide Zip Code Data",
  description: "US ZIP code and location directory used for geographic research and postal location verification.",
  link: "http://www.usnaviguide.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1692,
  name: "Wayback Imagery",
  description: "Historical satellite imagery archive by ArcGIS that lets you view older imagery for a place over time.",
  link: "https://livingatlas.arcgis.com/wayback/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1693,
  name: "SkyFi.com - Satellite Open Data (R)",
  description: "Satellite imagery discovery platform offering open datasets and exploration tools (restricted/paid options).",
  link: "https://app.skyfi.com/explore/open",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1694,
  name: "Google",
  description: "World’s most powerful search engine for general OSINT research, investigation queries, and web discovery.",
  link: "https://www.google.com/?gws_rd=ssl",
  category: "Google",
  icon: "🔍"
},
{
  id: 1695,
  name: "Bing",
  description: "Microsoft search engine for web OSINT research and alternative indexing compared to Google.",
  link: "http://www.bing.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1696,
  name: "DuckDuckGo",
  description: "Privacy-focused search engine useful for OSINT research and unbiased alternative search results.",
  link: "https://duckduckgo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1697,
  name: "Yahoo Advanced Web Search",
  description: "Advanced Yahoo search filters useful for refined OSINT queries and alternative search discovery.",
  link: "https://search.yahoo.com/web/advanced",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1698,
  name: "StartPage",
  description: "Privacy-first search engine that uses Google results without tracking — useful for anonymous OSINT browsing.",
  link: "https://www.startpage.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1699,
  name: "Yandex",
  description: "Search engine useful for OSINT investigations with strong coverage in Eastern Europe and Russian-language sources.",
  link: "https://www.yandex.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1700,
  name: "Baidu",
  description: "China’s major search engine — useful for OSINT research targeting Chinese-language websites and results.",
  link: "http://www.baidu.com/",
  category: "OSINT Tools",
  icon: "🧰"
},

{
  id: 1701,
  name: "Google Advanced Search",
  description: "Google’s advanced search interface to filter results by language, region, last update, file type, and exact phrases — extremely useful for OSINT queries.",
  link: "https://www.google.com/advanced_search",
  category: "Google",
  icon: "🔍"
},
{
  id: 1702,
  name: "iBoogie",
  description: "General web search engine alternative for exploring results outside mainstream search indexing.",
  link: "http://www.iboogie.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1703,
  name: "iZito",
  description: "Meta-style search engine providing alternative results aggregation for OSINT research.",
  link: "http://www.izito.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1704,
  name: "Bing vs. Google",
  description: "Comparison resource highlighting differences between Bing and Google results — helpful for multi-engine OSINT searching strategies.",
  link: "http://bvsg.org/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1705,
  name: "Ixquick Search Engine",
  description: "Privacy-focused search engine (historically associated with Startpage) for anonymous OSINT-style browsing.",
  link: "https://www.ixquick.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1706,
  name: "Advangle",
  description: "Alternative web search tool useful for broad OSINT discovery and diversified search results.",
  link: "http://advangle.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1707,
  name: "Instya",
  description: "Search engine tool designed to explore web results with privacy-oriented discovery features.",
  link: "http://www.instya.com/#/web/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1708,
  name: "Hulbee",
  description: "Search and research platform offering semantic-style results for OSINT discovery (privacy-friendly).",
  link: "https://hulbee.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1709,
  name: "Swisscows",
  description: "Swiss privacy-focused search engine emphasizing safe search and alternative indexing useful for OSINT exploration.",
  link: "https://swisscows.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1710,
  name: "Brave",
  description: "Brave Search — privacy-friendly search engine useful for OSINT investigations with independent indexing.",
  link: "https://search.brave.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1711,
  name: "Stract",
  description: "Independent search engine focused on transparent search indexing and privacy-conscious OSINT research.",
  link: "https://stract.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1712,
  name: "Shuriken",
  description: "Meta search tool that helps aggregate results from multiple sources for improved OSINT discovery.",
  link: "http://shuriken.pm",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1713,
  name: "iSEEK",
  description: "Search engine built for education and research — useful for finding academic and credible sources.",
  link: "http://iseek.com/iseek/home.page",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1714,
  name: "Biznar",
  description: "Business and government-focused search engine that helps discover industry data, reports, and official sources.",
  link: "http://biznar.com/biznar/desktop/en/search.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1715,
  name: "eTools.ch",
  description: "Meta search engine that aggregates results across multiple platforms for OSINT investigations.",
  link: "https://www.etools.ch/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1716,
  name: "searx.me",
  description: "Searx public instance — privacy-friendly meta search engine that queries multiple search providers at once.",
  link: "https://searx.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1717,
  name: "WhosTalkin",
  description: "Social media and web conversation search tool for tracking discussions and mentions (OSINT monitoring).",
  link: "http://www.whostalkin.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1718,
  name: "AnswerThePublic.com",
  description: "Question-based search discovery tool showing what people search online — useful for OSINT keyword expansion.",
  link: "http://answerthepublic.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1719,
  name: "PublicWWW",
  description: "Search engine for website source code — useful for tracking analytics IDs, scripts, tracking tags, and reused code.",
  link: "https://publicwww.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1720,
  name: "Searchcode",
  description: "Code search engine to find snippets across repositories and websites — useful for OSINT and security research.",
  link: "https://searchcode.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1721,
  name: "NerdyData",
  description: "Code and technology fingerprint search tool to discover websites using specific scripts, libraries, or tags.",
  link: "https://nerdydata.com/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1722,
  name: "Gitrob",
  description: "GitHub OSINT tool that scans organizations/users to detect potentially sensitive files and exposed data patterns.",
  link: "https://github.com/michenriksen/gitrob",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1723,
  name: "Github-Dorks",
  description: "Collection of GitHub dorks used for finding exposed secrets, configs, credentials, and sensitive code patterns.",
  link: "https://github.com/techgaun/github-dorks",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1724,
  name: "GitLeaks",
  description: "Secret detection tool that scans repositories for exposed credentials, tokens, keys, and sensitive content.",
  link: "https://github.com/zricethezav/gitleaks",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1725,
  name: "GlobalFile",
  description: "File search engine for locating documents/media publicly exposed on the internet (OSINT file discovery).",
  link: "https://globalfilesearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1726,
  name: "FTP Google Dork (D)",
  description: "Google dork query template for discovering FTP directories indexed publicly (for lawful OSINT research only).",
  link: "https://www.google.com/search?q=inurl%3Aftp+-inurl%3Ahttp+-inurl%3Ahttps+ftpsearchterm",
  category: "Google",
  icon: "🔍"
},
{
  id: 1727,
  name: "Napalm FTP",
  description: "FTP search engine for finding publicly indexed FTP servers and directories (OSINT discovery).",
  link: "http://www.searchftps.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1728,
  name: "PubPeer",
  description: "Post-publication peer review platform used to check scientific paper discussions and research integrity.",
  link: "https://pubpeer.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1729,
  name: "Bielefeld Academic Search Engine",
  description: "BASE academic search engine that indexes scholarly resources and open repositories for research OSINT.",
  link: "https://www.base-search.net/Search/Advanced",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1730,
  name: "Google Scholar",
  description: "Academic search engine for papers, citations, and journals — very useful for research-based OSINT.",
  link: "https://scholar.google.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1731,
  name: "PubMed - National Center for Biotechnology Information",
  description: "Medical/scientific publication search database for biomedical research and verified sources.",
  link: "http://www.ncbi.nlm.nih.gov/pubmed/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1732,
  name: "Social Science Research Network",
  description: "Research paper repository focused on social sciences, economics, and law — useful for policy OSINT.",
  link: "http://ssrn.com/en/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1733,
  name: "Open Library",
  description: "Open book catalog and digital library for research, referencing sources, and historical OSINT.",
  link: "https://openlibrary.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1734,
  name: "World Digital Library",
  description: "Global historical documents and cultural archives repository for academic and history OSINT research.",
  link: "https://www.wdl.org/en/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1735,
  name: "JURN",
  description: "Academic search engine indexing free scholarly content for research and evidence-based OSINT.",
  link: "http://jurn.org/#gsc.tab=0",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1736,
  name: "HathiTrust Digital Library",
  description: "Digital library platform offering access to books and scholarly works for historical and academic OSINT.",
  link: "https://www.hathitrust.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1737,
  name: "UK National Archives",
  description: "Official UK National Archives discovery portal to search historical documents, records, and government archives.",
  link: "http://discovery.nationalarchives.gov.uk/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1738,
  name: "OpenGrey EU Papers",
  description: "European grey literature database used for reports, papers, and policy documents not published commercially.",
  link: "http://opengrey.eu/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1739,
  name: "US Gov Publishing Office - FDsys",
  description: "US government publications portal for accessing official documents and archived government reports.",
  link: "https://www.gpo.gov/fdsys/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1740,
  name: "OpenDOAR",
  description: "Directory of Open Access Repositories — helps locate academic repositories and open research papers.",
  link: "http://www.opendoar.org/search.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1741,
  name: "Microsoft Academic",
  description: "Academic search platform reference for scholarly papers and citation discovery (availability may vary).",
  link: "https://academic.microsoft.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1742,
  name: "Science Direct",
  description: "Scientific journal and research portal hosting articles and papers across multiple domains.",
  link: "http://www.sciencedirect.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1743,
  name: "PQDT Open",
  description: "Open dissertation and thesis search portal useful for academic OSINT and specialized research discovery.",
  link: "http://pqdtopen.proquest.com/search.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1744,
  name: "Think Tank Search",
  description: "Harvard think tank search guide providing curated resources to locate think tank publications and reports.",
  link: "http://guides.library.harvard.edu/hks/think_tank_search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1745,
  name: "Library Databases",
  description: "University library database directory for discovering scholarly sources and premium academic resources.",
  link: "http://guides.uflib.ufl.edu/az.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1746,
  name: "Copyscape Plagiarism Checker",
  description: "Plagiarism and duplicate content checker useful for OSINT verification and content authenticity validation.",
  link: "http://copyscape.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1747,
  name: "Lazy Scholar",
  description: "Academic research helper for finding papers, managing reading lists, and improving research OSINT workflows.",
  link: "http://www.lazyscholar.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1748,
  name: "Open Access Scholarly Journals",
  description: "Open access journal platform listing scholarly publications for free academic research and OSINT.",
  link: "http://www.pagepress.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1749,
  name: "The Open Syllabus Project",
  description: "Syllabus dataset explorer showing commonly taught books/papers — useful for credibility and research trend OSINT.",
  link: "http://explorer.opensyllabusproject.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1750,
  name: "Science Publications",
  description: "Online science publication directory for exploring journals and articles (verify quality before citation).",
  link: "http://www.thescipub.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1751,
  name: "arXiv.org",
  description: "Open-access preprint repository for research papers in AI, math, physics, and CS — widely used in research OSINT.",
  link: "https://arxiv.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1752,
  name: "Paperboy Online Newspapers",
  description: "Global newspaper directory useful for finding regional newspapers and performing local news OSINT research.",
  link: "http://www.thepaperboy.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1753,
  name: "Google News Search",
  description: "Advanced Google News search interface to filter news articles by keyword, time range, and publishers.",
  link: "https://news.google.com/news/advanced_news_search?",
  category: "Google",
  icon: "🔍"
},
{
  id: 1754,
  name: "Flipboard",
  description: "News and content aggregation platform used for topic-based monitoring and trend discovery.",
  link: "https://flipboard.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1755,
  name: "YouGotTheNews",
  description: "News search tool focused on discovering articles and coverage from multiple online publishers.",
  link: "http://www.yougotthenews.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1756,
  name: "NewspaperARCHIVE.com",
  description: "Historical newspaper archive platform used for old news verification, genealogy, and investigation OSINT.",
  link: "http://newspaperarchive.com/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1757,
  name: "PressReader.com",
  description: "Digital newspaper and magazine platform providing access to global publications for news OSINT.",
  link: "http://www.pressreader.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1758,
  name: "Newspaper Map",
  description: "Interactive world map of newspapers — helps discover local media sources for regional OSINT research.",
  link: "http://newspapermap.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 1759,
  name: "NewsBrief",
  description: "European Media Monitor style news aggregator displaying clustered breaking news coverage and trends.",
  link: "http://emm.newsbrief.eu/NewsBrief/clusteredition/en/latest.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1760,
  name: "AllYouCanRead.com",
  description: "Worldwide newspaper directory useful for accessing news sources from different countries and languages.",
  link: "http://www.allyoucanread.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1761,
  name: "World News",
  description: "International news search platform for monitoring global events and multi-source reporting.",
  link: "https://wn.com/#/search",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1762,
  name: "NewsNow.co.uk",
  description: "News aggregator platform focusing on UK/global headlines — good for monitoring topics continuously.",
  link: "http://www.newsnow.co.uk/h/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1763,
  name: "Hubii",
  description: "Content and news discovery platform used to search and explore aggregated headlines and sources.",
  link: "http://hubii.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1764,
  name: "Inshorts",
  description: "Short news summary app/website useful for quickly scanning headlines and trending topics.",
  link: "https://www.inshorts.com/en/read",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1765,
  name: "NewsBot",
  description: "News monitoring tool used to track and discover important updates across multiple news channels.",
  link: "https://getnewsbot.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1766,
  name: "Colossus International Engine List",
  description: "Search Engine Colossus directory listing global search engines by country/language for OSINT expansion.",
  link: "http://www.searchenginecolossus.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1767,
  name: "AOL Search Database",
  description: "Search-ID directory resource for searching and locating indexed information across different databases.",
  link: "http://search-id.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1768,
  name: "Zenodo",
  description: "Open research repository hosting datasets, papers, and software — useful for academic OSINT and citations.",
  link: "https://zenodo.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1769,
  name: "EntityCube",
  description: "Entity and research exploration platform by Microsoft Research (historical/availability may vary).",
  link: "http://entitycube.research.microsoft.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1770,
  name: "FindTheData A Research Engine",
  description: "Research discovery engine to explore datasets, statistics, and structured information online.",
  link: "http://www.findthedata.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1771,
  name: "Million Short",
  description: "Search tool that removes top popular sites from results to discover lesser-known sources — useful for OSINT deep research.",
  link: "https://millionshort.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1772,
  name: "SearchDiggity",
  description: "OSINT/search toolkit from Bishop Fox useful for automating dorking and search-based recon workflows.",
  link: "http://www.bishopfox.com/download/405/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1773,
  name: "Scanner-inurlbr",
  description: "Google dork scanning framework used for search-based reconnaissance and discovery research.",
  link: "https://github.com/googleinurl/SCANNER-INURLBR",
  category: "Google",
  icon: "🔍"
},
{
  id: 1774,
  name: "Google Alerts",
  description: "Alert system by Google to track new web mentions/keywords and receive notifications automatically.",
  link: "https://www.google.com/alerts#",
  category: "Google",
  icon: "🔍"
},
{
  id: 1775,
  name: "Google Custom Search Engine",
  description: "Tool to create a custom Google search engine limited to selected websites for targeted OSINT searching.",
  link: "https://cse.google.com/cse/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1776,
  name: "pagodo - Passive Google Dork",
  description: "Passive Google dork automation tool that generates dorks for recon and OSINT search workflows.",
  link: "https://github.com/opsdisk/pagodo",
  category: "Google",
  icon: "🔍"
},
{
  id: 1777,
  name: "Talkwalker Alerts",
  description: "Alert tool to monitor keywords, brands, and mentions on the web similar to Google Alerts.",
  link: "http://www.talkwalker.com/alerts",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1778,
  name: "Google Trends",
  description: "Trend analysis tool showing popularity of search terms over time — useful for OSINT trend detection.",
  link: "https://trends.google.com/trends/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1779,
  name: "Google Hacking Database",
  description: "GHDB by Exploit-DB containing curated Google dorks useful for security and OSINT discovery research.",
  link: "https://www.exploit-db.com/google-hacking-database/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1780,
  name: "Google Search Operators Guide",
  description: "Guide explaining advanced Google search operators for effective OSINT searching and filtering.",
  link: "http://googleguide.com/advanced_operators_reference.html",
  category: "Google",
  icon: "🔍"
},
{
  id: 1781,
  name: "Google Guide Cheat Sheet",
  description: "Google search reference guide and cheat sheet for improving query efficiency and research speed.",
  link: "http://googleguide.com/help/calculator.html",
  category: "Google",
  icon: "🔍"
},
{
  id: 1782,
  name: "Hoaxy",
  description: "Fact-checking and misinformation tracking tool that visualizes how claims spread online.",
  link: "https://hoaxy.iuni.iu.edu/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1783,
  name: "Africa Check",
  description: "Fact-checking organization for Africa-focused claims, politics, and public statements verification.",
  link: "https://africacheck.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1784,
  name: "PolitiFact",
  description: "Fact-checking platform that verifies political claims and public statements using evidence-based reporting.",
  link: "http://www.politifact.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1785,
  name: "SciCheck",
  description: "Science fact-checking resource by FactCheck.org that verifies viral science and health misinformation.",
  link: "http://www.factcheck.org/scicheck/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1786,
  name: "Duke Reporters' Lab",
  description: "Fact-checking resource hub that tracks fact-check initiatives and provides verification tools.",
  link: "http://reporterslab.org/fact-checking/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1787,
  name: "Stop Fake Tools",
  description: "Verification toolset and anti-misinformation platform focused on detecting propaganda and fake news.",
  link: "http://www.stopfake.org/en/category/tools/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1788,
  name: "Snopes",
  description: "One of the most popular fact-checking sites for verifying rumors, hoaxes, viral claims, and misinformation.",
  link: "http://www.snopes.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1789,
  name: "Verification Handbook",
  description: "Practical guide for verifying online content, images, videos, and sources in OSINT investigations.",
  link: "http://verificationhandbook.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1790,
  name: "Verification Junkie",
  description: "OSINT verification resource providing tools and tips for fact-checking digital media.",
  link: "http://verificationjunkie.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1791,
  name: "MediaBugs",
  description: "Platform for reporting and tracking media errors — useful for journalism OSINT and credibility checks.",
  link: "http://mediabugs.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1792,
  name: "BoardReader",
  description: "Forum and discussion search engine used to find conversations and mentions across message boards.",
  link: "http://boardreader.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1793,
  name: "Omgili",
  description: "Forum search engine that indexes discussions across the web — useful for deep OSINT monitoring.",
  link: "http://omgili.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1794,
  name: "Craigslist Forums",
  description: "Public forums platform useful for local community discussions, marketplace insights, and regional OSINT.",
  link: "https://forums.craigslist.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1795,
  name: "Delphi Forum Search",
  description: "Forum community platform used for searching discussions, posts, and niche group content.",
  link: "http://www.delphiforums.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1796,
  name: "Google Groups Search",
  description: "Google Groups and Usenet-style archive search — useful for historical discussions and niche OSINT evidence.",
  link: "https://groups.google.com/forum/#!overview",
  category: "Google",
  icon: "🔍"
},
{
  id: 1797,
  name: "Live Journal Seek",
  description: "Search tool for LiveJournal content — useful for older blog OSINT and archival user content discovery.",
  link: "http://ljseek.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1798,
  name: "Topix",
  description: "News/blog discussion search platform reference used for discovering local and community-level conversations.",
  link: "http://www.topix.com/search/article?q=",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1799,
  name: "Blog Search Engine",
  description: "Blog-focused search engine to discover posts, articles, and niche blogs related to investigations.",
  link: "http://www.blogsearchengine.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1800,
  name: "Mibbit",
  description: "IRC search engine for discovering IRC channels and searchable chat logs useful for OSINT research.",
  link: "http://search.mibbit.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1801,
  name: "ircsnapshot",
  description: "Open-source tool for collecting and archiving IRC logs — useful for investigation documentation.",
  link: "https://github.com/bwall/ircsnapshot",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1802,
  name: "netsplit.de",
  description: "IRC channel search and network statistics platform useful for discovering IRC communities and channels.",
  link: "http://irc.netsplit.de/channels/search.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1803,
  name: "Internet Archive: Wayback Machine",
  description: "Wayback Machine by Internet Archive to view old versions of websites — core tool for web OSINT and evidence.",
  link: "https://archive.org/web/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1804,
  name: "Archive.is",
  description: "Web page snapshot archiving service to save and view web pages in immutable cached form.",
  link: "https://archive.is/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1805,
  name: "WebCite",
  description: "Web citation archive service for storing snapshots of web pages for academic and evidence purposes.",
  link: "http://webcitation.org/query",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1806,
  name: "Cached View",
  description: "Tool for viewing cached versions of web pages from different cache providers — useful for deleted content retrieval.",
  link: "http://cachedview.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1807,
  name: "Cached Pages",
  description: "Website cache lookup service used to find cached page versions when original pages are offline/removed.",
  link: "http://www.cachedpages.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1808,
  name: "Textfiles.com",
  description: "Archive of historical text files and early internet documentation useful for retro OSINT and old content discovery.",
  link: "http://textfiles.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1809,
  name: "UK Web Archive",
  description: "UK national web archiving portal for preserved web pages and government/cultural historical data.",
  link: "http://www.webarchive.org.uk/ukwa/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1810,
  name: "Screenshots.com",
  description: "Website archive platform showing historical website screenshots — useful for website evolution OSINT.",
  link: "http://www.screenshots.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1811,
  name: "Wayback Machine - Beta Search",
  description: "Wayback Machine beta interface for improved archive search and older website snapshot exploration.",
  link: "https://web-beta.archive.org/#/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1812,
  name: "Common Crawl",
  description: "Open web crawl dataset used for large-scale analysis, data mining, and archived website OSINT research.",
  link: "http://commoncrawl.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1813,
  name: "Wayback Machine Chrome Extension",
  description: "Browser extension that quickly checks archived copies of a page and opens Wayback versions easily.",
  link: "https://chrome.google.com/webstore/detail/wayback-machine/fpnmgdkabkmnadcjpehmlllkndpkmiak",
  category: "Archives",
  icon: "📚"
},
{
  id: 1814,
  name: "PDF My URL",
  description: "Web page to PDF converter used for saving online pages as evidence or documentation in investigations.",
  link: "http://pdfmyurl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1815,
  name: "Common Crawl",
  description: "Public dataset of crawled web pages used for advanced research, domain analysis, and OSINT data mining.",
  link: "http://commoncrawl.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1816,
  name: "Anna's Archive",
  description: "Large archive search portal indexing books/papers — useful for research discovery (check legal access rules in your region).",
  link: "https://annas-archive.org/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1817,
  name: "Browsershots",
  description: "Website screenshot service that renders pages across browsers/platforms — useful for web proof and testing.",
  link: "http://browsershots.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1818,
  name: "Waybackpack",
  description: "Tool that downloads archived snapshots from Wayback Machine — useful for automated archiving and evidence collection.",
  link: "https://github.com/jsvine/waybackpack",
  category: "Archives",
  icon: "📚"
},
{
  id: 1819,
  name: "Web Archive-RU",
  description: "Russian web archiving platform for checking historical versions of websites (regional alternative archive).",
  link: "https://web-arhive.ru/",
  category: "Archives",
  icon: "📚"
},
{
  id: 1820,
  name: "Databases.Today",
  description: "Search portal indexing leaked database references — use for threat awareness only and stay legally compliant.",
  link: "https://databases.today/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1821,
  name: "Cryptome",
  description: "Long-running repository of documents related to intelligence, surveillance, and government materials for research.",
  link: "http://cryptome.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1822,
  name: "WikiLeaks",
  description: "Public document leak platform hosting released materials — used for investigative OSINT and transparency research.",
  link: "https://wikileaks.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1823,
  name: "Labled Faces in the Wild DB",
  description: "Public face dataset used in machine learning research — useful for academic AI/vision study and OSINT research references.",
  link: "http://vis-www.cs.umass.edu/lfw/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1824,
  name: "VisualGenome",
  description: "Computer vision dataset containing images and annotations used for AI research and vision-based analysis.",
  link: "http://visualgenome.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1825,
  name: "UCI Spambase Data Set",
  description: "UCI Machine Learning dataset for spam detection research and training data exploration.",
  link: "https://archive.ics.uci.edu/ml/datasets/Spambase",
  category: "Archives",
  icon: "📚"
},
{
  id: 1826,
  name: "Stanford Large Network Dataset Collection",
  description: "Stanford SNAP dataset repository for networks, social graphs, and large-scale data research.",
  link: "http://snap.stanford.edu/data/#amazon",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1827,
  name: "Library of Congress: Digitized Newspapers - 1836-1922",
  description: "Digitized historical newspaper archive useful for old event verification, genealogy, and historical OSINT.",
  link: "http://chroniclingamerica.loc.gov/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1828,
  name: "Library of Congress: Newspaper Directory - 1690-Present",
  description: "Directory of newspapers across time used for sourcing local and historical publications.",
  link: "http://chroniclingamerica.loc.gov/search/titles/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1829,
  name: "TV Closed Caption Search",
  description: "Search TV closed captions and transcripts — useful for tracking public statements and media mentions.",
  link: "https://archive.org/details/tv",
  category: "Archives",
  icon: "📚"
},
{
  id: 1830,
  name: "DeepL Translator",
  description: "High-quality translation tool used for converting foreign-language OSINT content and improving understanding.",
  link: "https://www.deepl.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1831,
  name: "Google Translate",
  description: "Translation tool by Google for converting text/webpages — commonly used in multilingual OSINT research.",
  link: "https://translate.google.com/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1832,
  name: "Google Input Tools",
  description: "Typing and language input tool for writing in multiple languages — helpful for foreign OSINT searching.",
  link: "https://www.google.com/inputtools/try/",
  category: "Google",
  icon: "🔍"
},
{
  id: 1833,
  name: "Bing Translate",
  description: "Microsoft translation tool for translating OSINT content across languages.",
  link: "http://www.bing.com/translator/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1834,
  name: "Word Reference",
  description: "Dictionary and language reference site offering translations, synonyms, and definitions for OSINT translation support.",
  link: "https://www.wordreference.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1835,
  name: "Dictionary.com Translator",
  description: "Basic translation tool integrated with Dictionary.com for quick language conversion.",
  link: "http://translate.reference.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1836,
  name: "Free Translation",
  description: "Online translation platform for converting text between different languages.",
  link: "https://www.freetranslation.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1837,
  name: "Free Online Translation",
  description: "WorldLingo translation service useful for quick language conversion and foreign content understanding.",
  link: "http://www.worldlingo.com/en/products_services/worldlingo_translator.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1838,
  name: "Wiktionary",
  description: "Open dictionary project providing definitions, translations, pronunciation, and language references.",
  link: "https://www.wiktionary.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1839,
  name: "Slangit - The Slang Dictionary",
  description: "Slang dictionary useful for decoding internet slang and informal text during OSINT investigations.",
  link: "https://slangit.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1840,
  name: "Slang Dictionary & Translator",
  description: "NoSlang dictionary to decode abbreviations and slang terms used in chats, forums, and posts.",
  link: "http://www.noslang.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1841,
  name: "Urban Dictionary",
  description: "Crowdsourced slang dictionary helpful for understanding informal terms, memes, and internet language.",
  link: "http://www.urbandictionary.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1842,
  name: "Online OCR",
  description: "OCR tool that extracts text from images/scans — useful for converting screenshots into searchable text.",
  link: "http://www.free-ocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1843,
  name: "i2OCR",
  description: "Image-to-text OCR tool used to extract readable text from screenshots and documents.",
  link: "http://www.i2ocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1844,
  name: "New OCR",
  description: "Online OCR platform for extracting text from scanned documents and image files.",
  link: "https://www.newocr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1845,
  name: "Online OCR",
  description: "OCR service for converting printed/scanned documents into editable digital text.",
  link: "http://www.onlineocr.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1846,
  name: "Eleven Labs Dubbing",
  description: "AI dubbing tool used to translate and dub videos into other languages — helpful for multilingual media analysis.",
  link: "https://elevenlabs.io/dubbing",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1847,
  name: "WhatTheFont",
  description: "Font recognition tool to identify fonts used in images/documents — useful for design and document analysis OSINT.",
  link: "https://www.myfonts.com/WhatTheFont/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1848,
  name: "ExifTool",
  description: "Industry-standard metadata extraction tool for images/videos/documents to analyze EXIF and hidden file details.",
  link: "http://www.sno.phy.queensu.ca/~phil/exiftool/",
  category: "Metadata",
  icon: "🏷️"
},
{
  id: 1849,
  name: "Metagoofil",
  description: "Metadata extraction OSINT tool that finds public documents and extracts usernames, emails, and metadata.",
  link: "http://www.edge-security.com/metagoofil.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1850,
  name: "FOCA",
  description: "Metadata analysis tool that extracts hidden metadata from documents (PDF/DOCX/etc.) for OSINT investigations.",
  link: "https://github.com/ElevenPaths/FOCA",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1851,
  name: "CodeTwo Outlook Export",
  description: "Tool for exporting Outlook data — useful for analysis, backup workflows, and lawful digital investigations.",
  link: "http://www.codetwo.com/freeware/outlook-export/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1852,
  name: "Genymotion",
  description: "Android emulator useful for mobile OSINT testing, app analysis, and isolated investigation environments.",
  link: "https://www.genymotion.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1853,
  name: "BlueStacks 2",
  description: "Android emulator used to run Android apps on PC — useful for mobile OSINT workflows and testing.",
  link: "http://www.bluestacks.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1854,
  name: "Andy Android Emulator",
  description: "Android emulator platform used for running and testing Android applications on PC for analysis.",
  link: "http://www.andyroid.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1855,
  name: "Nox App Player",
  description: "Android emulator used for running Android apps in desktop environment useful for app OSINT/research testing.",
  link: "https://www.bignox.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1856,
  name: "Facebook",
  description: "Facebook mobile app listing used for OSINT: profile research, public posts monitoring, and social graph exploration.",
  link: "https://play.google.com/store/apps/details?id=com.facebook.katana",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1857,
  name: "LinkedIn",
  description: "LinkedIn mobile app listing used for professional OSINT: work history, company mapping, and connections discovery.",
  link: "https://play.google.com/store/apps/details?id=com.linkedin.android",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1858,
  name: "Twitter",
  description: "Twitter/X mobile app listing useful for OSINT monitoring, hashtag tracking, and public post investigations.",
  link: "https://play.google.com/store/apps/details?id=com.twitter.android",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1859,
  name: "Pinterest",
  description: "Pinterest app listing useful for OSINT: image-based discovery, boards, and interest profiling research.",
  link: "https://play.google.com/store/apps/details?id=com.pinterest",
  category: "Google",
  icon: "🔍"
},
{
  id: 1860,
  name: "Signal Private Messenger",
  description: "Signal secure messaging app listing — useful for app research and encrypted communication study.",
  link: "https://play.google.com/store/apps/details?id=org.thoughtcrime.securesms",
  category: "Google",
  icon: "🔍"
},
{
  id: 1861,
  name: "Riot.im - Communicate, your way",
  description: "Matrix-based messaging app (Element) listing — useful for secure communication OSINT research.",
  link: "https://play.google.com/store/apps/details?id=im.vector.app",
  category: "Google",
  icon: "🔍"
},
{
  id: 1862,
  name: "Telegram",
  description: "Telegram messaging app listing — useful for OSINT research on channels, groups, and public content.",
  link: "https://play.google.com/store/apps/details?id=org.telegram.messenger",
  category: "Google",
  icon: "🔍"
},
{
  id: 1863,
  name: "Snapchat",
  description: "Snapchat app listing — relevant for OSINT investigations involving stories, geofilters, and social activity.",
  link: "https://play.google.com/store/apps/details?id=com.snapchat.android",
  category: "Google",
  icon: "🔍"
},
{
  id: 1864,
  name: "WhatsApp Messenger",
  description: "WhatsApp app listing — widely used messaging platform; useful for mobile ecosystem and communication analysis.",
  link: "https://play.google.com/store/apps/details?id=com.whatsapp",
  category: "Google",
  icon: "🔍"
},
{
  id: 1865,
  name: "Kik",
  description: "Kik messaging app listing used for instant chat and community messaging research.",
  link: "https://play.google.com/store/apps/details?id=kik.android",
  category: "Google",
  icon: "🔍"
},
{
  id: 1866,
  name: "Yik Yak",
  description: "Anonymous/local community chat platform listing useful for region-based community OSINT investigation.",
  link: "https://play.google.com/store/apps/details?id=com.yik.yak",
  category: "Google",
  icon: "🔍"
},
{
  id: 1867,
  name: "LINE",
  description: "LINE messaging app listing — popular in some countries; useful for international communication OSINT research.",
  link: "https://play.google.com/store/apps/details?id=jp.naver.line.android",
  category: "Google",
  icon: "🔍"
},
{
  id: 1868,
  name: "Instagram",
  description: "Instagram mobile app listing used for OSINT: posts, reels, profiles, hashtags, and network discovery.",
  link: "https://play.google.com/store/apps/details?id=com.instagram.android",
  category: "Social Media",
  icon: "📱"
},
{
  id: 1869,
  name: "Flickr",
  description: "Flickr photo platform listing useful for image OSINT and photography metadata/location investigations.",
  link: "https://play.google.com/store/apps/details?id=com.yahoo.mobile.client.android.flickr",
  category: "Google",
  icon: "🔍"
},
{
  id: 1870,
  name: "Periscope",
  description: "Live streaming platform listing reference used for video OSINT and old broadcast content discovery.",
  link: "https://play.google.com/store/apps/details?id=tv.periscope.android",
  category: "Google",
  icon: "🔍"
},
{
  id: 1871,
  name: "Meerkat",
  description: "Live streaming app listing reference used for video streaming OSINT research.",
  link: "https://play.google.com/store/apps/details?id=co.getair.meerkat",
  category: "Google",
  icon: "🔍"
},
{
  id: 1872,
  name: "Vine",
  description: "Short video platform listing reference used for historical social media OSINT and archive discovery.",
  link: "https://play.google.com/store/apps/details?id=co.vine.android",
  category: "Google",
  icon: "🔍"
},
{
  id: 1873,
  name: "Truecaller",
  description: "Caller identification app listing used for call reputation research and number intelligence.",
  link: "https://play.google.com/store/apps/details?id=com.truecaller",
  category: "Google",
  icon: "🔍"
},
{
  id: 1874,
  name: "Global Terrorism Database",
  description: "Research database of terrorism incidents worldwide (START/UMD) useful for data-driven security OSINT research.",
  link: "http://www.start.umd.edu/gtd/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1875,
  name: "Reddit Deep Web",
  description: "Reddit community for deep web information discussions, safety awareness, and OSINT references.",
  link: "https://www.reddit.com/r/deepweb",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1876,
  name: "Reddit Onions",
  description: "Reddit community discussing onion sites and Tor-related topics for OSINT awareness and references.",
  link: "https://www.reddit.com/r/onions",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1877,
  name: "Reddit Darknet",
  description: "Reddit community focused on darknet topics — useful for awareness OSINT, trends, and discussions.",
  link: "https://www.reddit.com/r/darknet",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1878,
  name: "Tor Download",
  description: "Official Tor Browser download page — used for privacy-safe browsing and accessing onion services legally.",
  link: "https://www.torproject.org/download/download-easy.html.en",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1879,
  name: "Freenet Project",
  description: "Anonymous peer-to-peer network software used for privacy research and censorship-resistant publishing studies.",
  link: "https://freenetproject.org/pages/download.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1880,
  name: "I2P Anonymous Network",
  description: "I2P anonymous network platform used for privacy-focused communication and investigation research.",
  link: "https://geti2p.net/en/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1881,
  name: "OnionScan",
  description: "OSINT tool for analyzing Tor hidden services and identifying common configuration/security issues.",
  link: "https://github.com/s-rah/onionscan",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1882,
  name: "TorBot",
  description: "Dark web OSINT automation tool used for onion site crawling and content discovery workflows.",
  link: "https://github.com/DedSecInside/TorBot",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1883,
  name: "Tor Scan",
  description: "Tor-based site scan/search platform used for discovering onion services and monitoring dark web content.",
  link: "http://www.torscan.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1884,
  name: "Onioff",
  description: "Onion service discovery and monitoring tool useful for dark web OSINT reconnaissance.",
  link: "https://github.com/k4m4/onioff",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1885,
  name: "Hunchly Hidden Services Report",
  description: "Hunchly report page for dark web hidden services — supports OSINT evidence collection and reporting workflows.",
  link: "https://darkweb.hunch.ly/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1886,
  name: "docker-onion-nmap",
  description: "Docker project for scanning onion services with nmap through Tor — used for security research (lawful use only).",
  link: "https://github.com/milesrichardson/docker-onion-nmap",
  category: "Network",
  icon: "🌐"
},
{
  id: 1887,
  name: "Onion Investigator",
  description: "Dark web OSINT search and investigation platform for discovering onion services and related intelligence.",
  link: "https://oint.ctrlbox.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1888,
  name: "Onion Cab",
  description: "Tor search engine for indexing onion websites — useful for discovering onion services for OSINT awareness.",
  link: "https://onion.cab/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1889,
  name: "OnionLink",
  description: "Onion.link proxy service that allows opening onion sites via clearnet proxy (use with caution/security awareness).",
  link: "http://www.onion.link/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1890,
  name: "Candle",
  description: "Onion search engine link used for exploring Tor hidden services and dark web OSINT discovery.",
  link: "http://gjobqjj7wyczbqie.onion/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1891,
  name: "Not Evil",
  description: "Popular Tor search engine (onion) used for indexing and searching hidden services content.",
  link: "http://hss3uro2hsxfogfq.onion/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1892,
  name: "Tor66",
  description: "Tor search engine used to discover onion services and searchable hidden web pages.",
  link: "http://tor66sezptuu2nta.onion/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1893,
  name: "dark.fail",
  description: "Onion link status checker that lists reliable onion services and tracks downtime/phishing clones.",
  link: "http://darkfailllnkf4vf.onion/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1894,
  name: "Ahmia",
  description: "Tor search engine that provides onion indexing via clearnet — useful for discovery and research.",
  link: "https://ahmia.fi/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1895,
  name: "Hidden Wiki",
  description: "Onion directory listing various Tor sites — use only for awareness and always validate links for safety.",
  link: "http://thehiddenwiki.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1896,
  name: "Core.onion",
  description: "Tor onion directory link reference for exploring hidden web resources (use caution and verify legitimacy).",
  link: "http://eqt5g4fuenphqinx.onion/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1897,
  name: "Web O Proxy",
  description: "Web proxy service that can open onion sites via proxy — useful for OSINT preview (security caution advised).",
  link: "https://weboproxy.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1898,
  name: "IACA Dark Web Investigation Support",
  description: "Dark web investigation resource platform providing tools, training, and references for lawful OSINT research.",
  link: "https://iaca-darkweb-tools.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1899,
  name: "OXT",
  description: "Bitcoin blockchain explorer and analytics platform useful for cryptocurrency OSINT tracking and transaction analysis.",
  link: "https://oxt.me",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1900,
  name: "Blocktrail",
  description: "Bitcoin blockchain explorer reference used for tracking transactions, wallets, and network information.",
  link: "https://www.blocktrail.com/BTC",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1901,
  name: "Blockchain.info",
  description: "Popular Bitcoin blockchain explorer used for tracking transactions, blocks, addresses, and wallet activity for crypto OSINT investigations.",
  link: "https://blockchain.info/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1902,
  name: "Block Explorer",
  description: "Bitcoin block explorer that helps investigate wallet addresses, transaction chains, confirmations, and block data.",
  link: "https://blockexplorer.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1903,
  name: "Blockr.io",
  description: "Legacy blockchain explorer reference (availability may vary) for Bitcoin transaction and address analysis.",
  link: "http://blockr.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1904,
  name: "BitRef",
  description: "Bitcoin address lookup tool used for checking wallet details and transaction history for OSINT tracing.",
  link: "https://bitref.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1905,
  name: "Wallet Explorer",
  description: "Blockchain intelligence site that clusters Bitcoin addresses into wallets and entities for advanced crypto OSINT analysis.",
  link: "https://www.walletexplorer.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1906,
  name: "Graphsense",
  description: "Open blockchain analytics platform for investigating crypto flows, clusters, and transaction graphs.",
  link: "https://graphsense.info/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1907,
  name: "Blockonomics",
  description: "Bitcoin payment/tracking tool that can be used for analyzing wallet activities and invoice-based transactions.",
  link: "https://www.blockonomics.co/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1908,
  name: "Bitcoin Who's Who",
  description: "Bitcoin scam/abuse reporting lookup platform for checking reputation of wallet addresses (OSINT risk screening).",
  link: "http://bitcoinwhoswho.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1909,
  name: "Orbit",
  description: "Open-source OSINT tool to find information about cryptocurrency wallet addresses and related indicators.",
  link: "https://github.com/s0md3v/Orbit",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1910,
  name: "Ether.Camp",
  description: "Ethereum blockchain monitoring portal for exploring transactions, blocks, and smart contract activity.",
  link: "https://live.ether.camp/transactions",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1911,
  name: "etherchain.org",
  description: "Ethereum explorer that provides account, transaction, and block details useful for Ethereum OSINT investigations.",
  link: "https://etherchain.org/accounts/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1912,
  name: "Etherscan",
  description: "Most widely used Ethereum explorer to investigate addresses, token transfers, smart contracts, and transaction history.",
  link: "https://etherscan.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1913,
  name: "XMRChain.net",
  description: "Monero blockchain explorer used to view blocks and transactions; limited attribution due to Monero privacy design.",
  link: "https://xmrchain.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1914,
  name: "Monero Blocks",
  description: "Monero block explorer reference used for exploring block history and network activity.",
  link: "http://moneroblocks.info/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1915,
  name: "Chain Radar",
  description: "Crypto explorer platform supporting Monero views like blocks and network activity for OSINT research.",
  link: "https://chainradar.com/xmr/blocks",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1916,
  name: "Craigslist",
  description: "Classified ads platform useful for OSINT investigations involving listings, sellers, phone numbers, and regional activity.",
  link: "http://craigslist.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1917,
  name: "Kijiji - Canada Classifieds",
  description: "Canadian classifieds marketplace useful for OSINT research into ads, sellers, and location-based listings.",
  link: "http://www.kijiji.ca/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1918,
  name: "Quikr - India Classifieds",
  description: "Indian classifieds website useful for OSINT: seller profiles, ad history, contact details, and product listings.",
  link: "http://www.quikr.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1919,
  name: "eBay",
  description: "Global marketplace useful for OSINT: product listings, seller accounts, pricing patterns, and transaction history signals.",
  link: "http://www.ebay.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1920,
  name: "OfferUp",
  description: "Local marketplace app for buying/selling items — useful for regional OSINT investigations and seller activity.",
  link: "https://offerup.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1921,
  name: "Goofbid",
  description: "Auction/classified-style platform reference for finding listings and marketplace OSINT signals.",
  link: "http://www.goofbid.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1922,
  name: "Flippity",
  description: "Online content utility platform used for creating interactive lists/tools (classified references may vary).",
  link: "http://www.flippity.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1923,
  name: "SearchAllJunk",
  description: "Search engine for classifieds and marketplace listings to discover ads across multiple platforms.",
  link: "http://www.searchalljunk.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1924,
  name: "TotalCraigSearch",
  description: "Craigslist search aggregator that helps find listings across multiple Craigslist regions for OSINT research.",
  link: "http://www.totalcraigsearch.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1925,
  name: "Search Tempest",
  description: "Marketplace and Craigslist aggregator search tool to find listings across multiple regions quickly.",
  link: "http://www.searchtempest.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1926,
  name: "Oodle",
  description: "Classified ads search platform useful for finding listings, sellers, and product trends for OSINT.",
  link: "http://www.oodle.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1927,
  name: "Claz.org",
  description: "Classified listing search portal for discovering local ads and product postings across categories.",
  link: "http://claz.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1928,
  name: "francais-a-londres.org - French Classifieds",
  description: "French classifieds/community site reference useful for location-based OSINT investigations in London.",
  link: "http://francais-a-londres.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1929,
  name: "ClearImage Barcode Reader",
  description: "Online barcode/QR decoder used for extracting embedded data from images for OSINT and investigation workflows.",
  link: "http://online-barcode-reader.inliteresearch.com/",
  category: "Images",
  icon: "🖼️"
},
{
  id: 1930,
  name: "JS Beautifier",
  description: "JavaScript formatting tool to beautify/minify code for easier analysis, debugging, and OSINT script review.",
  link: "http://jsbeautifier.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1931,
  name: "JS NICE",
  description: "Tool to deobfuscate and rewrite JavaScript into readable form for code investigation and security analysis.",
  link: "http://jsnice.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1932,
  name: "Firebug",
  description: "Legacy Firefox debugging tool reference used for inspecting web pages and JavaScript during analysis.",
  link: "https://getfirebug.com/downloads/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1933,
  name: "SpiderMonkey",
  description: "Mozilla JavaScript engine documentation useful for understanding and analyzing JS execution and behavior.",
  link: "https://developer.mozilla.org/en-US/docs/Mozilla/Projects/SpiderMonkey",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1934,
  name: "Kahu Revelo",
  description: "JavaScript reverse engineering/deobfuscation toolkit used for analyzing suspicious scripts.",
  link: "http://www.kahusecurity.com/tools/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1935,
  name: "JavaScript Deobfuscator",
  description: "Browser addon to deobfuscate JavaScript and improve readability for malware/script investigation.",
  link: "https://addons.mozilla.org/en-US/firefox/addon/javascript-deobfuscator/",
  category: "Network",
  icon: "🌐"
},
{
  id: 1936,
  name: "DDecode - PHP Decoder",
  description: "PHP code decoder tool to deobfuscate encoded PHP and analyze hidden or suspicious code snippets.",
  link: "http://ddecode.com/phpdecoder/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1937,
  name: "XORSearch & XORStrings",
  description: "Didier Stevens’ tools to search and decode XOR-obfuscated data in malware samples and binaries.",
  link: "http://blog.didierstevens.com/programs/xorsearch/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1938,
  name: "xortool",
  description: "XOR brute-force and analysis tool used to decode XOR-based obfuscation in suspicious files or payloads.",
  link: "https://github.com/hellman/xortool",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1939,
  name: "unxor",
  description: "XOR decryption tool used in malware research to decode XOR-encrypted strings and data blobs.",
  link: "https://github.com/tomchop/unxor",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1940,
  name: "Kahu Converter Utilities",
  description: "Converter and deobfuscation utilities for reverse engineering malware and encoded data analysis.",
  link: "http://www.kahusecurity.com/tools/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1941,
  name: "iheartxor.py",
  description: "Python XOR utility script for decrypting and analyzing XOR-obfuscated content during investigation.",
  link: "http://hooked-on-mnemonics.blogspot.com/p/iheartxor.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1942,
  name: "XORBruteForcer.py",
  description: "Python script that attempts brute force XOR decoding to recover readable strings and hidden patterns.",
  link: "http://eternal-todo.com/var/scripts/xorbruteforcer",
  category: "Network",
  icon: "🌐"
},
{
  id: 1943,
  name: "NoMoreXOR.py",
  description: "Python-based XOR analysis tool for decoding XOR encryption in scripts, malware samples, or binaries.",
  link: "https://github.com/hiddenillusion/NoMoreXOR",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1944,
  name: "Balbuzard",
  description: "Reverse engineering tool to analyze and extract patterns/strings from suspicious files including XOR-encoded data.",
  link: "https://bitbucket.org/decalage/balbuzard",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1945,
  name: "CyberChef",
  description: "All-in-one decoding and data transformation tool by GCHQ for OSINT, malware analysis, and investigations.",
  link: "https://gchq.github.io/CyberChef/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1946,
  name: "Functions Online",
  description: "Online encoding/decoding utilities for hashes, conversions, and data transformations used in investigations.",
  link: "https://www.functions-online.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1947,
  name: "DataSploit",
  description: "OSINT automation framework that collects intelligence from multiple sources for reconnaissance workflows.",
  link: "https://github.com/datasploit/datasploit/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1948,
  name: "SpiderFoot",
  description: "Automated OSINT reconnaissance tool that maps domains, IPs, emails, breaches, and related assets.",
  link: "http://www.spiderfoot.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1949,
  name: "ThreatPipes",
  description: "Cyber threat intelligence automation tool that helps integrate OSINT, monitoring, and threat hunting pipelines.",
  link: "https://www.threatpipes.com",
  category: "Network",
  icon: "🌐"
},
{
  id: 1950,
  name: "Omnibus",
  description: "InQuest Omnibus OSINT tool used to extract intelligence from multiple data sources for threat research.",
  link: "https://github.com/InQuest/omnibus",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1951,
  name: "Photon",
  description: "Fast OSINT web crawler to extract URLs, emails, subdomains, files, and parameters from target websites.",
  link: "https://github.com/s0md3v/Photon",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1952,
  name: "ReconDog",
  description: "OSINT automation tool for gathering intelligence such as IP data, DNS records, phone/email lookups, and more.",
  link: "https://github.com/s0md3v/ReconDog",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1953,
  name: "IFTTT",
  description: "Automation platform useful for OSINT monitoring by creating alert-based workflows across services and apps.",
  link: "https://ifttt.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1954,
  name: "Stringify",
  description: "Automation workflow platform reference for connecting services and creating OSINT monitoring triggers.",
  link: "https://www.stringify.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1955,
  name: "Intrigue.io",
  description: "Attack surface discovery and OSINT platform for reconnaissance, asset mapping, and investigation workflows.",
  link: "https://intrigue.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1956,
  name: "OSRFramework",
  description: "OSINT framework to gather usernames, profiles, and account intelligence across online platforms.",
  link: "https://github.com/i3visio/osrframework",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1957,
  name: "Inquisitor",
  description: "OSINT automation toolkit used for reconnaissance and extraction of public information from multiple services.",
  link: "https://github.com/penafieljlm/inquisitor",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1958,
  name: "AutoOSINT",
  description: "Automated OSINT collection tool designed to speed up reconnaissance and intelligence gathering tasks.",
  link: "https://github.com/bharshbarger/AutOSINT",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1959,
  name: "IntRec-Pack",
  description: "OSINT intelligence reconnaissance pack containing scripts/tools for collection and investigation workflows.",
  link: "https://github.com/NullArray/IntRec-Pack",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1960,
  name: "OSINT-SPY",
  description: "OSINT automation toolset for reconnaissance tasks like data extraction, search automation, and target profiling.",
  link: "https://github.com/SharadKumar97/OSINT-SPY",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1961,
  name: "Microsoft Flow",
  description: "Microsoft Power Automate (Flow) automation platform useful for OSINT monitoring pipelines and alert workflows.",
  link: "https://flow.microsoft.com/en-us/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1962,
  name: "PhoneInfoga",
  description: "OSINT phone number investigation tool to gather carrier, region, formats, and public references.",
  link: "https://github.com/sundowndev/PhoneInfoga",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1963,
  name: "IntelligenceX",
  description: "Search engine for leaked data, documents, darknet references, and intelligence datasets (OSINT search platform).",
  link: "https://intelx.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1964,
  name: "Analyst Research Tools",
  description: "Collection of investigator tools and resources used for OSINT research and threat intelligence workflows.",
  link: "https://analystresearchtools.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1965,
  name: "Low Hanging Fruit",
  description: "Recon and pentesting OSINT helper tool used to find misconfigurations and exposed services quickly.",
  link: "https://github.com/blindfuzzy/LHF",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1966,
  name: "VMware Workstation Player",
  description: "Virtual machine platform used to run isolated OSINT environments and safe investigation machines.",
  link: "http://www.vmware.com/products/player/playerpro-evaluation.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1967,
  name: "VirtualBox",
  description: "Free virtualization software for running OSINT and security labs safely in isolated environments.",
  link: "https://www.virtualbox.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1968,
  name: "Buscador OS",
  description: "OSINT-focused Linux distribution built for investigators, containing privacy and intelligence gathering tools.",
  link: "https://inteltechniques.com/buscador/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1969,
  name: "Kali Linux OS",
  description: "Popular security-focused Linux OS containing penetration testing and investigation tools used in OSINT workflows.",
  link: "https://www.kali.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1970,
  name: "ParrotSec OS",
  description: "Security and privacy-focused Linux distribution useful for OSINT investigations and cybersecurity labs.",
  link: "https://www.parrotsec.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1971,
  name: "Microsoft Edge Development OS VMs",
  description: "Official Microsoft Windows virtual machines for testing Edge/IE — useful for web investigation and lab environments.",
  link: "https://developer.microsoft.com/en-us/microsoft-edge/tools/vms/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1972,
  name: "Subgraph OS",
  description: "Security-hardened operating system focused on privacy and isolation for sensitive research workflows.",
  link: "https://subgraph.com/index.en.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1973,
  name: "Tails Live OS",
  description: "Privacy-focused live OS that routes traffic through Tor — used for anonymous browsing and secure OSINT research.",
  link: "https://tails.boum.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1974,
  name: "Whonix",
  description: "Privacy-focused OS that runs inside virtual machines and routes traffic through Tor for safer investigations.",
  link: "https://www.whonix.org/wiki/Main_Page",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1975,
  name: "OWASP D4N155",
  description: "Security wordlist repository by OWASP useful for password testing, recon wordlists, and lab research.",
  link: "https://github.com/OWASP/D4N155",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1976,
  name: "W Generator",
  description: "Wordlist generator tool useful for reconnaissance wordlists, custom dictionaries, and OSINT automation.",
  link: "https://app.wgen.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1977,
  name: "Paterva / Maltego",
  description: "Graph-based OSINT investigation platform for link analysis, entity mapping, and relationship discovery.",
  link: "https://www.maltego.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1978,
  name: "Overview",
  description: "Document investigation tool for sorting, searching, and analyzing large sets of documents for OSINT research.",
  link: "https://www.overviewdocs.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1979,
  name: "Online Nikto scanner",
  description: "Web scanner platform for checking common security misconfigurations and web server findings (lawful research only).",
  link: "https://nikto.online/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1980,
  name: "ChatGPT (R)",
  description: "AI assistant useful for OSINT support tasks like summarization, research planning, data cleanup, and report drafting.",
  link: "https://chatgpt.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1981,
  name: "DuckDuckGo AI Chat",
  description: "AI chat assistant integrated with DuckDuckGo used for question answering and quick research support.",
  link: "https://duckduckgo.com/aichat",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1982,
  name: "WormGPT-6 (R)",
  description: "AI chat/community page reference — use caution and follow legal/ethical guidelines, as some variants may be linked to misuse.",
  link: "https://flowgpt.com/p/wormgpt-6",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1983,
  name: "InQuest Labs DFI/MalDoc Search",
  description: "Threat research platform to search malicious documents, file indicators, and analyze suspicious file intelligence.",
  link: "https://labs.inquest.net/dfi",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1984,
  name: "Decalage Malware Search",
  description: "Malware search portal by Decalage used for analyzing suspicious documents and extracting indicators.",
  link: "http://decalage.info/en/mwsearch",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1985,
  name: "VirusShare.com",
  description: "Malware sample sharing repository used for research and malware intelligence (restricted/controlled use).",
  link: "https://virusshare.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1986,
  name: "#totalhash",
  description: "Hash lookup and malware intelligence portal used for researching file hashes and indicators.",
  link: "https://totalhash.cymru.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1987,
  name: "VX Vault",
  description: "Malware sample listing and threat research resource used for tracking malicious URLs/files.",
  link: "http://vxvault.net/ViriList.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1988,
  name: "ID Ransomware",
  description: "Ransomware identification tool that helps detect ransomware family based on encrypted files and ransom notes.",
  link: "https://id-ransomware.malwarehunterteam.com/",
  category: "Email",
  icon: "✉️"
},
{
  id: 1989,
  name: "National Software Reference Library",
  description: "NSRL hash lookup resource used to identify known clean software files and reduce false positives in investigations.",
  link: "http://nsrl.hashsets.com/national_software_reference_library1_search.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1990,
  name: "InQuest DFI Maldoc Analyzer",
  description: "Malicious document analysis platform for extracting indicators, URLs, and suspicious macro behaviors.",
  link: "https://labs.inquest.net/dfi",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1991,
  name: "TYLabs QuickSand Framework",
  description: "Document scanning framework for analyzing PDF/Office files and detecting suspicious embedded content.",
  link: "https://scan.tylabs.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1992,
  name: "JoeSandbox Document Analyzer",
  description: "Automated document analysis sandbox to inspect malicious behavior in Office and other document formats.",
  link: "http://www.document-analyzer.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1993,
  name: "TYLabs QuickSand Framework",
  description: "PDF-focused scanning framework to detect suspicious scripts, embedded payloads, and malware patterns in PDFs.",
  link: "https://scan.tylabs.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1994,
  name: "Akana Android Malware",
  description: "Android malware analysis sandbox reference for investigating APK behavior and threat intelligence research.",
  link: "http://akana.mobiseclab.org/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1995,
  name: "Joe APK Analyzer",
  description: "Android APK sandbox analyzer that inspects app behavior, network calls, and malicious indicators.",
  link: "https://www.apk-analyzer.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1996,
  name: "VirusTotal",
  description: "Industry-standard malware scanning and threat intelligence platform for analyzing files, URLs, and hashes.",
  link: "https://www.virustotal.com/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1997,
  name: "OPSWAT Meta Defender",
  description: "Multi-engine file scanning platform for malware analysis and threat detection using multiple security engines.",
  link: "https://metadefender.opswat.com/#!/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 1998,
  name: "Hybrid Analysis",
  description: "Malware sandbox and analysis platform for running files and extracting threat intelligence indicators.",
  link: "https://www.hybrid-analysis.com/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 1999,
  name: "Malware Config",
  description: "Malware configuration extraction service useful for identifying C2 addresses and malware settings.",
  link: "https://malwareconfig.com/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2000,
  name: "Ether",
  description: "Web-based malware unpacking/research tool used for analyzing and extracting content from suspicious binaries.",
  link: "http://ether.gtisc.gatech.edu/web_unpack",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2001,
  name: "Jotti's Malware Scanner",
  description: "Online malware scanner that checks suspicious files using multiple antivirus engines for quick validation.",
  link: "https://virusscan.jotti.org/en-US/scan-file",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2002,
  name: "Blueliv Sandbox",
  description: "Sandbox analysis tool for executing suspicious files in controlled environments and extracting threat indicators.",
  link: "https://community.blueliv.com/#!/sandbox",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2003,
  name: "Valkyrie File Analysis",
  description: "Cloud sandbox by Comodo for analyzing suspicious file behavior and generating threat reports.",
  link: "https://consumer.valkyrie.comodo.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2004,
  name: "detux Linux Sandbox",
  description: "Linux sandbox platform used for malware analysis in Linux environments and behavior extraction.",
  link: "https://detux.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2005,
  name: "Joe File Analyzer",
  description: "File analysis sandbox for running suspicious files and extracting behavioral indicators and network activity.",
  link: "https://www.file-analyzer.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2006,
  name: "Pikker.ee Cuckoo Sandbox",
  description: "Hosted Cuckoo Sandbox instance for malware behavior analysis and automated threat reporting.",
  link: "http://sandbox.pikker.ee/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2007,
  name: "Koodous",
  description: "Android app intelligence platform used to analyze APKs, extract indicators, and research mobile threats.",
  link: "https://koodous.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2008,
  name: "Any Run",
  description: "Interactive malware sandbox used for running suspicious files and observing live behavior and indicators.",
  link: "https://app.any.run/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2009,
  name: "Uncover It",
  description: "Threat research platform reference for investigating suspicious files and extracting indicators.",
  link: "https://www.uncoverit.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2010,
  name: "Office Mal Scanner",
  description: "Tool used for scanning Office documents for malicious code, embedded objects, and suspicious patterns.",
  link: "http://www.reconstructer.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2011,
  name: "OffVis",
  description: "Microsoft Office file visualization tool useful for inspecting Office document structure and embedded objects.",
  link: "http://go.microsoft.com/fwlink/?LinkID=158791",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2012,
  name: "PDF Tools",
  description: "Collection of PDF analysis tools by Didier Stevens for investigating suspicious PDFs and extracting artifacts.",
  link: "http://blog.didierstevens.com/programs/pdf-tools/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2013,
  name: "Origami Framework",
  description: "PDF security analysis framework used for investigating PDF structure and suspicious components (archived reference).",
  link: "https://code.google.com/archive/p/origami-pdf/",
  category: "Archives",
  icon: "📚"
},
{
  id: 2014,
  name: "Malware-Traffic-Analysis.net",
  description: "Malware traffic repository providing PCAPs and real-world examples for network threat analysis and training.",
  link: "http://www.malware-traffic-analysis.net/index.html",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2015,
  name: "Ghidra",
  description: "NSA open-source reverse engineering suite used for malware analysis, binary investigation, and decompiling code.",
  link: "https://github.com/NationalSecurityAgency/ghidra",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2016,
  name: "Malware Analysis Tools",
  description: "Curated directory of malware analysis tools useful for incident response, reverse engineering, and OSINT workflows.",
  link: "http://malwareanalysis.tools/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2017,
  name: "virustotal",
  description: "Direct VirusTotal upload portal used to scan suspicious files for malware detection and threat intelligence.",
  link: "https://www.virustotal.com/gui/home/upload",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2018,
  name: "Default Passwords DB",
  description: "Database of default vendor/device passwords useful for security audits and OSINT-based device research.",
  link: "https://cirt.net/passwords",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2019,
  name: "Default passwords list",
  description: "Default-password directory useful for identifying factory credentials and improving defensive security checks.",
  link: "https://default-password.info/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2020,
  name: "Default Password Lookup Utility",
  description: "Default password lookup site for routers/devices — useful for research and security awareness.",
  link: "http://www.fortypoundhead.com/tools_dpw.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2021,
  name: "Phenoelit Default Password List",
  description: "Phenoelit default password list used for identifying default credentials and security auditing research.",
  link: "http://phenoelit.org/dpl/dpl.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2022,
  name: "Default Router Passwords",
  description: "Router password lookup site for researching vendor default credentials (defensive and audit use).",
  link: "http://routerpasswords.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2023,
  name: "Open Sez Me Default Passwords",
  description: "Default passwords repository reference useful for auditing device security and awareness research.",
  link: "http://open-sez.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2024,
  name: "Hashes.org",
  description: "Password hash cracking/lookup community platform useful for security research and hash intelligence.",
  link: "https://hashes.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2025,
  name: "Vulert: Updated Open Source Vulnerability Database",
  description: "Open-source vulnerability monitoring database that tracks package vulnerabilities and security advisories.",
  link: "https://vulert.com/vuln-db",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2026,
  name: "MITRE ATT&CK",
  description: "Globally recognized knowledge base of adversary tactics and techniques used for threat intel and incident mapping.",
  link: "https://attack.mitre.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2027,
  name: "Exploit DB",
  description: "Public archive of exploits and vulnerability PoCs used for security research, learning, and threat analysis.",
  link: "https://www.exploit-db.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2028,
  name: "Packet Storm",
  description: "Security research portal hosting exploits, advisories, tools, and vulnerability information.",
  link: "https://packetstormsecurity.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2029,
  name: "SecurityFocus",
  description: "Vulnerability and advisory database used for researching security issues and historical exploits.",
  link: "http://www.securityfocus.com/bid",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2030,
  name: "NVD - NIST",
  description: "Official NIST National Vulnerability Database listing CVEs, CVSS scores, and detailed vulnerability metadata.",
  link: "https://nvd.nist.gov/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2031,
  name: "OSV Vulnerability Library",
  description: "Open Source Vulnerability database for tracking package vulnerabilities across ecosystems (Google OSV).",
  link: "https://osv.dev/list",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2032,
  name: "Mend Vulnerability Database",
  description: "Vulnerability intelligence database for open-source components, CVEs, and security insights.",
  link: "https://www.mend.io/vulnerability-database/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2033,
  name: "CVE Details",
  description: "CVE lookup portal offering vulnerability data, CVSS scores, affected product info, and search features.",
  link: "http://www.cvedetails.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2034,
  name: "CVE - MITRE",
  description: "Official CVE program portal by MITRE containing vulnerability identifiers and references.",
  link: "http://cve.mitre.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2035,
  name: "OWASP",
  description: "Open Web Application Security Project — security research community known for OWASP Top 10 and best practices.",
  link: "https://www.owasp.org/index.php/Main_Page",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2036,
  name: "0day.today",
  description: "Exploit marketplace reference — use caution and ensure legal/ethical compliance when researching vulnerabilities.",
  link: "http://0day.today/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2037,
  name: "Secunia",
  description: "Security vulnerability research portal by Flexera/Secunia providing advisories and vulnerability intelligence.",
  link: "https://secuniaresearch.flexerasoftware.com/community/research/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2038,
  name: "Australian Cyber Security Centre",
  description: "Official Australian cybersecurity agency website providing alerts, advisories, and best practice guidance.",
  link: "https://www.cyber.gov.au/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2039,
  name: "Canadian Centre for Cyber Security",
  description: "Government of Canada cybersecurity advisory portal providing alerts, threat reports, and defensive guidance.",
  link: "https://cyber.gc.ca/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2040,
  name: "SecAI.ai",
  description: "Security research portal focused on phishing intelligence and threat analysis reports.",
  link: "https://secai.ai/research",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2041,
  name: "https://openphish.com/feed.txt",
  description: "OpenPhish phishing feed providing phishing URLs for threat intelligence monitoring and IOC tracking.",
  link: "https://openphish.com/feed.txt",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2042,
  name: "PhishTank",
  description: "Community-based phishing verification platform used for tracking and validating phishing websites.",
  link: "https://www.phishtank.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2043,
  name: "PhishStats",
  description: "Phishing intelligence tracker and dashboard showing phishing URLs, domains, and statistics.",
  link: "https://phishstats.info/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2044,
  name: "Jager",
  description: "IOC hunting tool used to search and validate indicators like domains, hashes, and suspicious patterns.",
  link: "https://github.com/sroberts/jager",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2045,
  name: "IOC Parser",
  description: "IOC extraction tool that parses indicators (domains, IPs, hashes) from text for OSINT and threat research.",
  link: "https://github.com/armbues/ioc_parser",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2046,
  name: "Cacador",
  description: "IOC discovery and hunting tool used for extracting indicators from sources and threat intelligence feeds.",
  link: "https://github.com/sroberts/cacador",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2047,
  name: "ThreatPinch Lookup",
  description: "IOC lookup utility used to search and validate indicators across sources for threat intelligence workflows.",
  link: "https://github.com/cloudtracer/ThreatPinchLookup",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2048,
  name: "Mimir",
  description: "Threat intelligence IOC lookup tool used for analyzing and managing indicators in OSINT pipelines.",
  link: "https://github.com/NullArray/Mimir",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2049,
  name: "iocextract",
  description: "Python IOC extraction library used to pull IPs, domains, URLs, and hashes from text automatically.",
  link: "https://github.com/InQuest/python-iocextract",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2050,
  name: "ThreatIngestor",
  description: "Threat intelligence ingestion tool used to collect and normalize IOCs from feeds into structured formats.",
  link: "https://github.com/InQuest/ThreatIngestor",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2051,
  name: "Malware Exploit TTP Database",
  description: "Database of malware exploitation behavior and TTPs used for mapping attacker techniques in investigations.",
  link: "https://www.pwnmalw.re/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2052,
  name: "Mitre TTPs",
  description: "MITRE ATT&CK technique listing used for mapping threats, adversary behavior, and attack patterns.",
  link: "https://attack.mitre.org/wiki/All_Techniques",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2053,
  name: "IBM X-Force Exchange",
  description: "Threat intelligence exchange platform for investigating IPs, domains, URLs, hashes, and threat reports.",
  link: "https://exchange.xforce.ibmcloud.com/new",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2054,
  name: "Malware Information Sharing Platform",
  description: "MISP platform for sharing structured threat intelligence and IOCs across security teams and researchers.",
  link: "http://www.misp-project.org/",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2055,
  name: "Malware Patrol",
  description: "Threat intelligence provider offering malware and phishing feeds for monitoring and defense research.",
  link: "https://www.malwarepatrol.net/open-source.shtml",
  category: "Malware",
  icon: "🦠"
},
{
  id: 2056,
  name: "AlienVault OTX",
  description: "Open Threat Exchange platform for community threat intelligence, IOCs, pulses, and threat context.",
  link: "https://otx.alienvault.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2057,
  name: "FireHOL IP Lists",
  description: "Curated IP reputation blocklists useful for threat intelligence, SOC monitoring, and defensive OSINT research.",
  link: "http://iplists.firehol.org/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2058,
  name: "Maltiverse",
  description: "Threat intelligence lookup platform for domains, IPs, URLs, and hashes with reputation scoring.",
  link: "https://maltiverse.com/start",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2059,
  name: "Malpedia",
  description: "Malware encyclopedia by Fraunhofer FKIE providing malware families, aliases, and technical references.",
  link: "https://malpedia.caad.fkie.fraunhofer.de/library",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2060,
  name: "Project Honey Pot",
  description: "Threat intelligence project tracking spammers and malicious actors via honeypots and IP reputation systems.",
  link: "http://www.projecthoneypot.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2061,
  name: "Cymon Open Threat Intelligence",
  description: "Threat intelligence platform reference for investigating IOCs, indicators, and malicious infrastructure.",
  link: "https://cymon.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2062,
  name: "mlsecproject / combine",
  description: "Threat intelligence aggregation tool used to combine multiple sources of security indicators and normalize outputs.",
  link: "https://github.com/mlsecproject/combine",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2063,
  name: "hostintel - keithjjones Github",
  description: "OSINT/threat intel toolkit repository for gathering host intelligence and infrastructure-related indicators.",
  link: "https://github.com/keithjjones/hostintel",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2064,
  name: "massive-octo-spice - csirtgadgets Github",
  description: "Threat intelligence automation repository that supports cyber defense and CSIRT investigation workflows.",
  link: "https://github.com/csirtgadgets/massive-octo-spice",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2065,
  name: "Scam Database",
  description: "Scam reporting and lookup platform useful for checking suspicious websites, scams, and fraud indicators.",
  link: "https://www.scamdb.net",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2066,
  name: "Bot Scout",
  description: "Bot/spam detection service useful for identifying suspicious accounts and spam-related indicators.",
  link: "http://botscout.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2067,
  name: "Blueliv Threat Exchange (R)",
  description: "Threat intelligence exchange platform for discovering IOCs and threat reports (registration may be required).",
  link: "https://community.blueliv.com/#!/discover",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2068,
  name: "APTnotes",
  description: "Collection of APT threat reports and analysis documents used for threat intelligence and OSINT research.",
  link: "https://github.com/aptnotes/data",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2069,
  name: "HoneyDB",
  description: "Threat intelligence project collecting and tracking malicious scanning activity across the internet.",
  link: "https://riskdiscovery.com/honeydb/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2070,
  name: "Pulsedive",
  description: "Threat intelligence search engine for IOCs with reputation scoring, context, and related metadata.",
  link: "https://pulsedive.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2071,
  name: "Mr.Looquer IOC Feed - 1st Dual Stack Threat Feed",
  description: "Threat feed providing IOCs for IPv4/IPv6 and malicious infrastructure monitoring in OSINT pipelines.",
  link: "https://iocfeed.mrlooquer.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2072,
  name: "REScure Cyber Threat Intelligence Project",
  description: "Cyber threat intelligence feed and resource portal for collecting threat indicators and defensive monitoring.",
  link: "https://rescure.me/feeds.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2073,
  name: "Fake Name Generator",
  description: "Fake persona generator that creates realistic identity details for privacy-safe testing and OSINT training scenarios.",
  link: "http://www.fakenamegenerator.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2074,
  name: "Fake Identity Generator",
  description: "Identity generation utility for creating test personas used in privacy research and OSINT training labs.",
  link: "http://justdelete.me/fake-identity-generator/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2075,
  name: "Random User Generator",
  description: "Generates random user profiles via API — helpful for creating dummy personas for testing and research.",
  link: "https://randomuser.me/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2076,
  name: "Pexels",
  description: "Free stock photos platform useful for safe persona creation and non-copyrighted image sourcing.",
  link: "https://www.pexels.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2077,
  name: "Faker.js",
  description: "JavaScript library to generate fake data (names, addresses, emails) useful for testing and secure OSINT practice datasets.",
  link: "https://cdn.rawgit.com/Marak/faker.js/master/examples/browser/index.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2078,
  name: "Tor Download",
  description: "Official Tor Browser download page used for privacy-safe browsing and anonymous OSINT research.",
  link: "https://www.torproject.org/download/download-easy.html.en",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2079,
  name: "Freenet Project",
  description: "Decentralized privacy network project useful for privacy research and censorship-resistant communication study.",
  link: "https://freenetproject.org/pages/download.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2080,
  name: "I2P Anonymous Network",
  description: "Anonymous network layer used for private browsing and research into privacy-focused communication systems.",
  link: "https://geti2p.net/en/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2081,
  name: "VPN Comparisons - That One Privacy Site",
  description: "VPN comparison resource reviewing privacy/security features and anonymization details of VPN services.",
  link: "https://thatoneprivacysite.net/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2082,
  name: "UserAgentString.com",
  description: "User-agent database useful for identifying browser/device strings and testing spoofed user-agent values.",
  link: "http://www.useragentstring.com/pages/useragentstring.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2083,
  name: "WhatIsMyBrowser.com",
  description: "Browser identification and fingerprint information site useful for OSINT and browser analysis testing.",
  link: "https://www.whatismybrowser.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2084,
  name: "User Agent String Decoder",
  description: "Tool to decode and interpret browser user-agent strings for OSINT and fingerprint understanding.",
  link: "http://tools.tracemyip.org/user-agent-string-decoder/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2085,
  name: "IP / DNS Leak Detection",
  description: "Privacy tool to check IP leaks and DNS leaks — useful for validating VPN/Tor anonymity during OSINT work.",
  link: "https://ipleak.net/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 2086,
  name: "JonDonym",
  description: "IP check tool used for detecting anonymity leaks and verifying connection privacy during investigations.",
  link: "http://ip-check.info/?lang=en",
  category: "Network",
  icon: "🌐"
},
{
  id: 2087,
  name: "DNS leak test",
  description: "DNS leak test platform used to verify VPN privacy and detect unwanted DNS exposure.",
  link: "https://www.dnsleaktest.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 2088,
  name: "DNS Leak Tests",
  description: "DNS leak detection tool to verify privacy and ensure DNS queries are not exposed during VPN usage.",
  link: "http://dnsleak.com/",
  category: "Domain",
  icon: "🌍"
},
{
  id: 2089,
  name: "TorGuard",
  description: "TorGuard leak test utility used to check DNS/IP leaks when using VPN services.",
  link: "https://torguard.net/vpn-dns-leak-test.php",
  category: "Domain",
  icon: "🌍"
},
{
  id: 2090,
  name: "IPv6 Leak Tests",
  description: "Test platform to detect IPv6 leaks that may expose real identity during VPN/Tor usage.",
  link: "http://ipv6leak.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2091,
  name: "Email Leak Tests",
  description: "Leak testing tool that detects exposed email/IP paths and privacy issues during browsing.",
  link: "http://emailipleak.com/",
  category: "Email",
  icon: "✉️"
},
{
  id: 2092,
  name: "Perfect Privacy",
  description: "IP check tool by Perfect Privacy used to verify anonymity and detect leaks during privacy browsing.",
  link: "https://www.perfect-privacy.com/check-ip/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2093,
  name: "WebRTC Leak Test",
  description: "Tool to detect WebRTC leaks that may reveal real IP address even while using VPN/Tor.",
  link: "https://www.perfect-privacy.com/webrtc-leaktest/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2094,
  name: "LetMeCheck.it",
  description: "Network diagnostic and privacy check tool used to verify IP/connection exposure during OSINT work.",
  link: "http://letmecheck.it/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2095,
  name: "Trace My IP",
  description: "IP lookup and network trace platform used for checking IP visibility, location, and network exposure.",
  link: "http://www.tracemyip.org/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2096,
  name: "Browser Statistics",
  description: "Browser statistics page useful for understanding browser market share and user behavior trends.",
  link: "https://www.w3schools.com/browsers/default.asp",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2097,
  name: "WhatsMyBrowser.org",
  description: "Browser info tool used to detect browser version, OS, and fingerprint-related details.",
  link: "http://www.whatsmybrowser.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2098,
  name: "What browser am I using.co",
  description: "Quick browser detection tool that reveals user browser/OS information for debugging and fingerprint checks.",
  link: "http://www.whatbrowseramiusing.co/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2099,
  name: "What Browser?",
  description: "Browser identification and details tool useful for understanding user-agent and platform information.",
  link: "https://whatbrowser.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2100,
  name: "BrowserSpy.dk Browser Information",
  description: "Browser fingerprint information tool showing visible details like headers, plugins, OS, and device attributes.",
  link: "http://browserspy.dk/browser.php",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2101,
  name: "Browserscope",
  description: "Browser testing platform used to analyze browser capabilities, performance, and compatibility for fingerprinting research.",
  link: "http://www.browserscope.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2102,
  name: "Proxychecker",
  description: "Proxy verification tool used to check if an IP is a proxy/VPN and detect anonymous browsing indicators.",
  link: "https://proxycheck.haschek.at/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2103,
  name: "IP2Proxy",
  description: "IP intelligence service used to detect VPN, proxy, TOR exit nodes, and anonymous IP addresses.",
  link: "https://www.ip2proxy.com/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2104,
  name: "NoScript",
  description: "Browser security extension that blocks scripts and active content to enhance privacy and safe OSINT browsing.",
  link: "https://noscript.net/",
  category: "Network",
  icon: "🌐"
},
{
  id: 2105,
  name: "Firefox-debloat",
  description: "Firefox privacy-hardening script/tool to remove unwanted features and reduce tracking surface for investigations.",
  link: "https://github.com/amq/firefox-debloat",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2106,
  name: "Browser Leaks",
  description: "Privacy testing site that checks for browser fingerprint leaks such as WebRTC, headers, location, and tracking info.",
  link: "https://browserleaks.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2107,
  name: "Self-Destructing Cookies",
  description: "Firefox extension that automatically deletes cookies and site data after leaving websites to reduce tracking.",
  link: "https://addons.mozilla.org/en-US/firefox/addon/self-destructing-cookies/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2108,
  name: "BrowserSpy.dk",
  description: "Browser fingerprinting information platform showing detectable details like headers, plugins, and configuration data.",
  link: "http://browserspy.dk/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2109,
  name: "LocaBrowser.com",
  description: "Anonymous browsing tool reference aimed at privacy-friendly browsing and reducing tracking exposure.",
  link: "http://www.locabrowser.com",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2110,
  name: "Privacy Guides",
  description: "Trusted privacy resource offering recommendations on secure browsers, OSINT safety, encryption, and anonymization tools.",
  link: "https://www.privacyguides.org/en/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2111,
  name: "Just Delete Me",
  description: "Directory that shows how to delete accounts on popular websites to improve privacy and reduce digital footprint.",
  link: "http://backgroundchecks.org/justdeleteme/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2112,
  name: "The Internet Privacy Handbook",
  description: "Practical guide for protecting online privacy including threat models, cleanup actions, and anonymity best practices.",
  link: "https://www.safeshepherd.com/handbook",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2113,
  name: "OptOut Credit Prescreen",
  description: "Official opt-out portal for U.S. credit prescreen offers — useful for reducing identity/marketing exposure.",
  link: "https://www.optoutprescreen.com/?rf=t",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2114,
  name: "Credit Freeze",
  description: "IntelTechniques guide explaining how to freeze credit reports to prevent identity fraud and unauthorized access.",
  link: "https://inteltechniques.com/blog/2018/09/28/complete-credit-freeze-tutorial-update/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2115,
  name: "Fake US Identities",
  description: "Identity generator reference used for creating test personas (use responsibly and only for legal training/testing).",
  link: "http://xdd2.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2116,
  name: "Social Media Fingerprint",
  description: "Tool that tests social media-based fingerprinting techniques to show possible identity leakage through browser behavior.",
  link: "https://robinlinus.github.io/socialmedia-leak/",
  category: "Social Media",
  icon: "📱"
},
{
  id: 2117,
  name: "Privacy Tools",
  description: "Privacy-focused recommendations website for secure tools like browsers, email, VPNs, and OSINT safety guides.",
  link: "https://www.privacytools.io/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2118,
  name: "Panopticlick",
  description: "EFF browser fingerprint testing tool that shows how unique your browser looks and how trackable you are online.",
  link: "https://panopticlick.eff.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2119,
  name: "Intel Techniques - Hiding from the Internet",
  description: "OSINT privacy workbook PDF that teaches methods to reduce digital footprint and improve online anonymity.",
  link: "https://inteltechniques.com/data/workbook.pdf",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2120,
  name: "The Many Hats Club - Privacy Resources",
  description: "Collection of privacy resources and best practices for improving OpSec and reducing online exposure.",
  link: "https://themanyhats.club/centralised-place-for-privacy-resources/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2121,
  name: "The Hitchhiker’s Guide to Online Anonymity",
  description: "Step-by-step guide on online anonymity, threat modeling, and privacy-first workflows for safe research.",
  link: "https://anonymousplanet.org/guide/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2122,
  name: "Anonymouth - Document Anonymization",
  description: "Tool for anonymizing writing style in documents to reduce authorship attribution (stylometry defense).",
  link: "https://github.com/psal/anonymouth",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2123,
  name: "Hunchly",
  description: "Evidence capture tool for OSINT investigations that logs browsing activity and preserves web pages as proof.",
  link: "http://www.hunch.ly/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2124,
  name: "Forensic OSINT",
  description: "Forensic OSINT platform offering guides, resources, and evidence capture techniques for investigators.",
  link: "https://www.forensicosint.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2125,
  name: "Fiddler",
  description: "Web debugging proxy tool used for capturing and analyzing HTTP/HTTPS traffic during investigations and testing.",
  link: "https://www.telerik.com/download/fiddler",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2126,
  name: "Burp Suite",
  description: "Web security testing suite that can capture, inspect, and modify web traffic for security research and analysis.",
  link: "https://portswigger.net/burp/download.html",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2127,
  name: "Page2Images",
  description: "Website screenshot generator that captures full webpage images for evidence capture and OSINT reporting.",
  link: "http://www.page2images.com/URL-Live-Website-Screenshot-Generator",
  category: "Images",
  icon: "🖼️"
},
{
  id: 2128,
  name: "Archive.is",
  description: "Web archiving service used to preserve snapshots of pages for OSINT evidence and historical reference.",
  link: "http://archive.is/",
  category: "Archives",
  icon: "📚"
},
{
  id: 2129,
  name: "Web Page Saver",
  description: "Free Magnet Forensics tool that captures and saves web pages for forensic documentation and evidence preservation.",
  link: "https://www.magnetforensics.com/free-tool-web-page-saver/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2130,
  name: "Snapper",
  description: "Web investigation evidence tool used to take structured snapshots/screenshots of webpages for reporting.",
  link: "https://github.com/dxa4481/Snapper",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2131,
  name: "Full Page Screen Capture Chrome Extension",
  description: "Chrome extension that captures full-page screenshots for OSINT evidence preservation and documentation.",
  link: "https://github.com/mrcoles/full-page-screen-capture-chrome-extension",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2132,
  name: "EZR OSINT Sidebar",
  description: "Chrome extension OSINT sidebar providing quick investigator tools, links, and workflows inside the browser.",
  link: "https://chromewebstore.google.com/detail/ezr-osint-sidebar/joagbbgciboooipadijeaoidjjigdmof",
  category: "Network",
  icon: "🌐"
},
{
  id: 2133,
  name: "FRAPS",
  description: "Screen recording and capture software used for documenting actions and evidence during investigations.",
  link: "http://www.fraps.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2134,
  name: "ShareX",
  description: "Powerful open-source screen capture and recording tool for documentation, evidence capture, and reporting.",
  link: "https://getsharex.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2135,
  name: "Greenshot",
  description: "Lightweight screenshot tool useful for capturing evidence, marking screenshots, and quick documentation.",
  link: "https://getgreenshot.org/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2136,
  name: "BatchGeo",
  description: "Bulk address mapping tool that converts address lists into interactive maps for OSINT location analysis.",
  link: "https://batchgeo.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 2137,
  name: "Google Street View - Hyperlapse",
  description: "Open-source project to generate hyperlapse-style Street View journeys for location-based OSINT storytelling.",
  link: "https://github.com/TeehanLax/Hyperlapse.js",
  category: "Google",
  icon: "🔍"
},
{
  id: 2138,
  name: "Teehan+Lax Labs - Hyperlapse",
  description: "Hyperlapse demo project for visualizing Street View journeys — useful for OSINT storytelling and mapping.",
  link: "http://labs.teehanlax.com/project/hyperlapse",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2139,
  name: "ZeeMaps",
  description: "Custom mapping tool used to create interactive maps with markers — useful for OSINT location analysis projects.",
  link: "https://www.zeemaps.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 2140,
  name: "Timeline JS3",
  description: "Knight Lab timeline tool to create interactive timelines for OSINT case documentation and story-based reporting.",
  link: "http://timeline.knightlab.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2141,
  name: "GeoGuesser",
  description: "Geo-location guessing game based on Street View — useful for OSINT training and improving geo-investigation skills.",
  link: "https://geoguessr.com/",
  category: "Geo",
  icon: "📍"
},
{
  id: 2142,
  name: "Verif!cation Quiz Bot",
  description: "Social media verification quiz bot that improves OSINT verification skills through challenges and exercises.",
  link: "https://twitter.com/quiztime",
  category: "Social Media",
  icon: "📱"
},
{
  id: 2143,
  name: "Forensic OSINT KB Guides",
  description: "Knowledge base guides and OSINT training resources focused on investigations, evidence capture, and reporting.",
  link: "https://www.forensicosint.com/osint-guide",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2144,
  name: "Open Source Intelligence Techniques",
  description: "IntelTechniques OSINT training website providing courses, tools, and investigation methods for analysts.",
  link: "https://inteltechniques.com/",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2145,
  name: "Plessas",
  description: "OSINT training platform offering online learning programs for intelligence gathering and investigation techniques.",
  link: "https://plessas.net/online-training",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2146,
  name: "SANS SEC487 OSINT Class",
  description: "SANS OSINT training course focused on open-source intelligence gathering, investigations, and digital research skills.",
  link: "https://www.sans.org/sec487",
  category: "OSINT Tools",
  icon: "🧰"
},
{
  id: 2147,
  name: "Smart Questions",
  description: "Guide explaining how to ask clear, effective questions — useful for investigations, research, and technical OSINT queries.",
  link: "http://www.catb.org/esr/faqs/smart-questions.html",
  category: "OSINT Tools",
  icon: "🧰"
}
];